(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-nouvac-order-flow-v2]';
  const CONTEXT_SELECTOR = '[data-nouvac-order-flow-v2-product-context]';
  const CONTEXT_JSON_SELECTOR = '[data-nouvac-order-flow-v2-product-json]';
  const CONTEXT_OFFERS_SELECTOR = '[data-nouvac-order-flow-v2-offers-template]';
  const CONTEXT_DETAILS_SELECTOR = '[data-nouvac-order-flow-v2-details-template]';
  const CONTEXT_SECTION_ID = 'nouvac-order-flow-v2-product-context';
  const FLOW_ADDRESS_CHECKOUT = 'address-checkout';
  const FLOW_FORMULA_CHECKOUT = 'formula-checkout';
  const FLOW_FORMULA_ADDRESS_CHECKOUT = 'formula-address-checkout';
  const FLOW_ADDRESS_FORMULA_CHECKOUT = 'address-formula-checkout';
  const FLOW_FORMULA_ADDRESS_CALENDAR = 'formula-address-calendar-checkout';
  const FLOW_ADDRESS_FORMULA_DPE_NUMBER = 'address-formula-dpe-number-checkout';
  const FLOW_ADDRESS_FORMULA_CALENDAR = 'address-formula-calendar-checkout';
  const FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR = 'address-variant-questions-calendar-checkout';
  const ADDRESS_PRESENTATION_NONE = 'none';
  const ADDRESS_PRESENTATION_PROJECT = 'project';
  const ADDRESS_PRESENTATION_PROPERTY_CONTEXT = 'property-context';
  const ADDRESS_PRESENTATION_CANONICAL = 'canonical';
  const SELECTION_PRESENTATION_NONE = 'none';
  const SELECTION_PRESENTATION_FORMULA_CARDS = 'formula-cards';
  const SELECTION_PRESENTATION_VARIANT_QUESTIONS = 'variant-questions';
  const FORMULA_PRESENTATION_DEFAULT = 'default';
  const FORMULA_PRESENTATION_CURATED_GRID = 'curated-grid';
  const FORMULA_PROGRESSION_NONE = 'none';
  const FORMULA_PROGRESSION_STAY = 'stay';
  const FORMULA_PROGRESSION_EXPLICIT = 'explicit';
  const CALENDAR_PRESENTATION_NONE = 'none';
  const CALENDAR_PRESENTATION_STANDARD = 'standard';
  const CALENDAR_PRESENTATION_CANONICAL = 'canonical';
  const BOOKING_LIFECYCLE_NONE = 'none';
  const BOOKING_LIFECYCLE_CONTEXT_BOUND = 'context-bound';
  const SUMMARY_PRESENTATION_NONE = 'none';
  const SUMMARY_PRESENTATION_INLINE = 'inline';
  const SUMMARY_PRESENTATION_FINAL_FORMULA = 'final-formula';
  const SUMMARY_PRESENTATION_DECISION = 'decision';
  const SUMMARY_PRESENTATION_CALENDAR = 'calendar';
  const INITIAL_VARIANT_REQUESTED_OR_FIRST = 'requested-or-first';
  const INITIAL_VARIANT_AUTHORIZED_DIRECT = 'authorized-direct';
  const INITIAL_VARIANT_REQUESTED_ONLY = 'requested-only';
  const INITIAL_VARIANT_UNIQUE_AVAILABLE = 'unique-available';
  const DIRECT_FORMULA_ENTRY_NONE = 'none';
  const DIRECT_FORMULA_ENTRY_SUMMARY = 'summary';
  const FINAL_ACTION_CART = 'cart';
  const FINAL_ACTION_BOOKING_HOLD_CART = 'booking-hold-cart';
  const VARIANT_UI_NONE = 'none';
  const VARIANT_UI_FORMULA_CARDS = 'formula-cards';
  const VARIANT_UI_VARIANT_OPTIONS = 'variant-options';
  const RE2020_SERVICE_SLUG = 'etude-thermique-re2020';
  const PERMIS_CONSTRUIRE_SERVICE_SLUG = 'permis-construire-en-ligne';
  const PERMIS_CONSTRUIRE_PRODUCT_HANDLE = 'permis-de-construire';
  const DECLARATION_PREALABLE_SERVICE_SLUG = 'declaration-prealable';
  const DECLARATION_PREALABLE_PRODUCT_HANDLE = 'declaration-prealable';
  const PERMIS_CONSTRUIRE_COMPATIBILITY_VARIANTS = {
    essentiel: '56751367815493',
    confort: '56751367848261',
    premium: '56751367881029'
  };
  const BILAN_SERVICE_SLUG = 'bilan-thermique-renovation';
  const DRONE_PRODUCT_HANDLE = 'photos-videos-drone';
  const ANIMATION_3D_SERVICE_SLUG = 'animation-video-3d';
  const RENDU_3D_SERVICE_SLUG = 'rendu-3d-photorealiste';
  const DPE_PROJETE_SERVICE_SLUG = 'dpe-projete';
  const DPE_PROJETE_PRODUCT_HANDLE = 'dpe-projete';
  const PACK_DIAGNOSTICS_SERVICE_SLUG = 'diagnostic-pack';
  const PACK_DIAGNOSTICS_PRODUCT_HANDLE = 'pack-diagnostics-immobiliers';
  const DIAGNOSTIC_PREQUALIFIED_API = window.NouvacDiagnosticPrequalifiedV21 || null;
  const ERP_PRODUCT_HANDLE = 'etat-risques-pollutions-erp';
  const ADDRESS_CHECKOUT_PRODUCT_IDENTITIES = new Set([ERP_PRODUCT_HANDLE]);
  const METAFIELD_DRIVEN_PRODUCT_IDENTITIES = Object.freeze({
    'audit-energetique': 'audit-energetique',
    'dpe-neuf': 'dpe-neuf'
  });
  const ADDRESS_FORMULA_CALENDAR_PRODUCT_IDENTITIES = Object.freeze({
    [BILAN_SERVICE_SLUG]: Object.freeze({
      serviceSlug: BILAN_SERVICE_SLUG,
      rendererKey: BILAN_SERVICE_SLUG,
      variantResolver: 'bilan',
      noAvailableMessage: 'Aucune formule Bilan disponible n’a été trouvée.'
    }),
    [DRONE_PRODUCT_HANDLE]: Object.freeze({
      serviceSlug: '',
      rendererKey: DRONE_PRODUCT_HANDLE,
      variantResolver: 'drone',
      addressHelperText: 'Votre adresse nous permet de vérifier si nos équipes interviennent dans votre zone.',
      noAvailableMessage: 'Aucune formule Photos et vidéos drone disponible n’a été trouvée.'
    })
  });
  const OBSOLETE_ADDRESS_RETENTION_KEY_PREFIX = 'nouvac_address_v2';
  const LEGACY_PACK_ADDRESS_STORAGE_KEYS = Object.freeze([
    `nouvac:v2:address:${PACK_DIAGNOSTICS_PRODUCT_HANDLE}:${PACK_DIAGNOSTICS_SERVICE_SLUG}`
  ]);
  const DPE_NUMBER_DEFERRED_LABEL = 'À renseigner plus tard';
  const PACK_ESTIMATED_DURATION_LABEL = 'entre 2 h et 4 h selon le logement';
  const PACK_ESTIMATED_DURATION_MIN_MINUTES = 120;
  const PACK_ESTIMATED_DURATION_MAX_MINUTES = 240;
  const PACK_CONSTRUCTION_YEAR_OPTION_TITLE = 'Choisissez l’année de construction de votre logement';
  const PACK_DIAGNOSTICS_INCLUDED_LABEL = 'Diagnostic inclus';
  const DIAGNOSTIC_PREQUALIFIED_SERVICE_LABEL = 'Pack Diagnostics Immobiliers';
  const PACK_DIAGNOSTICS_INCLUDED_BY_CONSTRUCTION_YEAR = Object.freeze({
    'apres 2011': Object.freeze(['DPE', 'ERP', 'Mesurage']),
    'entre 1997 et 2011': Object.freeze(['DPE', 'ERP', 'Mesurage', 'Électricité', 'Gaz']),
    'entre 1949 et 1997': Object.freeze(['DPE', 'ERP', 'Mesurage', 'Électricité', 'Gaz', 'Amiante']),
    'avant 1949': Object.freeze(['DPE', 'ERP', 'Mesurage', 'Électricité', 'Gaz', 'Amiante', 'Plomb'])
  });
  const BOOKING_HANDSHAKE_TIMEOUT_MS = 15000;
  const CONTEXT_BOUND_BOOKING_HOLD_TIMEOUT_MS = 15000;
  const ADDRESS_GEOCODING_ENDPOINT = 'https://data.geopf.fr/geocodage/search/';
  const ADDRESS_MIN_QUERY_LENGTH = 3;
  const ADDRESS_DEBOUNCE_DELAY = 350;
  const ADDRESS_LIMIT = 8;
  const ADDRESS_CACHE_LIMIT = 50;
  const ADDRESS_STATUS_LOADING = 'Recherche de l’adresse...';
  const ADDRESS_STATUS_EMPTY = 'Aucune adresse trouvée. Vous pouvez saisir l’adresse complète avec le code postal.';
  const ADDRESS_STATUS_ERROR = 'Impossible de rechercher cette adresse pour le moment. Veuillez réessayer.';
  const ADDRESS_STATUS_SELECTED = 'Adresse sélectionnée.';
  const ADDRESS_STATUS_MANUAL = 'Adresse saisie manuellement.';
  const ADDRESS_OUTSIDE_ZONE_MESSAGE = 'Désolé, nous ne desservons pas encore cette adresse pour cette prestation.';
  const ALLOWED_DOSSIER_STRUCTURES = new Set(['general', 'diagnostic_real_estate', 're2020', 'permit_declaration']);
  const PRODUCTION_EXTRANET_ORIGIN = 'https://espace-client.nouvac.fr';
  const STAGING_EXTRANET_ORIGIN = 'https://staging-espace-client.nouvac.fr';
  const ALLOWED_EXTRANET_ORIGINS = new Set([PRODUCTION_EXTRANET_ORIGIN, STAGING_EXTRANET_ORIGIN]);
  const PUBLIC_BOOKING_PATH = '/public/booking';
  const PUBLIC_COVERAGE_PATH = '/api/public/coverage/check';
  const BOOKING_MESSAGE_PROTOCOL_VERSION = '2026-06-v1';
  const SHOPIFY_ORDER_PAYLOAD_VERSION = 'order-flow-v2-cart-2026-07-v1';
  const PUBLIC_COVERAGE_CONTRACT_VERSION = 'public-shopify-coverage-2026-08-v1';
  const BOOKING_HANDSHAKE_STATES = Object.freeze({
    IFRAME_LOADING: 'IFRAME_LOADING',
    WAITING_FOR_READY: 'WAITING_FOR_READY',
    CONTEXT_INIT_SENT: 'CONTEXT_INIT_SENT',
    CONTEXT_ACCEPTED: 'CONTEXT_ACCEPTED',
    CONTEXT_FAILED: 'CONTEXT_FAILED'
  });
  const BOOKING_MESSAGE_TYPES = Object.freeze({
    IFRAME_READY: 'NOUVAC_BOOKING_IFRAME_READY',
    CONTEXT_INIT: 'NOUVAC_BOOKING_CONTEXT_INIT',
    CONTEXT_ACCEPTED: 'NOUVAC_BOOKING_CONTEXT_ACCEPTED',
    CONTEXT_FAILED: 'NOUVAC_BOOKING_CONTEXT_FAILED',
    IFRAME_RESIZE: 'NOUVAC_BOOKING_IFRAME_RESIZE',
    SLOT_SELECTED: 'NOUVAC_BOOKING_SLOT_SELECTED',
    HOLD_CREATED: 'NOUVAC_BOOKING_HOLD_CREATED',
    HOLD_FAILED: 'NOUVAC_BOOKING_HOLD_FAILED',
    CREATE_HOLD_REQUEST: 'NOUVAC_BOOKING_CREATE_HOLD_REQUEST'
  });
  const BOOKING_CONTEXT_FAILURE_CODES = new Set([
    'BOOKING_CONTEXT_INVALID',
    'BOOKING_PAYLOAD_TOO_LARGE',
    'BOOKING_CONFIGURATION_UNAVAILABLE',
    'BOOKING_TEMPORARY_FAILURE',
    'BOOKING_INITIALIZATION_INVALID',
    'BOOKING_INITIALIZATION_CONFLICT'
  ]);
  const COVERAGE_STATUSES = new Set([
    'COVERED',
    'OUTSIDE_COVERAGE',
    'INVALID_ADDRESS',
    'SERVICE_UNAVAILABLE',
    'TEMPORARY_FAILURE'
  ]);
  const BOOKING_IFRAME_MIN_HEIGHT = 160;
  const BOOKING_IFRAME_MAX_HEIGHT = 1800;
  const BOOKING_INITIALIZATION_MAX_SURFACE = 100000;
  const PRODUCT_HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;
  const VARIANT_ID_PATTERN = /^\d+$/;
  const ERROR_CATEGORIES = Object.freeze({
    INVALID_ROUTE: 'INVALID_ROUTE',
    PRODUCT_CONTEXT_FAILED: 'PRODUCT_CONTEXT_FAILED',
    INVALID_PRODUCT_CONFIG: 'INVALID_PRODUCT_CONFIG',
    INVALID_DOSSIER_STRUCTURE: 'INVALID_DOSSIER_STRUCTURE',
    UNSUPPORTED_FLOW: 'UNSUPPORTED_FLOW',
    OFFERS_RENDERER_MISSING: 'OFFERS_RENDERER_MISSING',
    NO_AVAILABLE_VARIANT: 'NO_AVAILABLE_VARIANT',
    VARIANT_REQUIRED: 'VARIANT_REQUIRED',
    VARIANT_UNAVAILABLE: 'VARIANT_UNAVAILABLE',
    QUESTIONS_REQUIRED: 'QUESTIONS_REQUIRED',
    INVALID_QUESTION_VALUE: 'INVALID_QUESTION_VALUE',
    ADDRESS_REQUIRED: 'ADDRESS_REQUIRED',
    DPE_NUMBER_REQUIRED: 'DPE_NUMBER_REQUIRED',
    CALENDAR_CONTEXT_FAILED: 'CALENDAR_CONTEXT_FAILED',
    CALENDAR_PROTOCOL_MISMATCH: 'CALENDAR_PROTOCOL_MISMATCH',
    SLOT_REQUIRED: 'SLOT_REQUIRED',
    HOLD_FAILED: 'HOLD_FAILED',
    CART_FAILED: 'CART_FAILED'
  });
  const createFlowProfile = ({ steps, capabilities, ...profile }) => Object.freeze({
    ...profile,
    steps: Object.freeze(steps),
    capabilities: Object.freeze(capabilities)
  });
  const FLOW_PROFILES = Object.freeze({
    [FLOW_ADDRESS_CHECKOUT]: createFlowProfile({
      steps: ['address'],
      finalAction: FINAL_ACTION_CART,
      addressProfile: 'required-complete-no-block',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_CANONICAL,
        selectionPresentation: SELECTION_PRESENTATION_NONE,
        formulaPresentation: FORMULA_PRESENTATION_DEFAULT,
        formulaProgression: FORMULA_PROGRESSION_NONE,
        calendarPresentation: CALENDAR_PRESENTATION_NONE,
        bookingLifecycle: BOOKING_LIFECYCLE_NONE,
        summaryPresentation: SUMMARY_PRESENTATION_NONE,
        initialVariantSelection: INITIAL_VARIANT_UNIQUE_AVAILABLE,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: true,
        markFormulaSelectionInUrl: false
      }
    }),
    [FLOW_FORMULA_CHECKOUT]: createFlowProfile({
      steps: ['formula'],
      finalAction: FINAL_ACTION_CART,
      addressProfile: 'none',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_NONE,
        selectionPresentation: SELECTION_PRESENTATION_FORMULA_CARDS,
        formulaPresentation: FORMULA_PRESENTATION_CURATED_GRID,
        formulaProgression: FORMULA_PROGRESSION_STAY,
        calendarPresentation: CALENDAR_PRESENTATION_NONE,
        bookingLifecycle: BOOKING_LIFECYCLE_NONE,
        summaryPresentation: SUMMARY_PRESENTATION_INLINE,
        initialVariantSelection: INITIAL_VARIANT_AUTHORIZED_DIRECT,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_SUMMARY,
        normalizeAddressWhitespace: false,
        markFormulaSelectionInUrl: false
      }
    }),
    [FLOW_FORMULA_ADDRESS_CHECKOUT]: createFlowProfile({
      steps: ['formula', 'address'],
      finalAction: FINAL_ACTION_CART,
      addressProfile: 'project-address-or-city',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_PROJECT,
        selectionPresentation: SELECTION_PRESENTATION_FORMULA_CARDS,
        formulaPresentation: FORMULA_PRESENTATION_DEFAULT,
        formulaProgression: FORMULA_PROGRESSION_EXPLICIT,
        calendarPresentation: CALENDAR_PRESENTATION_NONE,
        bookingLifecycle: BOOKING_LIFECYCLE_NONE,
        summaryPresentation: SUMMARY_PRESENTATION_INLINE,
        initialVariantSelection: INITIAL_VARIANT_AUTHORIZED_DIRECT,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: true,
        markFormulaSelectionInUrl: true
      }
    }),
    [FLOW_ADDRESS_FORMULA_CHECKOUT]: createFlowProfile({
      steps: ['address', 'formula'],
      finalAction: FINAL_ACTION_CART,
      addressProfile: 'required-no-block',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_CANONICAL,
        selectionPresentation: SELECTION_PRESENTATION_FORMULA_CARDS,
        formulaPresentation: FORMULA_PRESENTATION_CURATED_GRID,
        formulaProgression: FORMULA_PROGRESSION_STAY,
        calendarPresentation: CALENDAR_PRESENTATION_NONE,
        bookingLifecycle: BOOKING_LIFECYCLE_NONE,
        summaryPresentation: SUMMARY_PRESENTATION_FINAL_FORMULA,
        initialVariantSelection: INITIAL_VARIANT_AUTHORIZED_DIRECT,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: true,
        markFormulaSelectionInUrl: true
      }
    }),
    [FLOW_FORMULA_ADDRESS_CALENDAR]: createFlowProfile({
      steps: ['formula', 'address', 'calendar'],
      finalAction: FINAL_ACTION_BOOKING_HOLD_CART,
      addressProfile: 'onsite-property',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_PROPERTY_CONTEXT,
        selectionPresentation: SELECTION_PRESENTATION_FORMULA_CARDS,
        formulaPresentation: FORMULA_PRESENTATION_DEFAULT,
        formulaProgression: FORMULA_PROGRESSION_EXPLICIT,
        calendarPresentation: CALENDAR_PRESENTATION_STANDARD,
        bookingLifecycle: BOOKING_LIFECYCLE_CONTEXT_BOUND,
        summaryPresentation: SUMMARY_PRESENTATION_INLINE,
        initialVariantSelection: INITIAL_VARIANT_REQUESTED_OR_FIRST,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: false,
        markFormulaSelectionInUrl: false
      }
    }),
    [FLOW_ADDRESS_FORMULA_DPE_NUMBER]: createFlowProfile({
      steps: ['address', 'formula', 'dpe-number'],
      finalAction: FINAL_ACTION_CART,
      addressProfile: 'standard-property-address',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_CANONICAL,
        selectionPresentation: SELECTION_PRESENTATION_FORMULA_CARDS,
        formulaPresentation: FORMULA_PRESENTATION_DEFAULT,
        formulaProgression: FORMULA_PROGRESSION_EXPLICIT,
        calendarPresentation: CALENDAR_PRESENTATION_NONE,
        bookingLifecycle: BOOKING_LIFECYCLE_NONE,
        summaryPresentation: SUMMARY_PRESENTATION_DECISION,
        initialVariantSelection: INITIAL_VARIANT_AUTHORIZED_DIRECT,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: true,
        markFormulaSelectionInUrl: false
      }
    }),
    [FLOW_ADDRESS_FORMULA_CALENDAR]: createFlowProfile({
      steps: ['address', 'formula', 'calendar'],
      finalAction: FINAL_ACTION_BOOKING_HOLD_CART,
      addressProfile: 'required-zone-block-local',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_CANONICAL,
        selectionPresentation: SELECTION_PRESENTATION_FORMULA_CARDS,
        formulaPresentation: FORMULA_PRESENTATION_CURATED_GRID,
        formulaProgression: FORMULA_PROGRESSION_EXPLICIT,
        calendarPresentation: CALENDAR_PRESENTATION_CANONICAL,
        bookingLifecycle: BOOKING_LIFECYCLE_CONTEXT_BOUND,
        summaryPresentation: SUMMARY_PRESENTATION_CALENDAR,
        initialVariantSelection: INITIAL_VARIANT_AUTHORIZED_DIRECT,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: true,
        markFormulaSelectionInUrl: true
      }
    }),
    [FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR]: createFlowProfile({
      steps: ['address', 'details', 'calendar'],
      finalAction: FINAL_ACTION_BOOKING_HOLD_CART,
      addressProfile: 'required-zone-block-local',
      capabilities: {
        addressPresentation: ADDRESS_PRESENTATION_CANONICAL,
        selectionPresentation: SELECTION_PRESENTATION_VARIANT_QUESTIONS,
        formulaPresentation: FORMULA_PRESENTATION_DEFAULT,
        formulaProgression: FORMULA_PROGRESSION_NONE,
        calendarPresentation: CALENDAR_PRESENTATION_CANONICAL,
        bookingLifecycle: BOOKING_LIFECYCLE_CONTEXT_BOUND,
        summaryPresentation: SUMMARY_PRESENTATION_CALENDAR,
        initialVariantSelection: INITIAL_VARIANT_REQUESTED_ONLY,
        directFormulaEntry: DIRECT_FORMULA_ENTRY_NONE,
        normalizeAddressWhitespace: false,
        markFormulaSelectionInUrl: false
      }
    })
  });
  const V2_PRODUCT_CONTRACTS = Object.freeze({
    [ANIMATION_3D_SERVICE_SLUG]: Object.freeze({
      productHandle: ANIMATION_3D_SERVICE_SLUG,
      serviceSlug: ANIMATION_3D_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_FORMULA_CHECKOUT,
      dossierStructure: 'general',
      variantUi: VARIANT_UI_FORMULA_CARDS,
      addressMode: 'required-no-block',
      calendarRequired: false,
      customRendererRequired: true,
      rendererKey: ANIMATION_3D_SERVICE_SLUG,
      variantResolver: 'animation3d',
      noAvailableMessage: 'Aucune formule Animation vidéo 3D disponible n’a été trouvée.'
    }),
    [RENDU_3D_SERVICE_SLUG]: Object.freeze({
      productHandle: RENDU_3D_SERVICE_SLUG,
      serviceSlug: RENDU_3D_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_FORMULA_CHECKOUT,
      dossierStructure: 'general',
      variantUi: VARIANT_UI_FORMULA_CARDS,
      addressMode: 'required-no-block',
      calendarRequired: false,
      customRendererRequired: true,
      rendererKey: RENDU_3D_SERVICE_SLUG,
      variantResolver: 'rendu3d',
      noAvailableMessage: 'Aucune formule Visuels 3D disponible n’a été trouvée.'
    }),
    [RE2020_SERVICE_SLUG]: Object.freeze({
      productHandle: RE2020_SERVICE_SLUG,
      serviceSlug: RE2020_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_FORMULA_CHECKOUT,
      dossierStructure: 're2020',
      variantUi: VARIANT_UI_FORMULA_CARDS,
      addressMode: 'required-no-block',
      calendarRequired: false,
      customRendererRequired: true,
      rendererKey: RE2020_SERVICE_SLUG,
      variantResolver: 're2020',
      noAvailableMessage: 'Aucune formule RE2020 disponible n’a été trouvée.'
    }),
    [DPE_PROJETE_SERVICE_SLUG]: Object.freeze({
      productHandle: DPE_PROJETE_SERVICE_SLUG,
      serviceSlug: DPE_PROJETE_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_FORMULA_DPE_NUMBER,
      dossierStructure: 'general',
      variantUi: VARIANT_UI_FORMULA_CARDS,
      addressMode: 'required-no-block',
      calendarRequired: false,
      customRendererRequired: true,
      rendererKey: DPE_PROJETE_SERVICE_SLUG,
      variantResolver: 'dpeProjete',
      noAvailableMessage: 'Aucune formule DPE projeté disponible n’a été trouvée.'
    }),
    [PERMIS_CONSTRUIRE_PRODUCT_HANDLE]: Object.freeze({
      productHandle: PERMIS_CONSTRUIRE_PRODUCT_HANDLE,
      serviceSlug: PERMIS_CONSTRUIRE_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_FORMULA_CHECKOUT,
      dossierStructure: 'permit_declaration',
      variantUi: VARIANT_UI_FORMULA_CARDS,
      addressMode: 'required-no-block',
      calendarRequired: false,
      customRendererRequired: true,
      rendererKey: PERMIS_CONSTRUIRE_SERVICE_SLUG,
      variantResolver: 'permisConstruire',
      noAvailableMessage: 'Aucune formule Permis de construire disponible n’a été trouvée.'
    }),
    [DECLARATION_PREALABLE_PRODUCT_HANDLE]: Object.freeze({
      productHandle: DECLARATION_PREALABLE_PRODUCT_HANDLE,
      serviceSlug: DECLARATION_PREALABLE_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_FORMULA_CHECKOUT,
      dossierStructure: 'permit_declaration',
      variantUi: VARIANT_UI_FORMULA_CARDS,
      addressMode: 'required-no-block',
      calendarRequired: false,
      customRendererRequired: true,
      rendererKey: DECLARATION_PREALABLE_SERVICE_SLUG,
      variantResolver: 'declarationPrealable',
      noAvailableMessage: 'Aucune formule Déclaration préalable disponible n’a été trouvée.'
    }),
    [PACK_DIAGNOSTICS_PRODUCT_HANDLE]: Object.freeze({
      productHandle: PACK_DIAGNOSTICS_PRODUCT_HANDLE,
      serviceSlug: PACK_DIAGNOSTICS_SERVICE_SLUG,
      flowType: FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR,
      dossierStructure: 'diagnostic_real_estate',
      variantUi: VARIANT_UI_VARIANT_OPTIONS,
      addressMode: 'required-zone-block-local',
      calendarRequired: true,
      customRendererRequired: false,
      rendererKey: 'generic-variant-buttons',
      customDetailsRendererRequired: true,
      detailsRendererKey: PACK_DIAGNOSTICS_SERVICE_SLUG,
      customQuestionsRequired: true,
      questionsKey: PACK_DIAGNOSTICS_SERVICE_SLUG,
      noAvailableMessage: 'Aucune combinaison disponible n’a été trouvée pour cette prestation.'
    })
  });

  class NouvacOrderFlowV2 {
    constructor(root) {
      this.root = root;
      this.product = null;
      this.route = null;
      this.staticRouteContract = null;
      this.runtimeContract = null;
      this.contextPending = false;
      this.productContextController = null;
      this.renderer = null;
      this.details = {
        mode: 'none',
        key: '',
        customDetailsRequired: false,
        html: ''
      };
      this.selectedVariant = null;
      this.selectedOptionValues = {};
      this.questionAnswers = {};
      this.questions = {
        mode: 'none',
        key: '',
        customQuestionsRequired: false,
        schema: [],
        html: ''
      };
      this.currentStep = 'formula';
      this.cartPending = false;
      this.holdPending = false;
      this.directFormulaEntry = false;
      this.validationDiagnostic = null;
      this.selectedSlot = null;
      this.bookingHold = null;
      this.calendarContextIdentity = '';
      this.calendarIframeUrl = '';
      this.calendarGenerationCounter = 0;
      this.calendarGeneration = null;
      this.handshakeTimer = null;
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      this.holdResponseTimer = null;
      this.cartRequestPromise = null;
      this.cartController = null;
      this.cartRequestContextIdentity = '';
      this.cartCompleted = false;
      this.iframeMessageListener = null;
      this.documentClickListener = null;
      this.documentKeydownListener = null;
      this.sectionUnloadListener = null;
      this.destroyed = false;
      this.diagnosticEntry = { status: 'NONE' };
      if (DIAGNOSTIC_PREQUALIFIED_API) {
        try {
          this.diagnosticEntry = DIAGNOSTIC_PREQUALIFIED_API.readEntry(window.location, window.sessionStorage);
        } catch (error) {
          this.diagnosticEntry = { status: 'NONE' };
        }
      }
      this.diagnosticReturnPath = DIAGNOSTIC_PREQUALIFIED_API?.getDiagnosticReturnPath?.(this.diagnosticEntry)
        || '/pages/diagnostic-immobilier';
      this.diagnosticResumeState = 'NONE';
      this.diagnosticSummary = null;
      this.diagnosticResumeContractVersion = '';
      this.diagnosticChoicesExpanded = false;
      this.diagnosticContextExpiresAt = '';
      this.diagnosticContextTimer = null;
      this.diagnosticFailureCode = '';
      this.diagnosticFailureMessage = '';
      this.addressSuggestions = [];
      this.addressDebounceTimer = null;
      this.addressController = null;
      this.addressCache = new Map();
      this.activeAddressIndex = -1;
      this.selectedAddress = null;
      this.addressCoordinates = null;
      this.coverageController = null;
      this.coverageRequestIdentity = '';
      this.coveredContextIdentity = '';
      this.coveragePending = false;
      this.coverageRetryRequired = false;
      this.addressState = {
        addressLine: '',
        postcode: '',
        city: '',
        department: '',
        coordinates: '',
        propertyType: '',
        surface: ''
      };
      this.dpeNumberState = {
        input: '',
        normalized: '',
        status: ''
      };
      this.debugEnabled = Boolean(window.Shopify?.designMode || new URLSearchParams(window.location.search).get('debug') === '1');
      const configuredExtranetOrigin = this.normalizeWhitespace(root.dataset.nouvacBookingOrigin);
      this.extranetOrigin = ALLOWED_EXTRANET_ORIGINS.has(configuredExtranetOrigin)
        ? configuredExtranetOrigin
        : PRODUCTION_EXTRANET_ORIGIN;

      this.nodes = {
        back: root.querySelector('[data-nouvac-order-flow-v2-back]'),
        loading: root.querySelector('[data-nouvac-order-flow-v2-loading]'),
        configError: root.querySelector('[data-nouvac-order-flow-v2-config-error]'),
        productError: root.querySelector('[data-nouvac-order-flow-v2-product-error]'),
        variantError: root.querySelector('[data-nouvac-order-flow-v2-variant-error]'),
        retry: root.querySelector('[data-nouvac-order-flow-v2-retry]'),
        content: root.querySelector('[data-nouvac-order-flow-v2-content]'),
        step: root.querySelector('[data-nouvac-order-flow-v2-step]'),
        heading: root.querySelector('.nouvac-order-flow-v2__heading'),
        title: root.querySelector('[data-nouvac-order-flow-v2-title]'),
        stepText: root.querySelector('[data-nouvac-order-flow-v2-step-text]'),
        options: root.querySelector('[data-nouvac-order-flow-v2-options]'),
        formulaPanel: root.querySelector('[data-nouvac-order-flow-v2-step-panel="formula"]'),
        addressPanel: root.querySelector('[data-nouvac-order-flow-v2-step-panel="address"]'),
        detailsPanel: root.querySelector('[data-nouvac-order-flow-v2-step-panel="details"]'),
        detailsOptions: root.querySelector('[data-nouvac-order-flow-v2-details-options]'),
        detailsQuestions: root.querySelector('[data-nouvac-order-flow-v2-details-questions]'),
        detailsStatus: root.querySelector('[data-nouvac-order-flow-v2-details-status]'),
        nextDetails: root.querySelector('[data-nouvac-order-flow-v2-next-details]'),
        backDetails: root.querySelector('[data-nouvac-order-flow-v2-back-details]'),
        calendarPanel: root.querySelector('[data-nouvac-order-flow-v2-step-panel="calendar"]'),
        calendarHeading: root.querySelector('.nouvac-order-flow-v2__pack-calendar-heading'),
        calendarTitle: root.querySelector('[data-nouvac-order-flow-v2-calendar-title]'),
        calendarStep: root.querySelector('[data-nouvac-order-flow-v2-calendar-step]'),
        dpeNumberPanel: root.querySelector('[data-nouvac-order-flow-v2-step-panel="dpe-number"]'),
        nextAddress: root.querySelector('[data-nouvac-order-flow-v2-next-address]'),
        nextCalendar: root.querySelector('[data-nouvac-order-flow-v2-next-calendar]'),
        backFormula: root.querySelector('[data-nouvac-order-flow-v2-back-formula]'),
        backAddress: root.querySelector('[data-nouvac-order-flow-v2-back-address]'),
        backFormulaFromDpe: root.querySelector('[data-nouvac-order-flow-v2-back-formula-from-dpe]'),
        addressLabel: root.querySelector('[data-nouvac-order-flow-v2-address-label]'),
        addressHelper: root.querySelector('[data-nouvac-order-flow-v2-address-helper]'),
        addressWrapper: root.querySelector('[data-nouvac-order-flow-v2-address-wrapper]'),
        addressLine: root.querySelector('[data-nouvac-order-flow-v2-address-line]'),
        addressSuggestions: root.querySelector('[data-nouvac-order-flow-v2-address-suggestions]'),
        addressStatus: root.querySelector('[data-nouvac-order-flow-v2-address-status]'),
        addressExtraFields: root.querySelector('[data-nouvac-order-flow-v2-address-extra-fields]'),
        addressActions: root.querySelector('[data-nouvac-order-flow-v2-address-form] .nouvac-order-flow-v2__actions'),
        postcode: root.querySelector('[data-nouvac-order-flow-v2-postcode]'),
        city: root.querySelector('[data-nouvac-order-flow-v2-city]'),
        propertyTypes: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-property-type]')),
        surface: root.querySelector('[data-nouvac-order-flow-v2-surface]'),
        bilanPropertyFields: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-bilan-property-field]')),
        dpeNumber: root.querySelector('[data-nouvac-order-flow-v2-dpe-number]'),
        dpeNumberStatus: root.querySelector('[data-nouvac-order-flow-v2-dpe-number-status]'),
        dpeNumberLater: root.querySelector('[data-nouvac-order-flow-v2-dpe-number-later]'),
        dpeNumberMissing: root.querySelector('[data-nouvac-order-flow-v2-dpe-number-missing]'),
        dpeNumberEntry: root.querySelector('[data-nouvac-order-flow-v2-dpe-number-entry]'),
        dpeNumberActions: root.querySelector('[data-nouvac-order-flow-v2-dpe-number-actions]'),
        dpeNumberBackActions: root.querySelector('[data-nouvac-order-flow-v2-dpe-number-back-actions]'),
        dpeMissingPanel: root.querySelector('[data-nouvac-order-flow-v2-dpe-missing-panel]'),
        dpeStep: root.querySelector('[data-nouvac-order-flow-v2-dpe-step]'),
        dpeTitle: root.querySelector('[data-nouvac-order-flow-v2-dpe-title]'),
        dpePaymentSlot: root.querySelector('[data-nouvac-order-flow-v2-dpe-payment-slot]'),
        dpeSideSummary: root.querySelector('[data-nouvac-order-flow-v2-dpe-side-summary]'),
        dpeSummaryAddress: root.querySelector('[data-nouvac-order-flow-v2-dpe-summary-address]'),
        dpeSummaryService: root.querySelector('[data-nouvac-order-flow-v2-dpe-summary-service]'),
        dpeSummaryFormula: root.querySelector('[data-nouvac-order-flow-v2-dpe-summary-formula]'),
        dpeSummaryPrice: root.querySelector('[data-nouvac-order-flow-v2-dpe-summary-price]'),
        dpeSummaryNumberRow: root.querySelector('[data-nouvac-order-flow-v2-dpe-summary-number-row]'),
        dpeSummaryNumber: root.querySelector('[data-nouvac-order-flow-v2-dpe-summary-number]'),
        iframeWrap: root.querySelector('[data-nouvac-order-flow-v2-calendar-iframe-wrap]'),
        iframe: root.querySelector('[data-nouvac-order-flow-v2-calendar-iframe]'),
        slotStatus: root.querySelector('[data-nouvac-order-flow-v2-slot-status]'),
        calendarDuration: root.querySelector('[data-nouvac-order-flow-v2-calendar-duration]'),
        calendarPaymentSlot: root.querySelector('[data-nouvac-order-flow-v2-calendar-payment-slot]'),
        diagnosticPrequalified: root.querySelector('[data-nouvac-order-flow-v2-diagnostic-prequalified]'),
        diagnosticState: root.querySelector('[data-nouvac-order-flow-v2-diagnostic-state]'),
        diagnosticSummaries: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-summary]')),
        diagnosticDossiers: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-dossier]')),
        diagnosticChipLists: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-chips]')),
        diagnosticProperties: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-property]')),
        diagnosticAddresses: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-address]')),
        diagnosticChoicesToggles: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-choices-toggle]')),
        diagnosticChoicesPanels: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-choices-panel]')),
        diagnosticFormAnswerLists: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-form-answers]')),
        diagnosticSlots: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-slot]')),
        diagnosticPrices: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-price]')),
        diagnosticInstallments: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-installment]')),
        diagnosticWeekendNote: root.querySelector('[data-nouvac-order-flow-v2-diagnostic-weekend-note]'),
        diagnosticReassurance: root.querySelector('[data-nouvac-order-flow-v2-diagnostic-reassurance]'),
        diagnosticPaymentHelpers: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-payment-helper]')),
        diagnosticDesktopPaymentSlot: root.querySelector('[data-nouvac-order-flow-v2-diagnostic-desktop-payment-slot]'),
        diagnosticReturn: root.querySelector('[data-nouvac-order-flow-v2-diagnostic-return]'),
        diagnosticModifyLinks: Array.from(root.querySelectorAll('[data-nouvac-order-flow-v2-diagnostic-modify]')),
        packSideSummary: root.querySelector('[data-nouvac-order-flow-v2-pack-side-summary]'),
        packSummaryRows: root.querySelector('[data-nouvac-order-flow-v2-pack-summary-rows]'),
        summary: root.querySelector('[data-nouvac-order-flow-v2-summary]'),
        summaryFormula: root.querySelector('[data-nouvac-order-flow-v2-summary-formula]'),
        summaryService: root.querySelector('[data-nouvac-order-flow-v2-summary-service]'),
        summaryPrice: root.querySelector('[data-nouvac-order-flow-v2-summary-price]'),
        summaryAddressRow: root.querySelector('[data-nouvac-order-flow-v2-summary-address-row]'),
        summaryAddress: root.querySelector('[data-nouvac-order-flow-v2-summary-address]'),
        summaryPropertyRow: root.querySelector('[data-nouvac-order-flow-v2-summary-property-row]'),
        summaryProperty: root.querySelector('[data-nouvac-order-flow-v2-summary-property]'),
        summarySlotRow: root.querySelector('[data-nouvac-order-flow-v2-summary-slot-row]'),
        summarySlot: root.querySelector('[data-nouvac-order-flow-v2-summary-slot]'),
        summaryDpeRow: root.querySelector('[data-nouvac-order-flow-v2-summary-dpe-row]'),
        summaryDpe: root.querySelector('[data-nouvac-order-flow-v2-summary-dpe]'),
        summaryQuestions: root.querySelector('[data-nouvac-order-flow-v2-summary-questions]'),
        cartError: root.querySelector('[data-nouvac-order-flow-v2-cart-error]'),
        payment: root.querySelector('[data-nouvac-order-flow-v2-payment]'),
        mobileSummary: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary]'),
        mobileSummaryBar: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-bar]'),
        mobileSummaryTrigger: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-trigger]'),
        mobileSummaryPanel: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-panel]'),
        mobileSummaryRows: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-rows]'),
        mobileSummaryClose: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-close]'),
        mobileSummaryService: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-service]'),
        mobileSummaryPrice: root.querySelector('[data-nouvac-order-flow-v2-mobile-summary-price]'),
        mobilePayment: root.querySelector('[data-nouvac-order-flow-v2-mobile-payment]'),
        mobileFormulaAction: root.querySelector('[data-nouvac-order-flow-v2-mobile-formula-action]'),
        mobileFormulaService: root.querySelector('[data-nouvac-order-flow-v2-mobile-formula-service]'),
        mobileFormulaPrice: root.querySelector('[data-nouvac-order-flow-v2-mobile-formula-price]'),
        mobileFormulaNext: root.querySelector('[data-nouvac-order-flow-v2-mobile-formula-next]')
      };
      this.bookingIframe = null;
      this.paymentHome = {
        parent: this.nodes.payment?.parentNode || null,
        nextSibling: this.nodes.payment?.nextSibling || null
      };
      this.slotStatusHome = {
        parent: this.nodes.slotStatus?.parentNode || null,
        nextSibling: this.nodes.slotStatus?.nextSibling || null
      };
    }

    async init() {
      this.setInitializing(true);
      this.setContextPending(true);
      this.setPaymentEnabled(false);
      this.bindEvents();
      this.applyDiagnosticLandingReturnLinks();

      const route = this.readRoute();
      if (!route.valid) {
        this.showOnly('configError', route.message, route.category || ERROR_CATEGORIES.INVALID_ROUTE);
        return;
      }
      this.route = route;

      const staticContractValidation = this.validateStaticRouteContract(route);
      if (!staticContractValidation.valid) {
        this.showOnly(
          'configError',
          staticContractValidation.message,
          staticContractValidation.category || ERROR_CATEGORIES.INVALID_ROUTE
        );
        return;
      }
      this.staticRouteContract = staticContractValidation.contract;
      const progressiveAddressReveal = this.canRevealAddressBeforeContext();

      try {
        const contextPromise = this.loadProductContext(route.productHandle);
        if (progressiveAddressReveal) this.revealAddressWhileContextPending();

        const context = await contextPromise;
        if (this.destroyed) return;
        this.product = context.product;
        this.renderer = context.renderer;
        this.details = this.normalizeDetailsContract(context.details);
        this.questions = this.normalizeQuestionsContract(context.questions);
        this.applyBackLink(this.isDiagnosticPrequalifiedCandidate ? this.diagnosticReturnPath : this.product.url);

        const validation = this.validateEligibility(this.product, route);
        if (!validation.valid) {
          this.validationDiagnostic = validation;
          console.error('[NOUVAC Order Flow V2] Product context validation failed.', validation.category || ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG);
          this.showOnly('configError', validation.message, validation.category || ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG);
          return;
        }
        this.runtimeContract = validation.contract || null;
        this.validationDiagnostic = null;
        this.syncAddressState();

        const initialVariant = this.resolveInitialVariant(this.product, route.variantId);
        const initialVariantSelection = this.getCapability('initialVariantSelection');
        const missingRequiredInitialVariant = !initialVariant && (
          initialVariantSelection === INITIAL_VARIANT_REQUESTED_OR_FIRST ||
          initialVariantSelection === INITIAL_VARIANT_UNIQUE_AVAILABLE ||
          route.formulaSelected
        );
        if (missingRequiredInitialVariant) {
          this.showOnly('variantError', '', ERROR_CATEGORIES.NO_AVAILABLE_VARIANT);
          return;
        }

        this.directFormulaEntry = Boolean(initialVariant && route.formulaSelected && route.variantId === String(initialVariant.id));
        this.selectedVariant = this.isDiagnosticPrequalifiedCandidate ? null : initialVariant;
        if (this.usesVariantOptions && initialVariant) this.selectOptionsFromVariant(initialVariant);
        if (!this.renderActiveFlow(context.offersHtml, progressiveAddressReveal)) {
          console.error('[NOUVAC Order Flow V2] Product context rendering failed.');
          return;
        }
        this.clearObsoleteAddressRetention();
        this.registerIframeMessageListener();
        if (!this.isDiagnosticPrequalifiedCandidate && initialVariant && !this.usesUniqueAvailableVariantSelection) {
          this.replaceVariantInUrl(initialVariant.id);
        }
        if (this.isDiagnosticPrequalifiedCandidate) this.activateDiagnosticPrequalifiedCalendar();

        if (this.directFormulaEntry && this.hasCapability('directFormulaEntry', DIRECT_FORMULA_ENTRY_SUMMARY)) {
          window.requestAnimationFrame(() => this.nodes.summary.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        }
      } catch (error) {
        if (this.destroyed || error?.name === 'AbortError') return;
        console.error('[NOUVAC Order Flow V2] Product context initialization failed.', error);
        this.showOnly('productError', '', ERROR_CATEGORIES.PRODUCT_CONTEXT_FAILED);
        return;
      }

      if (this.nodes.detailsPanel && !this.isDiagnosticPrequalifiedCandidate) {
        this.nodes.detailsPanel.addEventListener('click', (event) => {
          const optionButton = event.target.closest('[data-nouvac-order-flow-v2-option-value]');
          if (optionButton && this.root.contains(optionButton)) {
            this.selectVariantOption(
              optionButton.getAttribute('data-nouvac-order-flow-v2-option-name'),
              optionButton.getAttribute('data-nouvac-order-flow-v2-option-value')
            );
            return;
          }
          const questionButton = event.target.closest('[data-nouvac-order-flow-v2-question-option]');
          if (questionButton && this.root.contains(questionButton)) {
            this.selectQuestionAnswer(
              questionButton.getAttribute('data-nouvac-order-flow-v2-question-key'),
              questionButton.getAttribute('data-nouvac-order-flow-v2-question-value')
            );
          }
        });
      }

      this.nodes.nextDetails?.addEventListener('click', () => {
        this.continueFromDetails();
      });

      this.nodes.backDetails?.addEventListener('click', () => {
        const previousStep = this.getPreviousStep('details');
        if (previousStep) this.showStep(previousStep);
      });
    }

    bindEvents() {
      if (this.nodes.options) {
        this.nodes.options.addEventListener('click', (event) => {
          if (this.contextPending) return;
          const button = event.target.closest('[data-nouvac-order-flow-v2-variant-button]');
          const card = this.usesFormulaCardSelection
            ? event.target.closest('[data-nouvac-order-flow-v2-formula-card]')
            : null;
          const target = button || card;
          if (!target || !this.root.contains(target)) return;
          const selectionControl = button || card?.querySelector('[data-nouvac-order-flow-v2-variant-button]');
          const variantId = selectionControl?.getAttribute('data-nouvac-order-flow-v2-variant-id') || card?.getAttribute('data-nouvac-variant-id') || '';
          if (!variantId || selectionControl?.disabled || card?.getAttribute('data-nouvac-order-flow-v2-formula-state') === 'unavailable') return;
          this.selectVariant(variantId, true);
        });
        this.nodes.options.addEventListener('keydown', (event) => {
          if (!['Enter', ' '].includes(event.key)) return;
          const target = event.target.closest('[data-nouvac-order-flow-v2-variant-button], [data-nouvac-order-flow-v2-formula-card]');
          if (!target || !this.root.contains(target)) return;
          event.preventDefault();
          target.click();
        });
      }

      this.nodes.nextAddress?.addEventListener('click', () => {
        if (this.contextPending) return;
        if (this.isCurrentStep('formula') && this.getNextStep('formula')) return this.continueFromFormula();
        const nextStep = this.getNextStep(this.currentStep);
        if (nextStep) this.showStep(nextStep);
      });
      this.nodes.nextCalendar?.addEventListener('click', () => {
        this.continueFromAddress();
      });
      this.nodes.backFormula?.addEventListener('click', () => {
        const previousStep = this.getPreviousStep();
        if (previousStep) {
          this.showStep(previousStep);
          return;
        }
        if (this.nodes.back?.href) window.location.href = this.nodes.back.href;
      });
      this.nodes.backAddress?.addEventListener('click', () => this.showStep(this.getPreviousStep('calendar') || 'address'));
      this.nodes.backFormulaFromDpe?.addEventListener('click', () => {
        const previousStep = this.getPreviousStep('dpe-number');
        if (previousStep) this.showStep(previousStep);
      });

      [this.nodes.postcode, this.nodes.city].forEach((input) => {
        input?.addEventListener('input', () => {
          this.clearRetainedAddress();
          this.selectedAddress = null;
          this.addressCoordinates = null;
          this.setAddressStatus('');
          this.syncAddressState();
        });
      });
      [this.nodes.surface].forEach((input) => {
        input?.addEventListener('input', () => this.syncAddressState());
      });
      this.nodes.addressLine?.addEventListener('input', () => this.handleAddressInput());
      this.nodes.addressLine?.addEventListener('keydown', (event) => this.handleAddressKeydown(event));
      this.nodes.addressSuggestions?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-nouvac-order-flow-v2-address-suggestion-index]');
        if (!button || !this.root.contains(button)) return;
        this.selectAddressSuggestion(Number(button.getAttribute('data-nouvac-order-flow-v2-address-suggestion-index')));
      });
      this.documentClickListener = (event) => {
        if (this.nodes.addressWrapper && !this.nodes.addressWrapper.contains(event.target)) this.closeAddressSuggestions();
        if (this.isMobileSummaryOpen() && this.nodes.mobileSummary && !this.nodes.mobileSummary.contains(event.target)) {
          this.closeMobileSummary(false);
        }
      };
      this.documentKeydownListener = (event) => {
        if (event.key === 'Escape' && this.isMobileSummaryOpen()) this.closeMobileSummary(true);
      };
      document.addEventListener('click', this.documentClickListener);
      document.addEventListener('keydown', this.documentKeydownListener);
      this.nodes.propertyTypes.forEach((input) => input.addEventListener('change', () => this.syncAddressState()));
      this.nodes.dpeNumber?.addEventListener('input', () => this.syncDpeNumberState());
      this.nodes.dpeNumberLater?.addEventListener('click', () => this.deferDpeNumber());
      this.nodes.dpeNumberMissing?.addEventListener('click', () => this.blockMissingDpeNumber());
      this.nodes.mobileSummaryBar?.addEventListener('click', (event) => {
        if (event.target.closest('[data-nouvac-order-flow-v2-mobile-payment]')) return;
        this.toggleMobileSummary();
      });
      this.nodes.mobileSummaryClose?.addEventListener('click', () => this.closeMobileSummary(true));
      this.nodes.diagnosticChoicesToggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleDiagnosticChoices();
        });
      });

      this.nodes.payment?.addEventListener('click', (event) => {
        event.preventDefault();
        this.submitPayment();
      });
      this.nodes.mobilePayment?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.submitPayment();
      });
      this.nodes.mobileFormulaNext?.addEventListener('click', (event) => {
        event.preventDefault();
        this.continueFromMobileFormulaAction();
      });

      this.nodes.back?.addEventListener('click', (event) => {
        if (!this.usesProjectAddressPresentation || !this.isCurrentStep('address') || this.getPreviousStep() !== 'formula') return;
        event.preventDefault();
        this.showStep('formula');
      });

      this.nodes.retry?.addEventListener('click', () => {
        if (this.calendarGeneration?.state === BOOKING_HANDSHAKE_STATES.CONTEXT_FAILED) {
          this.retryCalendarIframe();
          return;
        }
        window.location.reload();
      });

      this.sectionUnloadListener = (event) => {
        if (event.target?.contains?.(this.root)) this.destroy();
      };
      document.addEventListener('shopify:section:unload', this.sectionUnloadListener);

    }

    continueFromFormula() {
      if (this.contextPending) return;
      const nextStep = this.getNextStep('formula');
      if (this.validateStep('formula') && nextStep) {
        this.showStep(nextStep);
        if (nextStep === 'calendar') this.renderIframe();
      }
    }

    continueFromDetails() {
      if (this.contextPending) return;
      if (!this.validateStep('details', true)) return;
      const nextStep = this.getNextStep('details');
      if (!nextStep) return;
      this.showStep(nextStep);
      if (nextStep === 'calendar') this.renderIframe();
    }

    async continueFromAddress() {
      if (this.contextPending || this.coveragePending || !this.validateStep('address', true)) return;
      if (this.requiresPublicCoverageCheck && !await this.ensurePublicCoverage()) return;
      const nextStep = this.getNextStep('address');
      if (!nextStep || this.destroyed) return;
      this.showStep(nextStep);
      if (nextStep === 'calendar') this.renderIframe();
    }

    continueFromMobileFormulaAction() {
      if (this.contextPending) return;
      if (this.isCurrentStep('details')) {
        this.continueFromDetails();
        return;
      }
      this.continueFromFormula();
    }

    registerIframeMessageListener() {
      if (!this.hasCalendarCapability || this.iframeMessageListener) return;
      this.iframeMessageListener = (event) => this.handleIframeMessage(event);
      window.addEventListener('message', this.iframeMessageListener);
    }

    destroy() {
      if (this.destroyed) return;
      this.destroyed = true;
      if (this.iframeMessageListener) window.removeEventListener('message', this.iframeMessageListener);
      if (this.documentClickListener) document.removeEventListener('click', this.documentClickListener);
      if (this.documentKeydownListener) document.removeEventListener('keydown', this.documentKeydownListener);
      if (this.sectionUnloadListener) document.removeEventListener('shopify:section:unload', this.sectionUnloadListener);
      this.iframeMessageListener = null;
      this.documentClickListener = null;
      this.documentKeydownListener = null;
      this.sectionUnloadListener = null;
      window.clearTimeout(this.addressDebounceTimer);
      this.addressDebounceTimer = null;
      if (this.addressController) this.addressController.abort();
      this.addressController = null;
      if (this.productContextController) this.productContextController.abort();
      this.productContextController = null;
      if (this.cartController) this.cartController.abort();
      this.cartController = null;
      this.abortCoverageRequest();
      this.clearHandshakeTimer();
      this.clearHoldResponseTimer();
      this.clearDiagnosticContextTimer();
      this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
      this.cartRequestPromise = null;
      this.root.dataset.nouvacOrderFlowV2Initialized = 'false';
    }

    readRoute() {
      const params = new URLSearchParams(window.location.search);
      const productHandleParam = this.normalizeToken(params.get('productHandle') || '');
      const productAliasParam = this.normalizeToken(params.get('product') || '');
      const serviceSlugParam = this.normalizeToken(params.get('serviceSlug') || '');
      const serviceAliasParam = this.normalizeToken(params.get('service') || '');
      let productHandle = productHandleParam || productAliasParam;
      const variantId = String(params.get('variant') || params.get('shopifyVariantId') || '').trim();
      let serviceSlug = serviceSlugParam || serviceAliasParam;
      let flowType = this.normalizeToken(params.get('flowType') || '');
      const formulaSelected = params.get('formulaSelected') === 'true';

      if (this.diagnosticEntry?.status === 'INVALID') {
        const explicitRoute = Boolean(productHandle || serviceSlug || flowType || variantId || formulaSelected);
        if (explicitRoute && this.diagnosticEntry.reason === 'INVALID_SAME_SESSION_HANDOFF') {
          this.diagnosticEntry = { status: 'NONE' };
        } else {
          this.applyBackLink(this.diagnosticReturnPath);
          return {
            valid: false,
            category: ERROR_CATEGORIES.INVALID_ROUTE,
            message: 'Ce lien de reprise Diagnostic n’est pas valide. Effectuez une nouvelle demande pour continuer.'
          };
        }
      }
      if (this.diagnosticEntry?.status === 'CANDIDATE') {
        const explicitRoute = Boolean(productHandle || serviceSlug || flowType || variantId || formulaSelected);
        const matchesDiagnosticRoute = Boolean(
          (!productHandle || productHandle === PACK_DIAGNOSTICS_PRODUCT_HANDLE) &&
          (!serviceSlug || serviceSlug === PACK_DIAGNOSTICS_SERVICE_SLUG) &&
          (!flowType || flowType === FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR) &&
          !variantId &&
          !formulaSelected
        );
        if (explicitRoute && !matchesDiagnosticRoute && this.diagnosticEntry.entry === 'SAME_SESSION') {
          this.diagnosticEntry = { status: 'NONE' };
        } else if (!matchesDiagnosticRoute) {
          this.applyBackLink(this.diagnosticReturnPath);
          return {
            valid: false,
            category: ERROR_CATEGORIES.INVALID_ROUTE,
            message: 'Ce lien de reprise ne correspond pas à cette prestation.'
          };
        } else {
          productHandle = PACK_DIAGNOSTICS_PRODUCT_HANDLE;
          serviceSlug = PACK_DIAGNOSTICS_SERVICE_SLUG;
          flowType = FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR;
        }
      }

      if (
        (productHandleParam && productAliasParam && productHandleParam !== productAliasParam) ||
        (serviceSlugParam && serviceAliasParam && serviceSlugParam !== serviceAliasParam)
      ) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_ROUTE, message: 'Les paramètres de la prestation sont incohérents.' };
      }
      if (!productHandle || !PRODUCT_HANDLE_PATTERN.test(productHandle)) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_ROUTE, message: 'Le produit demandé est invalide.' };
      }
      if (variantId && !VARIANT_ID_PATTERN.test(variantId)) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_ROUTE, message: 'La formule demandée est invalide.' };
      }
      if (!FLOW_PROFILES[flowType]) {
        return { valid: false, category: ERROR_CATEGORIES.UNSUPPORTED_FLOW, message: 'Ce type de parcours n’est pas pris en charge.' };
      }

      return { valid: true, productHandle, variantId, serviceSlug, flowType, formulaSelected };
    }

    validateStaticRouteContract(route) {
      const fixedContract = V2_PRODUCT_CONTRACTS[route.productHandle];
      const metafieldDrivenServiceSlug = METAFIELD_DRIVEN_PRODUCT_IDENTITIES[route.productHandle] || '';
      const addressFormulaCalendarIdentity = ADDRESS_FORMULA_CALENDAR_PRODUCT_IDENTITIES[route.productHandle] || null;
      const addressCheckoutIdentity = ADDRESS_CHECKOUT_PRODUCT_IDENTITIES.has(route.productHandle);
      if (!fixedContract && !metafieldDrivenServiceSlug && !addressFormulaCalendarIdentity && !addressCheckoutIdentity) {
        return {
          valid: false,
          category: ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG,
          message: 'Cette prestation n’est pas configurée pour ce parcours de commande.'
        };
      }
      if (addressCheckoutIdentity && (route.variantId || route.formulaSelected)) {
        return {
          valid: false,
          category: ERROR_CATEGORIES.INVALID_ROUTE,
          message: 'La demande ne correspond pas à la prestation sélectionnée.'
        };
      }

      const contract = fixedContract || (
        addressFormulaCalendarIdentity
          ? {
            productHandle: route.productHandle,
            serviceSlug: addressFormulaCalendarIdentity.serviceSlug || route.serviceSlug,
            flowType: FLOW_ADDRESS_FORMULA_CALENDAR,
            addressMode: 'required-zone-block-local',
            variantUi: VARIANT_UI_FORMULA_CARDS,
            calendarRequired: true,
            customRendererRequired: true,
            rendererKey: addressFormulaCalendarIdentity.rendererKey,
            variantResolver: addressFormulaCalendarIdentity.variantResolver,
            addressHelperText: addressFormulaCalendarIdentity.addressHelperText || '',
            addressFormulaCalendar: true
          }
          : addressCheckoutIdentity
            ? {
              productHandle: route.productHandle,
              serviceSlug: route.serviceSlug,
              flowType: FLOW_ADDRESS_CHECKOUT,
              addressMode: 'required-complete-no-block',
              variantUi: VARIANT_UI_NONE,
              calendarRequired: false,
              customRendererRequired: false,
              rendererKey: '',
              variantResolver: 'uniqueAvailable',
              addressCheckout: true
            }
          : {
            productHandle: route.productHandle,
            serviceSlug: metafieldDrivenServiceSlug,
            flowType: FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR,
            metafieldDriven: true
          }
      );
      const matches = Boolean(
        route.productHandle === contract.productHandle &&
        PRODUCT_HANDLE_PATTERN.test(route.serviceSlug) &&
        route.serviceSlug === contract.serviceSlug &&
        route.flowType === contract.flowType
      );
      if (!matches) {
        return {
          valid: false,
          category: ERROR_CATEGORIES.INVALID_ROUTE,
          message: 'La demande ne correspond pas à la prestation sélectionnée.'
        };
      }
      return { valid: true, contract };
    }

    canRevealAddressBeforeContext() {
      const contract = this.staticRouteContract;
      return Boolean(contract && !this.isDiagnosticPrequalifiedCandidate && this.profile.steps[0] === 'address');
    }

    revealAddressWhileContextPending() {
      if (this.isDiagnosticPrequalifiedCandidate) return false;
      this.applyBackLink(`/products/${encodeURIComponent(this.route.productHandle)}`);
      this.hideAllMessages();
      this.nodes.loading.hidden = true;
      this.nodes.content.hidden = false;
      return this.showStep('address');
    }

    async loadProductContext(productHandle) {
      if (this.productContextController) this.productContextController.abort();
      this.productContextController = new AbortController();
      const response = await fetch(`/products/${encodeURIComponent(productHandle)}?section_id=${CONTEXT_SECTION_ID}`, {
        credentials: 'same-origin',
        signal: this.productContextController.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Product context request failed');

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const contextRoot = documentFragment.querySelector(CONTEXT_SELECTOR);
      const jsonNode = contextRoot && contextRoot.querySelector(CONTEXT_JSON_SELECTOR);
      if (!jsonNode) throw new Error('Product context JSON missing');

      const payload = JSON.parse(jsonNode.textContent);
      if (this.destroyed) throw new DOMException('Instance destroyed.', 'AbortError');
      if (!payload?.product || !Array.isArray(payload.product.variants)) {
        throw new Error('Product context incomplete');
      }

      const offersTemplate = contextRoot.querySelector(CONTEXT_OFFERS_SELECTOR);
      const detailsTemplate = contextRoot.querySelector(CONTEXT_DETAILS_SELECTOR);
      return {
        product: payload.product,
        renderer: payload.renderer || {},
        details: {
          ...(payload.details || {}),
          html: detailsTemplate ? detailsTemplate.innerHTML.trim() : ''
        },
        questions: payload.questions || {},
        offersHtml: offersTemplate ? offersTemplate.innerHTML.trim() : ''
      };
    }

    getMetafieldDrivenServiceSlug(productHandle) {
      return METAFIELD_DRIVEN_PRODUCT_IDENTITIES[this.normalizeToken(productHandle)] || '';
    }

    buildMetafieldDrivenContract(product, route) {
      const metafields = product?.metafields || {};
      return {
        productHandle: product.handle,
        serviceSlug: this.normalizeToken(metafields.service_slug),
        flowType: this.normalizeToken(metafields.flow_type),
        dossierStructure: this.getCanonicalDossierStructure(),
        variantUi: this.normalizeToken(metafields.variant_ui),
        addressMode: this.normalizeToken(metafields.address_mode),
        calendarRequired: metafields.calendar_required === true,
        customRendererRequired: false,
        rendererKey: 'generic-variant-buttons',
        customDetailsRendererRequired: this.details.customDetailsRequired,
        detailsRendererKey: this.details.key,
        customQuestionsRequired: this.questions.customQuestionsRequired,
        questionsKey: this.questions.key,
        noAvailableMessage: 'Aucune combinaison disponible n’a été trouvée pour cette prestation.',
        metafieldDriven: true
      };
    }

    buildAddressFormulaCalendarContract(product) {
      const identity = ADDRESS_FORMULA_CALENDAR_PRODUCT_IDENTITIES[product?.handle];
      const metafields = product?.metafields || {};
      if (!identity) return null;
      return {
        productHandle: product.handle,
        serviceSlug: identity.serviceSlug || this.normalizeToken(metafields.service_slug),
        flowType: FLOW_ADDRESS_FORMULA_CALENDAR,
        dossierStructure: this.getCanonicalDossierStructure(),
        variantUi: VARIANT_UI_FORMULA_CARDS,
        addressMode: 'required-zone-block-local',
        calendarRequired: true,
        customRendererRequired: true,
        rendererKey: identity.rendererKey,
        variantResolver: identity.variantResolver,
        addressHelperText: identity.addressHelperText || '',
        noAvailableMessage: identity.noAvailableMessage,
        addressFormulaCalendar: true
      };
    }

    buildAddressCheckoutContract(product) {
      const metafields = product?.metafields || {};
      if (!ADDRESS_CHECKOUT_PRODUCT_IDENTITIES.has(product?.handle)) return null;
      return {
        productHandle: product.handle,
        serviceSlug: this.normalizeToken(metafields.service_slug),
        flowType: FLOW_ADDRESS_CHECKOUT,
        dossierStructure: this.getCanonicalDossierStructure(),
        variantUi: VARIANT_UI_NONE,
        addressMode: 'required-complete-no-block',
        calendarRequired: false,
        customRendererRequired: false,
        rendererKey: '',
        variantResolver: 'uniqueAvailable',
        noAvailableMessage: 'Cette prestation ne dispose pas d’une variante unique disponible.',
        addressCheckout: true
      };
    }

    validateEligibility(product, route) {
      const metafields = product.metafields || {};
      const availableVariants = product.variants.filter((variant) => variant?.available);
      const canonicalDossierStructure = this.getCanonicalDossierStructure();
      const profile = FLOW_PROFILES[route.flowType];
      const fixedContract = V2_PRODUCT_CONTRACTS[product.handle];
      const addressFormulaCalendarIdentity = ADDRESS_FORMULA_CALENDAR_PRODUCT_IDENTITIES[product.handle] || null;
      const addressCheckoutIdentity = ADDRESS_CHECKOUT_PRODUCT_IDENTITIES.has(product.handle);
      const metafieldDrivenServiceSlug = this.getMetafieldDrivenServiceSlug(product.handle);
      const contract = fixedContract || (
        addressFormulaCalendarIdentity
          ? this.buildAddressFormulaCalendarContract(product)
          : addressCheckoutIdentity
            ? this.buildAddressCheckoutContract(product)
            : metafieldDrivenServiceSlug
              ? this.buildMetafieldDrivenContract(product, route)
              : null
      );

      if (metafields.booking_required !== true) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG, message: 'Cette prestation n’est pas activée pour Order Flow V2.' };
      }
      if (product.handle !== route.productHandle) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG, message: 'Le produit chargé ne correspond pas à la demande.' };
      }
      if (!contract) {
        return this.invalidProductConfig('product_contract');
      }
      if (product.handle !== contract.productHandle) {
        return this.invalidProductConfig('product_handle', contract.productHandle, product.handle);
      }
      if (
        !metafields.service_slug ||
        this.normalizeToken(metafields.service_slug) !== contract.serviceSlug ||
        (route.serviceSlug && this.normalizeToken(route.serviceSlug) !== contract.serviceSlug) ||
        (metafieldDrivenServiceSlug && contract.serviceSlug !== metafieldDrivenServiceSlug) ||
        (addressFormulaCalendarIdentity?.serviceSlug && contract.serviceSlug !== addressFormulaCalendarIdentity.serviceSlug)
      ) {
        return this.invalidProductConfig('service_slug', contract.serviceSlug, metafields.service_slug);
      }
      if (!profile) {
        return { valid: false, category: ERROR_CATEGORIES.UNSUPPORTED_FLOW, message: 'Ce type de parcours n’est pas pris en charge.' };
      }
      if (metafields.flow_type !== route.flowType || metafields.flow_type !== contract.flowType) {
        return this.invalidProductConfig('flow_type', contract.flowType, metafields.flow_type);
      }
      if (!canonicalDossierStructure) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_DOSSIER_STRUCTURE, message: 'La configuration du dossier est incomplète pour cette prestation.' };
      }
      if (canonicalDossierStructure !== contract.dossierStructure) {
        return { valid: false, category: ERROR_CATEGORIES.INVALID_DOSSIER_STRUCTURE, message: 'La configuration du dossier est incomplète pour cette prestation.' };
      }
      if (this.normalizeToken(metafields.variant_ui) !== contract.variantUi) {
        return this.invalidProductConfig('variant_ui', contract.variantUi, metafields.variant_ui);
      }
      const profileVariantUi = profile.capabilities.selectionPresentation === SELECTION_PRESENTATION_VARIANT_QUESTIONS
        ? VARIANT_UI_VARIANT_OPTIONS
        : profile.capabilities.selectionPresentation === SELECTION_PRESENTATION_FORMULA_CARDS
          ? VARIANT_UI_FORMULA_CARDS
          : VARIANT_UI_NONE;
      if (this.normalizeToken(metafields.variant_ui) !== profileVariantUi) {
        return this.invalidProductConfig('variant_ui', profileVariantUi, metafields.variant_ui);
      }
      if (this.normalizeToken(metafields.address_mode) !== contract.addressMode) {
        return this.invalidProductConfig('address_mode', contract.addressMode, metafields.address_mode);
      }
      if ((contract.metafieldDriven || contract.addressFormulaCalendar || contract.addressCheckout) && contract.addressMode !== profile.addressProfile) {
        return this.invalidProductConfig('address_mode', profile.addressProfile, metafields.address_mode);
      }
      if (metafields.calendar_required !== this.requiresCalendar || metafields.calendar_required !== contract.calendarRequired) {
        return this.invalidProductConfig('calendar_required', String(contract.calendarRequired), String(metafields.calendar_required));
      }
      const rendererValidation = this.validateRendererContract(contract, product);
      if (!rendererValidation.valid) return rendererValidation;
      const detailsValidation = this.validateDetailsContract(contract);
      if (!detailsValidation.valid) return detailsValidation;
      const questionsValidation = this.validateQuestionsContract(contract);
      if (!questionsValidation.valid) return questionsValidation;
      if (contract.variantResolver === 'uniqueAvailable' && availableVariants.length !== 1) {
        return { valid: false, category: ERROR_CATEGORIES.NO_AVAILABLE_VARIANT, message: contract.noAvailableMessage };
      }
      if (!this.getContractVariants(contract, product).some((variant) => variant?.available)) {
        return { valid: false, category: ERROR_CATEGORIES.NO_AVAILABLE_VARIANT, message: contract.noAvailableMessage };
      }
      if (!availableVariants.length) {
        return { valid: false, category: ERROR_CATEGORIES.NO_AVAILABLE_VARIANT, message: 'Aucune formule disponible n’a été trouvée.' };
      }
      return { valid: true, contract };
    }

    invalidProductConfig(field, expected = '', actual = '') {
      return {
        valid: false,
        category: ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG,
        message: 'La configuration de cette prestation est temporairement indisponible. Veuillez réessayer ou revenir à la page du service.',
        field,
        expected,
        actual
      };
    }

    validateRendererContract(contract, product) {
      const renderer = this.renderer || {};
      if (contract.customRendererRequired && renderer.mode !== 'custom') {
        return this.invalidProductConfig('renderer.mode', 'custom', renderer.mode || '');
      }
      if (contract.rendererKey && renderer.key !== contract.rendererKey) {
        return this.invalidProductConfig('renderer.key', contract.rendererKey, renderer.key || '');
      }
      if (renderer.custom_renderer_required !== contract.customRendererRequired) {
        return this.invalidProductConfig('renderer.custom_renderer_required', String(contract.customRendererRequired), String(renderer.custom_renderer_required));
      }
      const productVariantIds = new Set((product.variants || []).map((variant) => String(variant.id)));
      const mappedVariants = Array.isArray(renderer.mapped_variants) ? renderer.mapped_variants : [];
      const hasForeignVariant = mappedVariants.some((item) => item?.variant_id && !productVariantIds.has(String(item.variant_id)));
      if (hasForeignVariant) {
        return this.invalidProductConfig('renderer.mapped_variants');
      }
      return { valid: true };
    }

    validateDetailsContract(contract) {
      const details = this.details || {};
      if (contract.customDetailsRendererRequired && details.mode !== 'custom') {
        return this.invalidProductConfig('details.mode', 'custom', details.mode || '');
      }
      if (contract.detailsRendererKey && details.key !== contract.detailsRendererKey) {
        return this.invalidProductConfig('details.key', contract.detailsRendererKey, details.key || '');
      }
      if (contract.customDetailsRendererRequired && details.customDetailsRequired !== true) {
        return this.invalidProductConfig('details.custom_details_required', 'true', String(details.customDetailsRequired));
      }
      if (contract.customDetailsRendererRequired && !details.html) {
        return this.invalidProductConfig('details.html', 'present', '');
      }
      return { valid: true };
    }

    validateQuestionsContract(contract) {
      if (contract.customQuestionsRequired && this.questions.mode !== 'custom') {
        return this.invalidProductConfig('questions.mode', 'custom', this.questions.mode || '');
      }
      if (contract.questionsKey && this.questions.key !== contract.questionsKey) {
        return this.invalidProductConfig('questions.key', contract.questionsKey, this.questions.key || '');
      }
      if (contract.customQuestionsRequired && this.questions.customQuestionsRequired !== true) {
        return this.invalidProductConfig('questions.custom_questions_required', 'true', String(this.questions.customQuestionsRequired));
      }
      if (contract.customQuestionsRequired && !this.questions.schema.length) {
        return this.invalidProductConfig('questions.schema', 'present', '');
      }
      return { valid: true };
    }

    normalizeToken(value) {
      return String(value || '').trim().toLowerCase();
    }

    normalizeWhitespace(value) {
      return String(value || '').trim().replace(/\s+/g, ' ');
    }

    normalizeDetailsContract(details) {
      return {
        mode: this.normalizeToken(details?.mode) || 'none',
        key: this.normalizeToken(details?.key),
        customDetailsRequired: details?.custom_details_required === true,
        html: String(details?.html || '')
      };
    }

    normalizeQuestionsContract(questions) {
      const rawSchema = Array.isArray(questions?.schema) ? questions.schema : [];
      return {
        mode: this.normalizeToken(questions?.mode) || 'none',
        key: this.normalizeToken(questions?.key),
        customQuestionsRequired: questions?.custom_questions_required === true,
        html: String(questions?.html || ''),
        schema: rawSchema.map((item) => this.normalizeQuestionSchemaItem(item)).filter(Boolean)
      };
    }

    normalizeQuestionSchemaItem(item) {
      if (!item || typeof item !== 'object') return null;
      const rawKey = this.normalizeWhitespace(item.key);
      const key = this.normalizeToken(item.key);
      const type = this.normalizeToken(item.type);
      const allowedValues = Array.isArray(item.allowed_values) ? item.allowed_values : [];
      if (!key || type !== 'single-choice') return null;
      const normalizedValues = allowedValues.map((value) => {
        const technicalValue = this.normalizeToken(value?.value);
        if (!technicalValue) return null;
        return {
          value: technicalValue,
          label: this.normalizeWhitespace(value?.label),
          includeInSummary: value?.include_in_summary !== false,
          includeAsVisibleCartProperty: value?.include_as_visible_cart_property === true,
          includeInPayload: value?.include_in_payload !== false
        };
      }).filter(Boolean);
      if (!normalizedValues.length) return null;
      return {
        key,
        rawKey: rawKey || key,
        label: this.normalizeWhitespace(item.label),
        summaryLabel: this.normalizeWhitespace(item.summary_label || item.cart_label || item.label),
        cartLabel: this.normalizeWhitespace(item.cart_label || item.summary_label || item.label),
        type,
        required: item.required === true,
        validationMessage: this.normalizeWhitespace(item.validation_message) || 'Veuillez répondre aux questions obligatoires.',
        includeInSummary: item.include_in_summary !== false,
        includeAsVisibleCartProperty: item.include_as_visible_cart_property === true,
        includeInPayload: item.include_in_payload !== false,
        allowedValues: normalizedValues
      };
    }

    getCanonicalDossierStructure() {
      const value = this.normalizeToken(this.product?.metafields?.dossier_structure);
      return ALLOWED_DOSSIER_STRUCTURES.has(value) ? value : '';
    }

    get isFormulaAddressFlow() {
      return this.route?.flowType === FLOW_FORMULA_ADDRESS_CHECKOUT && this.activeContract?.flowType === FLOW_FORMULA_ADDRESS_CHECKOUT;
    }

    get isAddressFormulaCheckoutFlow() {
      return this.route?.flowType === FLOW_ADDRESS_FORMULA_CHECKOUT && this.activeContract?.flowType === FLOW_ADDRESS_FORMULA_CHECKOUT;
    }

    get isPermisConstruireFlow() {
      return this.route?.flowType === FLOW_ADDRESS_FORMULA_CHECKOUT && this.product?.handle === PERMIS_CONSTRUIRE_PRODUCT_HANDLE;
    }

    get isDpeProjeteFlow() {
      const productHandle = this.product?.handle || this.staticRouteContract?.productHandle;
      return this.route?.flowType === FLOW_ADDRESS_FORMULA_DPE_NUMBER && productHandle === DPE_PROJETE_PRODUCT_HANDLE;
    }

    get isPackDiagnosticsFlow() {
      const productHandle = this.product?.handle || this.staticRouteContract?.productHandle;
      return this.route?.flowType === FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR && productHandle === PACK_DIAGNOSTICS_PRODUCT_HANDLE;
    }

    get isDiagnosticPrequalifiedCandidate() {
      return Boolean(
        DIAGNOSTIC_PREQUALIFIED_API &&
        this.diagnosticEntry?.status === 'CANDIDATE' &&
        this.route?.productHandle === PACK_DIAGNOSTICS_PRODUCT_HANDLE &&
        this.route?.serviceSlug === PACK_DIAGNOSTICS_SERVICE_SLUG &&
        this.route?.flowType === FLOW_ADDRESS_VARIANT_QUESTIONS_CALENDAR
      );
    }

    get isDiagnosticPrequalifiedReady() {
      return this.isDiagnosticPrequalifiedCandidate && this.diagnosticResumeState === 'READY' && Boolean(this.diagnosticSummary);
    }

    get profile() {
      return FLOW_PROFILES[this.route?.flowType] || FLOW_PROFILES[FLOW_FORMULA_CHECKOUT];
    }

    getCapability(capability) {
      return this.profile.capabilities?.[capability];
    }

    hasCapability(capability, expectedValue = true) {
      return this.getCapability(capability) === expectedValue;
    }

    hasStep(stepName) {
      return this.profile.steps.includes(stepName);
    }

    isCurrentStep(stepName) {
      return this.currentStep === stepName;
    }

    get currentStepIndex() {
      return this.profile.steps.indexOf(this.currentStep);
    }

    get totalStepCount() {
      return this.profile.steps.length;
    }

    get isFinalStep() {
      return this.currentStep === this.finalPaymentStep;
    }

    get finalPaymentStep() {
      return this.profile.steps[this.profile.steps.length - 1] || 'formula';
    }

    isStepComplete(stepName) {
      if (!this.hasStep(stepName)) return true;
      if (this.isDiagnosticPrequalifiedReady && ['address', 'details'].includes(stepName)) return true;
      if (stepName === 'address') return this.isAddressValid();
      if (stepName === 'formula') return Boolean(this.selectedVariant?.available);
      if (stepName === 'details') return this.validateDetailsStep(false);
      if (stepName === 'calendar') {
        return Boolean(this.selectedSlot?.start && this.selectedSlot?.end && this.isCalendarIframeCurrent());
      }
      if (stepName === 'dpe-number') {
        return Boolean(
          (this.dpeNumberState.status === 'PROVIDED' && this.dpeNumberState.normalized) ||
          this.dpeNumberState.status === 'DEFERRED'
        );
      }
      return true;
    }

    validateStep(stepName, showMessage = false) {
      if (stepName === 'address') return showMessage ? this.ensureAddressReady(true) : this.isStepComplete(stepName);
      if (stepName === 'details') return this.validateDetailsStep(showMessage);
      return this.isStepComplete(stepName);
    }

    get requiresCalendar() {
      return this.hasStep('calendar');
    }

    get requiresBookingHold() {
      return !this.hasCapability('bookingLifecycle', BOOKING_LIFECYCLE_NONE);
    }

    get usesCanonicalAddressPresentation() {
      return this.hasCapability('addressPresentation', ADDRESS_PRESENTATION_CANONICAL);
    }

    get usesProjectAddressPresentation() {
      return this.hasCapability('addressPresentation', ADDRESS_PRESENTATION_PROJECT);
    }

    get usesPropertyContextAddressPresentation() {
      return this.hasCapability('addressPresentation', ADDRESS_PRESENTATION_PROPERTY_CONTEXT);
    }

    get usesFormulaCardSelection() {
      return this.hasCapability('selectionPresentation', SELECTION_PRESENTATION_FORMULA_CARDS);
    }

    get usesUniqueAvailableVariantSelection() {
      return this.hasCapability('initialVariantSelection', INITIAL_VARIANT_UNIQUE_AVAILABLE);
    }

    get usesVariantQuestionSelection() {
      return this.hasCapability('selectionPresentation', SELECTION_PRESENTATION_VARIANT_QUESTIONS);
    }

    get usesCalendarPresentation() {
      return this.hasCapability('calendarPresentation', CALENDAR_PRESENTATION_CANONICAL);
    }

    get usesCalendarSummary() {
      return this.hasCapability('summaryPresentation', SUMMARY_PRESENTATION_CALENDAR);
    }

    get usesFinalFormulaSummary() {
      return this.hasCapability('summaryPresentation', SUMMARY_PRESENTATION_FINAL_FORMULA);
    }

    get usesDecisionSummary() {
      return this.hasCapability('summaryPresentation', SUMMARY_PRESENTATION_DECISION);
    }

    get usesNoSummary() {
      return this.hasCapability('summaryPresentation', SUMMARY_PRESENTATION_NONE);
    }

    get usesExplicitFormulaConfirmation() {
      return this.hasCapability('formulaProgression', FORMULA_PROGRESSION_EXPLICIT);
    }

    get usesCanonicalZoneAddress() {
      return this.profile.addressProfile === 'required-zone-block-local';
    }

    get usesContextBoundBookingLifecycle() {
      return this.hasCapability('bookingLifecycle', BOOKING_LIFECYCLE_CONTEXT_BOUND);
    }

    get hasCalendarCapability() {
      if (!this.requiresCalendar) return false;
      if (!this.product) return true;
      const contract = this.activeContract;
      if (!contract || contract.calendarRequired !== true) return false;
      return true;
    }

    get activeContract() {
      return this.runtimeContract || V2_PRODUCT_CONTRACTS[this.product?.handle] || this.staticRouteContract || null;
    }

    get runtimeServiceSlug() {
      return this.normalizeToken(this.product?.metafields?.service_slug || this.route?.serviceSlug || '');
    }

    get usesVariantOptions() {
      return this.usesVariantQuestionSelection;
    }

    get usesDetailsStep() {
      return this.hasStep('details');
    }

    getPreviousStep(step = this.currentStep) {
      if (this.isDiagnosticPrequalifiedCandidate) return '';
      const index = this.profile.steps.indexOf(step);
      return index > 0 ? this.profile.steps[index - 1] : '';
    }

    getNextStep(step = this.currentStep) {
      if (this.isDiagnosticPrequalifiedCandidate) return '';
      const index = this.profile.steps.indexOf(step);
      return index >= 0 && index < this.profile.steps.length - 1 ? this.profile.steps[index + 1] : '';
    }

    normalizeTitle(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    }

    findUniqueVariantByNormalizedTitle(variants, normalizedTitle) {
      const matches = (variants || []).filter((variant) => this.normalizeTitle(variant.title) === normalizedTitle);
      return matches.length === 1 ? matches[0] : null;
    }

    getBilanVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findUniqueVariantByNormalizedTitle(variants, 'strategie energie'),
        this.findUniqueVariantByNormalizedTitle(variants, 'confort 365 nouvac')
      ];
    }

    getDroneVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findUniqueVariantByNormalizedTitle(variants, 'essentiel'),
        this.findUniqueVariantByNormalizedTitle(variants, 'premium')
      ];
    }

    getRe2020Variants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findUniqueVariantByNormalizedTitle(variants, 'essentiel'),
        this.findUniqueVariantByNormalizedTitle(variants, 'confort'),
        this.findUniqueVariantByNormalizedTitle(variants, 'premium')
      ];
    }

    getPermisConstruireVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findPermisConstruireVariant(variants, 'essentiel'),
        this.findPermisConstruireVariant(variants, 'confort'),
        this.findPermisConstruireVariant(variants, 'premium')
      ];
    }

    getDeclarationPrealableVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findUniqueVariantByNormalizedTitle(variants, 'essentiel'),
        this.findUniqueVariantByNormalizedTitle(variants, 'confort'),
        this.findUniqueVariantByNormalizedTitle(variants, 'premium')
      ];
    }

    getDpeProjeteVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        variants.find((variant) => this.normalizeTitle(variant.title) === 'essentiel') || null,
        variants.find((variant) => this.normalizeTitle(variant.title) === 'premium') || null
      ];
    }

    getAnimation3dVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findAnimation3dVariant(variants, 'essentiel'),
        this.findAnimation3dVariant(variants, 'premium')
      ];
    }

    getRendu3dVariants(product = this.product) {
      const variants = product?.variants || [];
      return [
        this.findUniqueVariantByNormalizedTitle(variants, 'essentiel'),
        this.findUniqueVariantByNormalizedTitle(variants, 'premium')
      ];
    }

    getContractVariants(contract, product = this.product) {
      if (!contract) return [];
      if (contract.variantResolver === 'uniqueAvailable') {
        const availableVariants = (product?.variants || []).filter((variant) => variant?.available);
        return availableVariants.length === 1 ? availableVariants : [];
      }
      if (contract.variantResolver === 're2020') return this.getRe2020Variants(product);
      if (contract.variantResolver === 'bilan') return this.getBilanVariants(product);
      if (contract.variantResolver === 'drone') return this.getDroneVariants(product);
      if (contract.variantResolver === 'dpeProjete') return this.getDpeProjeteVariants(product);
      if (contract.variantResolver === 'animation3d') return this.getAnimation3dVariants(product);
      if (contract.variantResolver === 'rendu3d') return this.getRendu3dVariants(product);
      if (contract.variantResolver === 'permisConstruire') return this.getPermisConstruireVariants(product);
      if (contract.variantResolver === 'declarationPrealable') return this.getDeclarationPrealableVariants(product);
      if (contract.variantUi === VARIANT_UI_VARIANT_OPTIONS) return product?.variants || [];
      return [];
    }

    findAnimation3dVariant(variants, formulaKey) {
      return this.findUniqueVariantByNormalizedTitle(variants, this.normalizeTitle(formulaKey));
    }

    findPermisConstruireVariant(variants, formulaKey) {
      const normalizedFormula = this.normalizeTitle(formulaKey);
      return variants.find((variant) => {
        return [variant.title, variant.option1, variant.option2, variant.option3].some((value) => this.normalizeTitle(value) === normalizedFormula);
      }) || variants.find((variant) => String(variant.id) === PERMIS_CONSTRUIRE_COMPATIBILITY_VARIANTS[formulaKey]) || null;
    }

    resolveInitialVariant(product, variantId) {
      const eligibleVariants = this.getContractVariants(this.activeContract, product).filter(Boolean);
      const requestedVariant = variantId
        ? eligibleVariants.find((variant) => String(variant.id) === String(variantId) && variant.available)
        : null;
      const selectionMode = this.getCapability('initialVariantSelection');
      if (selectionMode === INITIAL_VARIANT_UNIQUE_AVAILABLE) {
        return eligibleVariants.length === 1 ? eligibleVariants.find((variant) => variant.available) || null : null;
      }
      if (selectionMode === INITIAL_VARIANT_REQUESTED_ONLY) return requestedVariant || null;
      if (selectionMode === INITIAL_VARIANT_AUTHORIZED_DIRECT) {
        return this.route.formulaSelected ? requestedVariant : null;
      }
      return requestedVariant || eligibleVariants.find((variant) => variant.available) || null;
    }

    renderActiveFlow(offersHtml, preserveCurrentStep = false) {
      this.hideAllMessages();
      this.nodes.loading.hidden = true;
      this.nodes.content.hidden = false;
      if (this.isDiagnosticPrequalifiedCandidate) {
        if (this.nodes.options) this.nodes.options.innerHTML = '';
        this.lockDiagnosticPrequalifiedGenericControls();
      } else if (!this.renderOptions(offersHtml)) {
        return false;
      }
      this.renderDetailsStep();
      this.setContextPending(false);
      this.root.dataset.nouvacOrderFlowV2Ready = 'true';
      if (preserveCurrentStep && !this.isDiagnosticPrequalifiedCandidate) {
        this.applyDpeNumberState();
        this.renderSummary();
        this.updateButtons();
        return true;
      }
      this.showStep(this.getInitialStep());
      return true;
    }

    activateDiagnosticPrequalifiedCalendar() {
      if (!this.isDiagnosticPrequalifiedCandidate || this.contextPending || !this.product) return false;
      this.lockDiagnosticPrequalifiedGenericControls();
      this.applyBackLink(this.diagnosticReturnPath);
      if (this.currentStep !== 'calendar' && !this.showStep('calendar')) return false;
      this.registerIframeMessageListener();
      return this.renderIframe({ force: true });
    }

    getInitialStep() {
      if (this.isDiagnosticPrequalifiedCandidate) return 'calendar';
      return this.profile.steps[0] || 'formula';
    }

    renderDetailsStep() {
      if (!this.nodes.detailsPanel) return;
      if (this.isDiagnosticPrequalifiedCandidate) {
        if (this.nodes.detailsOptions) this.nodes.detailsOptions.innerHTML = '';
        if (this.nodes.detailsQuestions) this.nodes.detailsQuestions.innerHTML = '';
        this.nodes.detailsPanel.hidden = true;
        return;
      }
      if (
        this.usesVariantQuestionSelection &&
        this.nodes.detailsQuestions &&
        this.nodes.detailsOptions &&
        this.nodes.detailsQuestions.compareDocumentPosition(this.nodes.detailsOptions) & Node.DOCUMENT_POSITION_PRECEDING
      ) {
        this.nodes.detailsPanel.insertBefore(this.nodes.detailsQuestions, this.nodes.detailsOptions);
      }
      if (this.nodes.detailsOptions) {
        this.nodes.detailsOptions.innerHTML = '';
        if (this.details.html) {
          this.renderDetailsHtmlRegion('[data-nouvac-order-flow-v2-variant-options]', this.nodes.detailsOptions);
        } else if (this.usesVariantOptions) {
          this.renderVariantOptions();
        }
      }
      if (this.nodes.detailsQuestions) {
        this.nodes.detailsQuestions.innerHTML = '';
        if (this.details.html) {
          this.renderDetailsHtmlRegion('[data-nouvac-order-flow-v2-questions]', this.nodes.detailsQuestions);
        } else if (this.questions.html) {
          this.nodes.detailsQuestions.innerHTML = this.questions.html;
        } else {
          this.renderSupplementalQuestions();
        }
      }
      if (this.nodes.detailsOptions) this.nodes.detailsOptions.hidden = !this.nodes.detailsOptions.children.length;
      if (this.nodes.detailsQuestions) this.nodes.detailsQuestions.hidden = !this.nodes.detailsQuestions.children.length;
      this.updateOptionControls();
      this.updateQuestionControls();
    }

    renderDetailsHtmlRegion(selector, target) {
      const template = document.createElement('template');
      template.innerHTML = this.details.html || '';
      const region = template.content.querySelector(selector);
      if (region) target.innerHTML = region.innerHTML;
    }

    renderVariantOptions() {
      if (!this.nodes.detailsOptions) return;
      const optionNames = this.getMeaningfulOptionNames();
      optionNames.forEach((optionName, optionIndex) => {
        const values = this.getOptionValues(optionIndex);
        if (!values.length) return;
        const group = document.createElement('fieldset');
        const legend = document.createElement('legend');
        const choiceGrid = document.createElement('div');
        group.className = 'nouvac-order-flow-v2__fieldset nouvac-order-flow-v2__details-group';
        group.setAttribute('data-nouvac-order-flow-v2-option-group', '');
        group.setAttribute('data-nouvac-order-flow-v2-option-name', optionName);
        legend.textContent = optionName;
        choiceGrid.className = 'nouvac-order-flow-v2__choice-grid';
        values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'nouvac-order-flow-v2__choice-button';
          button.setAttribute('data-nouvac-order-flow-v2-option-value', value);
          button.setAttribute('data-nouvac-order-flow-v2-option-name', optionName);
          button.setAttribute('aria-pressed', 'false');
          button.textContent = value;
          choiceGrid.appendChild(button);
        });
        group.append(legend, choiceGrid);
        this.nodes.detailsOptions.appendChild(group);
      });
    }

    renderSupplementalQuestions() {
      if (!this.nodes.detailsQuestions) return;
      this.questions.schema.forEach((question) => {
        const group = document.createElement('fieldset');
        const legend = document.createElement('legend');
        const choiceGrid = document.createElement('div');
        group.className = 'nouvac-order-flow-v2__fieldset nouvac-order-flow-v2__details-group';
        group.setAttribute('data-nouvac-order-flow-v2-question', '');
        group.setAttribute('data-nouvac-order-flow-v2-question-key', question.rawKey || question.key);
        group.setAttribute('data-nouvac-order-flow-v2-question-type', question.type);
        group.setAttribute('data-nouvac-order-flow-v2-question-required', question.required ? 'true' : 'false');
        legend.textContent = question.label;
        choiceGrid.className = 'nouvac-order-flow-v2__choice-grid';
        question.allowedValues.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'nouvac-order-flow-v2__choice-button';
          button.setAttribute('data-nouvac-order-flow-v2-question-option', '');
          button.setAttribute('data-nouvac-order-flow-v2-question-key', question.rawKey || question.key);
          button.setAttribute('data-nouvac-order-flow-v2-question-value', value.value);
          button.setAttribute('aria-pressed', 'false');
          button.textContent = value.label;
          choiceGrid.appendChild(button);
        });
        group.append(legend, choiceGrid);
        this.nodes.detailsQuestions.appendChild(group);
      });
    }

    getOptionValues(optionIndex) {
      const key = `option${optionIndex + 1}`;
      const values = [];
      (this.product?.variants || []).forEach((variant) => {
        const value = this.normalizeWhitespace(variant?.[key]);
        if (value && !values.includes(value)) values.push(value);
      });
      return values;
    }

    getMeaningfulOptionNames() {
      const optionNames = Array.isArray(this.product?.options) ? this.product.options.filter(Boolean) : [];
      return optionNames.filter((optionName, optionIndex) => {
        const values = this.getOptionValues(optionIndex);
        return !(optionNames.length === 1 && values.length <= 1 && this.normalizeTitle(`${optionName} ${values[0] || ''}`).includes('default'));
      });
    }

    renderOptions(offersHtml) {
      this.nodes.options.innerHTML = '';
      if (!this.usesFormulaCardSelection && !this.usesVariantQuestionSelection) {
        this.updateSelectedControls();
        return true;
      }
      if (this.usesDetailsStep && this.usesVariantOptions) {
        this.updateSelectedControls();
        return true;
      }
      const renderer = this.renderer || {};
      const requiresCustomRenderer = renderer.custom_renderer_required === true;
      if (renderer.mode === 'custom' && offersHtml) {
        this.nodes.options.innerHTML = offersHtml;
      } else if (requiresCustomRenderer) {
        this.showOnly('configError', 'La configuration des formules est incomplète pour cette prestation.', ERROR_CATEGORIES.OFFERS_RENDERER_MISSING);
        return false;
      } else {
        this.product.variants.forEach((variant) => {
          const button = document.createElement('button');
          const title = document.createElement('span');
          const price = document.createElement('span');
          button.type = 'button';
          button.className = 'nouvac-order-flow-v2__option';
          button.setAttribute('data-nouvac-order-flow-v2-variant-button', '');
          button.setAttribute('data-nouvac-order-flow-v2-variant-id', String(variant.id));
          button.disabled = !variant.available;
          title.className = 'nouvac-order-flow-v2__option-title';
          title.textContent = variant.title;
          price.className = 'nouvac-order-flow-v2__option-price';
          price.textContent = variant.price_formatted;
          button.append(title, price);
          this.nodes.options.appendChild(button);
        });
      }
      this.updateSelectedControls();
      return true;
    }

    showStep(step) {
      if (this.isDiagnosticPrequalifiedCandidate && step !== 'calendar') return false;
      if (this.contextPending && step !== 'address') return false;
      if (!this.hasStep(step)) return false;
      this.currentStep = step;
      const stepIndex = this.currentStepIndex + 1;
      this.root.dataset.nouvacOrderFlowV2CurrentStep = step;
      this.root.dataset.nouvacOrderFlowV2FlowType = this.route?.flowType || '';
      this.root.dataset.nouvacOrderFlowV2ProductHandle = this.product?.handle || this.route?.productHandle || '';
      this.root.dataset.nouvacOrderFlowV2EntryMode = this.isDiagnosticPrequalifiedCandidate
        ? 'diagnostic-prequalified-v2-1'
        : 'generic-v2';
      this.root.dataset.nouvacOrderFlowV2AddressPresentation = this.getCapability('addressPresentation') || '';
      this.root.dataset.nouvacOrderFlowV2SelectionPresentation = this.getCapability('selectionPresentation') || '';
      this.root.dataset.nouvacOrderFlowV2FormulaPresentation = this.getCapability('formulaPresentation') || '';
      this.root.dataset.nouvacOrderFlowV2FormulaProgression = this.getCapability('formulaProgression') || '';
      this.root.dataset.nouvacOrderFlowV2CalendarPresentation = this.getCapability('calendarPresentation') || '';
      this.root.dataset.nouvacOrderFlowV2SummaryPresentation = this.getCapability('summaryPresentation') || '';
      if (step !== 'address') this.closeAddressSuggestions();
      this.nodes.step.textContent = `ÉTAPE ${stepIndex}/${this.totalStepCount}`;
      if (this.nodes.heading) this.nodes.heading.hidden = false;
      if (this.nodes.step) this.nodes.step.hidden = this.isDpeProjeteFlow && step === 'dpe-number';
      if (this.nodes.heading && this.isDpeProjeteFlow && step === 'dpe-number') this.nodes.heading.hidden = true;
      this.nodes.title.textContent = step === 'formula'
        ? (this.usesDecisionSummary || this.hasCapability('formulaPresentation', FORMULA_PRESENTATION_CURATED_GRID) ? 'Choisissez votre formule' : 'Choisir une formule')
        : step === 'address'
          ? (this.usesCanonicalAddressPresentation ? 'Quelle est l’adresse du bien ?' : (this.usesProjectAddressPresentation ? 'Saisissez l’adresse du projet' : 'Renseigner le bien'))
          : step === 'dpe-number'
            ? (this.isDpeMissingBlocked() ? 'DPE existant requis' : 'Saisissez le numéro de votre DPE')
            : step === 'details'
              ? 'Précisez votre prestation'
              : (this.isDiagnosticPrequalifiedCandidate
                ? 'Choisissez votre créneau d’intervention'
                : (this.usesCalendarPresentation ? 'Quand souhaitez-vous planifier l’intervention ?' : 'Choisir un créneau'));
      this.nodes.formulaPanel.hidden = step !== 'formula';
      this.nodes.addressPanel.hidden = step !== 'address';
      if (this.nodes.detailsPanel) this.nodes.detailsPanel.hidden = step !== 'details';
      this.nodes.calendarPanel.hidden = step !== 'calendar';
      if (this.nodes.diagnosticPrequalified) {
        this.nodes.diagnosticPrequalified.hidden = !(this.isDiagnosticPrequalifiedCandidate && step === 'calendar');
      }
      if (this.nodes.dpeNumberPanel) this.nodes.dpeNumberPanel.hidden = step !== 'dpe-number';
      this.nodes.bilanPropertyFields.forEach((node) => {
        node.hidden = !this.usesPropertyContextAddressPresentation;
      });
      if (this.nodes.calendarDuration) {
        this.nodes.calendarDuration.textContent = this.isDiagnosticPrequalifiedCandidate
          ? 'Durée estimée : 2 h à 4 h selon le logement'
          : this.isPackDiagnosticsFlow ? `Durée d’intervention estimée : ${PACK_ESTIMATED_DURATION_LABEL}` : '';
        this.nodes.calendarDuration.hidden = !this.isPackDiagnosticsFlow;
      }
      if (this.nodes.calendarTitle) {
        this.nodes.calendarTitle.textContent = this.isDiagnosticPrequalifiedCandidate
          ? 'Choisissez votre créneau'
          : 'Quand souhaitez-vous planifier l’intervention ?';
      }
      this.placeSlotStatus();
      this.placePaymentButton();
      this.renderDiagnosticPrequalifiedState();
      this.applyAddressCopy();
      this.applyDpeNumberState();
      this.renderSummary();
      this.updateButtons();
      this.renderMobileFormulaAction();
      if (!(this.profile.steps.length === 1 && step === 'formula')) {
        window.requestAnimationFrame(() => {
          const focusTarget = this.isDpeProjeteFlow && step === 'dpe-number'
            ? this.nodes.dpeTitle
            : this.nodes.heading?.hidden
            ? this.root.querySelector(`[data-nouvac-order-flow-v2-step-panel="${step}"]`)
            : this.nodes.title;
          focusTarget?.setAttribute('tabindex', '-1');
          focusTarget?.focus({ preventScroll: true });
        });
      }
      this.setInitializing(false);
      return true;
    }

    clearDiagnosticContextTimer() {
      if (!this.diagnosticContextTimer) return;
      window.clearTimeout(this.diagnosticContextTimer);
      this.diagnosticContextTimer = null;
    }

    scheduleDiagnosticContextRefresh(expiresAt) {
      this.clearDiagnosticContextTimer();
      const delay = Date.parse(expiresAt) - Date.now();
      if (!Number.isFinite(delay) || delay <= 0) {
        this.refreshExpiredDiagnosticContext();
        return;
      }
      this.diagnosticContextTimer = window.setTimeout(() => {
        this.diagnosticContextTimer = null;
        this.refreshExpiredDiagnosticContext();
      }, Math.min(delay, 2147483647));
    }

    refreshExpiredDiagnosticContext() {
      if (this.destroyed || !this.isDiagnosticPrequalifiedCandidate || this.cartCompleted) return;
      if (this.holdPending || this.cartPending || this.cartRequestPromise) {
        this.diagnosticContextTimer = window.setTimeout(() => {
          this.diagnosticContextTimer = null;
          this.refreshExpiredDiagnosticContext();
        }, 1000);
        return;
      }
      this.diagnosticResumeState = 'REFRESHING';
      this.diagnosticContextExpiresAt = '';
      this.renderDiagnosticPrequalifiedState();
      this.renderIframe({ force: true, preserveDiagnosticSelection: true });
    }

    clearDiagnosticSelection() {
      if (!this.isDiagnosticPrequalifiedCandidate) return;
      this.selectedVariant = null;
      this.selectedSlot = null;
      this.bookingHold = null;
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      this.cartPending = false;
      this.cartRequestPromise = null;
      this.cartRequestContextIdentity = '';
      this.cartCompleted = false;
    }

    clearDiagnosticPreHoldSelection() {
      if (!this.isDiagnosticPrequalifiedCandidate) return;
      this.selectedVariant = null;
      this.selectedSlot = null;
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      this.cartPending = false;
      this.cartRequestPromise = null;
      this.cartRequestContextIdentity = '';
      this.cartCompleted = false;
    }

    hasActiveDiagnosticBookingHold() {
      return Boolean(
        this.isDiagnosticPrequalifiedCandidate &&
        this.bookingHold &&
        !this.isBookingHoldExpired(this.bookingHold)
      );
    }

    lockDiagnosticPrequalifiedGenericControls() {
      if (!this.isDiagnosticPrequalifiedCandidate) return false;
      this.selectedVariant = null;
      this.selectedOptionValues = {};
      this.questionAnswers = {};
      if (this.nodes.options) this.nodes.options.innerHTML = '';
      if (this.nodes.detailsOptions) this.nodes.detailsOptions.innerHTML = '';
      if (this.nodes.detailsQuestions) this.nodes.detailsQuestions.innerHTML = '';
      [this.nodes.addressPanel, this.nodes.detailsPanel].forEach((panel) => {
        panel?.querySelectorAll?.('button, input, select, textarea').forEach((control) => {
          control.disabled = true;
        });
      });
      return true;
    }

    getCurrentDiagnosticOfferResolution() {
      if (
        !this.isDiagnosticPrequalifiedReady ||
        !this.selectedSlot?.finalOffer ||
        !this.selectedVariant?.available
      ) {
        return null;
      }
      const resolution = DIAGNOSTIC_PREQUALIFIED_API.resolveNativeVariant(this.product, this.selectedSlot);
      const exactOffer = resolution && [
        'productHandle',
        'shopifyProductId',
        'shopifyVariantId',
        'offerKey',
        'surchargeType'
      ].every((key) => resolution.finalOffer[key] === this.selectedSlot.finalOffer[key]);
      return exactOffer && String(resolution.variant.id) === String(this.selectedVariant.id)
        ? resolution
        : null;
    }

    getDiagnosticDisplayLabel(code) {
      return {
        DPE: 'DPE',
        ERP: 'ERP',
        MESURAGE: 'Mesurage',
        ELECTRICITE: 'Électricité',
        GAZ: 'Gaz',
        PLOMB: 'Plomb',
        AMIANTE: 'Amiante'
      }[code] || code;
    }

    getDiagnosticPricePresentation(value) {
      const nativeLabel = this.normalizeWhitespace(value);
      if (!nativeLabel || !/\d/.test(nativeLabel)) return nativeLabel;
      if ((nativeLabel.match(/€/g) || []).length === 1 && /€$/.test(nativeLabel)) return nativeLabel;
      const amount = nativeLabel
        .replace(/€/g, '')
        .replace(/\bEUR\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
      return amount ? `${amount}\u00a0€` : nativeLabel;
    }

    getDiagnosticInstallmentPresentation(priceCents) {
      const amount = Number(priceCents);
      if (!Number.isFinite(amount) || amount <= 0) return '';
      return `ou 3 × ${this.formatEuroCents(amount / 3)}`;
    }

    getDiagnosticFormAnswer(key) {
      const answer = this.diagnosticSummary?.formAnswers?.find((item) => item.key === key);
      return answer ? DIAGNOSTIC_PREQUALIFIED_API.getFormAnswerDisplay(answer) : null;
    }

    getDiagnosticTransactionalSummaryModel() {
      if (!this.isDiagnosticPrequalifiedReady || !this.diagnosticSummary) return null;
      const transaction = {
        vente: 'Vente',
        location: 'Location'
      }[this.diagnosticSummary.objective] || '';
      const propertyType = this.getDiagnosticFormAnswer('propertyType');
      const surface = this.getDiagnosticFormAnswer('surface') || (
        this.diagnosticSummary.surfaceBand
          ? DIAGNOSTIC_PREQUALIFIED_API.getFormAnswerDisplayValue('surface', this.diagnosticSummary.surfaceBand)
          : null
      );
      const offerResolution = this.getCurrentDiagnosticOfferResolution();
      const count = this.diagnosticSummary.diagnosticCount;
      const dossierParts = [
        `${count} diagnostic${count > 1 ? 's' : ''}`,
        transaction
      ].filter(Boolean);
      const formAnswers = Array.isArray(this.diagnosticSummary.formAnswers)
        ? this.diagnosticSummary.formAnswers
          .map((answer) => DIAGNOSTIC_PREQUALIFIED_API.getFormAnswerDisplay(answer))
          .filter(Boolean)
        : [];
      return Object.freeze({
        dossier: dossierParts.join(' · '),
        diagnostics: Object.freeze(this.diagnosticSummary.diagnostics.map((code) => this.getDiagnosticDisplayLabel(code))),
        property: [propertyType?.value, surface?.value].filter(Boolean).join(' · '),
        address: this.diagnosticSummary.address,
        formAnswers: Object.freeze(formAnswers),
        slot: offerResolution && (this.selectedSlot?.start || this.selectedSlot?.label)
          ? this.getCalendarSlotDisplayLabel(this.selectedSlot)
          : 'Sélectionnez un créneau',
        price: offerResolution
          ? this.getDiagnosticPricePresentation(offerResolution.variant.price_formatted)
          : 'Sélectionnez un créneau pour afficher votre tarif',
        installment: offerResolution
          ? this.getDiagnosticInstallmentPresentation(offerResolution.variant.price)
          : '',
        offerReady: Boolean(offerResolution)
      });
    }

    renderDiagnosticChoicesDisclosure(model) {
      const choicesAvailable = Boolean(model?.formAnswers?.length);
      if (!choicesAvailable) this.diagnosticChoicesExpanded = false;
      this.nodes.diagnosticChoicesToggles.forEach((toggle) => {
        toggle.hidden = !choicesAvailable;
        toggle.textContent = this.diagnosticChoicesExpanded ? 'Masquer mes choix' : 'Voir mes choix';
        toggle.setAttribute('aria-expanded', this.diagnosticChoicesExpanded ? 'true' : 'false');
      });
      this.nodes.diagnosticChoicesPanels.forEach((panel) => {
        panel.hidden = !choicesAvailable || !this.diagnosticChoicesExpanded;
      });
    }

    renderDiagnosticTransactionalSummary(model = this.getDiagnosticTransactionalSummaryModel()) {
      const active = Boolean(model);
      this.nodes.diagnosticSummaries.forEach((summary) => {
        summary.hidden = !active;
      });
      if (!active) {
        this.nodes.diagnosticInstallments.forEach((node) => {
          node.textContent = '';
          node.hidden = true;
        });
        this.renderDiagnosticChoicesDisclosure(null);
        return;
      }

      this.nodes.diagnosticDossiers.forEach((node) => {
        node.textContent = model.dossier;
      });
      this.nodes.diagnosticProperties.forEach((node) => {
        node.textContent = model.property;
        node.hidden = !model.property;
      });
      this.nodes.diagnosticAddresses.forEach((node) => {
        node.textContent = model.address;
      });
      this.nodes.diagnosticSlots.forEach((node) => {
        node.textContent = model.slot;
      });
      this.nodes.diagnosticPrices.forEach((node) => {
        node.textContent = model.price;
      });
      this.nodes.diagnosticInstallments.forEach((node) => {
        node.textContent = model.installment;
        node.hidden = !model.installment;
      });
      this.nodes.diagnosticPaymentHelpers.forEach((node) => {
        node.hidden = model.offerReady;
      });
      this.nodes.diagnosticChipLists.forEach((list) => {
        list.replaceChildren();
        model.diagnostics.forEach((diagnostic) => {
          const item = document.createElement('li');
          item.textContent = diagnostic;
          list.appendChild(item);
        });
      });
      this.nodes.diagnosticFormAnswerLists.forEach((list) => {
        list.replaceChildren();
        model.formAnswers.forEach((answer) => {
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          row.className = 'nouvac-order-flow-v2__diagnostic-answer';
          row.setAttribute('data-nouvac-order-flow-v2-diagnostic-answer-key', answer.key);
          term.textContent = answer.label;
          description.textContent = answer.value;
          row.append(term, description);
          list.appendChild(row);
        });
      });
      this.renderDiagnosticChoicesDisclosure(model);
    }

    toggleDiagnosticChoices() {
      const model = this.getDiagnosticTransactionalSummaryModel();
      if (!model?.formAnswers?.length) return;
      this.diagnosticChoicesExpanded = !this.diagnosticChoicesExpanded;
      this.renderDiagnosticChoicesDisclosure(model);
    }

    renderDiagnosticPrequalifiedState() {
      if (!this.nodes.diagnosticPrequalified) return;
      const active = this.isDiagnosticPrequalifiedCandidate && this.currentStep === 'calendar';
      this.nodes.diagnosticPrequalified.hidden = !active;
      if (this.nodes.diagnosticWeekendNote) {
        this.nodes.diagnosticWeekendNote.hidden = !(active && this.isDiagnosticPrequalifiedReady);
      }
      if (this.nodes.diagnosticReassurance) {
        this.nodes.diagnosticReassurance.hidden = !(active && this.isDiagnosticPrequalifiedReady);
      }
      if (!active) return;

      const ready = this.isDiagnosticPrequalifiedReady;
      if (this.nodes.back) this.nodes.back.hidden = ready;
      if (this.nodes.calendarStep) this.nodes.calendarStep.hidden = ready;

      const stateMessages = {
        NONE: 'Vérification sécurisée de votre demande…',
        VERIFYING: 'Vérification sécurisée de votre demande…',
        REFRESHING: 'Actualisation sécurisée des disponibilités…',
        READY: 'Votre demande est vérifiée. Choisissez une date et une heure disponibles.',
        MANUAL: 'Cette demande nécessite un accompagnement. Un conseiller NOUVAC reviendra vers vous.',
        FAILED: this.diagnosticFailureMessage || 'Impossible de reprendre cette réservation. Vous pouvez réessayer ou effectuer une nouvelle demande.'
      };
      if (this.nodes.diagnosticState) {
        this.nodes.diagnosticState.textContent = stateMessages[this.diagnosticResumeState] || stateMessages.NONE;
        this.nodes.diagnosticState.hidden = ready;
      }
      if (this.nodes.diagnosticReturn) {
        this.nodes.diagnosticReturn.hidden = !['MANUAL', 'FAILED'].includes(this.diagnosticResumeState) ||
          this.diagnosticFailureCode === 'DIAGNOSTIC_SESSION_EXPIRED';
      }
      this.root.dataset.nouvacDiagnosticPrequalifiedOffer = this.getCurrentDiagnosticOfferResolution() ? 'ready' : 'pending';
      this.root.dataset.nouvacDiagnosticPrequalifiedState = this.diagnosticResumeState.toLowerCase();
      this.placePaymentButton();
    }

    applyAddressCopy() {
      if (this.nodes.addressLabel) {
        this.nodes.addressLabel.textContent = this.usesProjectAddressPresentation ? 'Adresse ou ville du projet' : 'Adresse du bien';
      }
      if (this.nodes.stepText) {
        this.nodes.stepText.textContent = '';
        this.nodes.stepText.hidden = true;
      }
      if (this.nodes.addressHelper) {
        this.nodes.addressHelper.textContent = this.activeContract?.addressHelperText || (this.usesCanonicalZoneAddress
          ? 'Votre adresse nous permet de vérifier si nos diagnostiqueurs interviennent dans votre zone.'
          : this.usesCanonicalAddressPresentation && this.usesRequiredNoBlockAddress()
          ? 'Indiquez l’adresse, la ville ou le code postal du bien concerné.'
          : this.usesProjectAddressPresentation
          ? 'Cela permet à nos équipes de situer votre projet. Si vous ne connaissez pas l’adresse exacte, veuillez renseigner simplement la ville.'
          : '');
        this.nodes.addressHelper.hidden = !(
          this.usesProjectAddressPresentation ||
          (this.usesCanonicalAddressPresentation && this.usesRequiredNoBlockAddress()) ||
          this.usesCanonicalZoneAddress
        );
      }
      if (this.nodes.backFormula) {
        this.nodes.backFormula.textContent = this.usesProjectAddressPresentation ? 'Modifier la formule' : 'Retour';
      }
      if (this.nodes.addressExtraFields) {
        this.nodes.addressExtraFields.hidden = !this.usesPropertyContextAddressPresentation;
      }
    }

    selectVariant(variantId, updateUrl) {
      if (this.contextPending || this.isDiagnosticPrequalifiedCandidate) return false;
      const eligibleVariants = this.getContractVariants(this.activeContract).filter(Boolean);
      const variant = eligibleVariants.find((item) => String(item.id) === String(variantId) && item.available);
      if (!variant || this.cartPending || this.holdPending) return false;
      const variantChanged = String(this.selectedVariant?.id || '') !== String(variant.id);
      this.selectedVariant = variant;
      if (this.nodes.variantError) this.nodes.variantError.hidden = true;
      if (variantChanged && this.requiresCalendar) this.clearCalendarState();
      this.updateSelectedControls();
      this.renderSummary();
      this.updateButtons();
      this.renderMobileFormulaAction();
      if (variantChanged && this.hasCalendarCapability && this.currentStep === 'calendar') this.renderIframe();
      if (updateUrl) this.replaceVariantInUrl(variant.id, this.hasCapability('markFormulaSelectionInUrl'));
      return true;
    }

    updateSelectedControls() {
      this.root.querySelectorAll('[data-nouvac-order-flow-v2-variant-button]').forEach((button) => {
        const selected = this.selectedVariant && button.getAttribute('data-nouvac-order-flow-v2-variant-id') === String(this.selectedVariant.id);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-selected', selected);
        button.closest('[data-nouvac-order-flow-v2-formula-card]')?.classList.toggle('is-selected', selected);
      });
    }

    updateOptionControls() {
      this.root.querySelectorAll('[data-nouvac-order-flow-v2-option-value]').forEach((button) => {
        const optionName = button.getAttribute('data-nouvac-order-flow-v2-option-name') || '';
        const optionValue = button.getAttribute('data-nouvac-order-flow-v2-option-value') || '';
        const selected = this.selectedOptionValues[optionName] === optionValue;
        const available = this.isOptionValueAvailable(optionName, optionValue);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
        button.disabled = !available;
        button.classList.toggle('is-selected', selected);
        button.classList.toggle('is-unavailable', !available);
        button.closest('[data-nouvac-order-flow-v2-option-state]')?.classList.toggle('is-selected', selected);
      });
    }

    isOptionValueAvailable(optionName, optionValue) {
      const canonicalOptionName = this.getCanonicalOptionName(optionName);
      const canonicalOptionValue = this.normalizeWhitespace(optionValue);
      const optionNames = this.getMeaningfulOptionNames();
      if (!canonicalOptionName || !canonicalOptionValue || !optionNames.length) return true;
      return (this.product?.variants || []).some((variant) => {
        if (!variant.available) return false;
        return optionNames.every((name) => {
          const productOptionIndex = (this.product?.options || []).indexOf(name);
          const variantOptionValue = productOptionIndex >= 0 ? this.normalizeWhitespace(variant[`option${productOptionIndex + 1}`]) : '';
          if (name === canonicalOptionName) return variantOptionValue === canonicalOptionValue;
          const selectedOptionValue = this.selectedOptionValues[name];
          return !selectedOptionValue || variantOptionValue === selectedOptionValue;
        });
      });
    }

    updateQuestionControls() {
      this.root.querySelectorAll('[data-nouvac-order-flow-v2-question-option]').forEach((button) => {
        const key = this.normalizeToken(button.getAttribute('data-nouvac-order-flow-v2-question-key'));
        const selected = this.questionAnswers[key] === this.normalizeToken(button.getAttribute('data-nouvac-order-flow-v2-question-value'));
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.classList.toggle('is-selected', selected);
        button.closest('[data-nouvac-order-flow-v2-question-state]')?.classList.toggle('is-selected', selected);
      });
    }

    selectVariantOption(optionName, optionValue) {
      const canonicalOptionName = this.getCanonicalOptionName(optionName);
      const canonicalOptionValue = this.normalizeWhitespace(optionValue);
      if (this.contextPending || this.isDiagnosticPrequalifiedCandidate || !canonicalOptionName || !canonicalOptionValue || this.cartPending || this.holdPending) return false;
      const previousCalendarContextIdentity = this.getCalendarContextIdentity();
      this.selectedOptionValues = {
        ...this.selectedOptionValues,
        [canonicalOptionName]: canonicalOptionValue
      };
      const resolvedVariant = this.resolveVariantFromOptions();
      this.selectedVariant = resolvedVariant;
      if (
        this.requiresCalendar &&
        previousCalendarContextIdentity !== this.getCalendarContextIdentity()
      ) {
        this.clearCalendarState();
      }
      this.clearDetailsStatus();
      this.updateOptionControls();
      this.renderSummary();
      this.updateButtons();
      return Boolean(resolvedVariant);
    }

    selectQuestionAnswer(questionKey, questionValue) {
      const question = this.getQuestionSchema(questionKey);
      const value = this.normalizeToken(questionValue);
      if (this.contextPending || this.isDiagnosticPrequalifiedCandidate || !question || !this.getQuestionValueSchema(question, value) || this.cartPending || this.holdPending) {
        this.showDetailsStatus('Cette réponse n’est pas disponible.', ERROR_CATEGORIES.INVALID_QUESTION_VALUE);
        return false;
      }
      const previousCalendarContextIdentity = this.getCalendarContextIdentity();
      this.questionAnswers = {
        ...this.questionAnswers,
        [question.key]: value
      };
      if (this.requiresCalendar && previousCalendarContextIdentity !== this.getCalendarContextIdentity()) this.clearCalendarState();
      this.clearDetailsStatus();
      this.updateQuestionControls();
      this.renderSummary();
      this.updateButtons();
      return true;
    }

    getCanonicalOptionName(optionName) {
      const requested = this.normalizeToken(optionName);
      const optionNames = Array.isArray(this.product?.options) ? this.product.options : [];
      return optionNames.find((name) => this.normalizeToken(name) === requested) || '';
    }

    resolveVariantFromOptions() {
      if (this.isDiagnosticPrequalifiedCandidate) return null;
      const optionNames = this.getMeaningfulOptionNames();
      if (!optionNames.length || optionNames.some((name) => !this.selectedOptionValues[name])) return null;
      const matches = (this.product?.variants || []).filter((variant) => {
        return optionNames.every((name) => {
          const productOptionIndex = (this.product?.options || []).indexOf(name);
          return productOptionIndex >= 0 && this.normalizeWhitespace(variant[`option${productOptionIndex + 1}`]) === this.selectedOptionValues[name];
        });
      });
      return matches.length === 1 && matches[0].available ? matches[0] : null;
    }

    selectOptionsFromVariant(variant) {
      if (this.isDiagnosticPrequalifiedCandidate) {
        this.selectedOptionValues = {};
        return;
      }
      const optionNames = this.getMeaningfulOptionNames();
      this.selectedOptionValues = optionNames.reduce((values, optionName) => {
        const productOptionIndex = (this.product?.options || []).indexOf(optionName);
        const optionValue = productOptionIndex >= 0 ? this.normalizeWhitespace(variant?.[`option${productOptionIndex + 1}`]) : '';
        if (optionValue) values[optionName] = optionValue;
        return values;
      }, {});
    }

    areVariantOptionsComplete() {
      const optionNames = this.getMeaningfulOptionNames();
      return Boolean(optionNames.length && optionNames.every((name) => this.selectedOptionValues[name]));
    }

    getQuestionSchema(questionKey) {
      const key = this.normalizeToken(questionKey);
      return this.questions.schema.find((item) => item.key === key) || null;
    }

    getQuestionValueSchema(question, value) {
      return question?.allowedValues?.find((item) => item.value === this.normalizeToken(value)) || null;
    }

    validateDetailsStep(showMessage = false) {
      if (this.usesVariantOptions && !this.selectedVariant?.available) {
        if (showMessage) {
          this.showDetailsStatus(
            this.areVariantOptionsComplete() ? 'Cette combinaison n’est pas disponible.' : 'Veuillez sélectionner les caractéristiques de votre prestation.',
            this.areVariantOptionsComplete() ? ERROR_CATEGORIES.VARIANT_UNAVAILABLE : ERROR_CATEGORIES.VARIANT_REQUIRED
          );
        }
        return false;
      }
      const missingQuestion = this.questions.schema.find((question) => {
        if (!question.required) return false;
        const answer = this.questionAnswers[question.key];
        return !answer || !this.getQuestionValueSchema(question, answer);
      });
      if (missingQuestion) {
        if (showMessage) this.showDetailsStatus(missingQuestion.validationMessage || 'Veuillez répondre aux questions obligatoires.', ERROR_CATEGORIES.QUESTIONS_REQUIRED);
        return false;
      }
      this.clearDetailsStatus();
      return true;
    }

    showDetailsStatus(message, category) {
      if (!this.nodes.detailsStatus) return;
      this.nodes.detailsStatus.textContent = message;
      this.nodes.detailsStatus.dataset.nouvacOrderFlowV2ErrorCategory = category;
      this.nodes.detailsStatus.hidden = false;
      window.requestAnimationFrame(() => {
        this.nodes.detailsStatus.setAttribute('tabindex', '-1');
        this.nodes.detailsStatus.focus({ preventScroll: false });
      });
    }

    clearDetailsStatus() {
      if (!this.nodes.detailsStatus) return;
      this.nodes.detailsStatus.textContent = '';
      this.nodes.detailsStatus.hidden = true;
    }

    clearCalendarState() {
      if (this.cartController) this.cartController.abort();
      this.cartController = null;
      this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
      this.selectedSlot = null;
      this.bookingHold = null;
      this.holdPending = false;
      this.cartPending = false;
      this.clearHoldResponseTimer();
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      this.cartRequestPromise = null;
      this.cartRequestContextIdentity = '';
      this.cartCompleted = false;
      if (this.nodes.slotStatus) this.nodes.slotStatus.textContent = 'Sélectionnez un créneau dans le calendrier.';
      this.updateSlotStatus();
      return true;
    }

    getObsoleteAddressRetentionKey() {
      const contract = this.activeContract;
      const productHandle = this.normalizeToken(this.product?.handle);
      const serviceSlug = this.normalizeToken(contract?.serviceSlug);
      const canonicalServiceSlug = this.normalizeToken(this.product?.metafields?.service_slug);
      if (
        this.contextPending ||
        !this.runtimeContract ||
        !this.hasStep('address') ||
        contract?.addressMode === 'none' ||
        productHandle !== this.normalizeToken(contract?.productHandle) ||
        serviceSlug !== canonicalServiceSlug ||
        !PRODUCT_HANDLE_PATTERN.test(productHandle) ||
        !PRODUCT_HANDLE_PATTERN.test(serviceSlug)
      ) {
        return '';
      }
      return `${OBSOLETE_ADDRESS_RETENTION_KEY_PREFIX}_${productHandle}_${serviceSlug}`;
    }

    removeAddressRetentionStorage(key = this.getObsoleteAddressRetentionKey()) {
      if (!key) return;
      try {
        window.localStorage?.removeItem(key);
      } catch (error) {
        // Functional form retention must never block the live Address flow.
      }
    }

    clearObsoleteAddressRetention() {
      const contract = this.activeContract;
      if (this.contextPending || !this.product || !contract) return;
      try {
        this.removeAddressRetentionStorage();
        if (
          this.product.handle === PACK_DIAGNOSTICS_PRODUCT_HANDLE &&
          contract.serviceSlug === PACK_DIAGNOSTICS_SERVICE_SLUG
        ) {
          LEGACY_PACK_ADDRESS_STORAGE_KEYS.forEach((key) => window.localStorage?.removeItem(key));
        }
      } catch (error) {
        // Known legacy cleanup is best-effort and must not block the live Address flow.
      }
    }

    clearRetainedAddress() {
      this.removeAddressRetentionStorage();
    }

    syncAddressState() {
      if (this.isDiagnosticPrequalifiedCandidate) return false;
      const normalizeAddressValue = (value) => this.hasCapability('normalizeAddressWhitespace')
        ? this.normalizeWhitespace(value)
        : String(value || '').trim();
      const addressLine = normalizeAddressValue(this.nodes.addressLine?.value || '');
      const matchedSelectedAddress = this.selectedAddress?.label === addressLine ? this.selectedAddress : null;
      const manualCompleteAddress = !matchedSelectedAddress && (this.usesRequiredCompleteNoBlockAddress() || this.requiresPublicCoverageCheck)
        ? this.getManualAddressCandidate()
        : null;
      const ignoresHiddenLocalityFields = this.usesCanonicalZoneAddress || this.usesRequiredCompleteNoBlockAddress();
      const postcode = matchedSelectedAddress?.postcode ||
        manualCompleteAddress?.postcode ||
        (ignoresHiddenLocalityFields ? '' : normalizeAddressValue(this.nodes.postcode?.value || ''));
      const city = matchedSelectedAddress?.city ||
        manualCompleteAddress?.city ||
        (ignoresHiddenLocalityFields ? '' : normalizeAddressValue(this.nodes.city?.value || ''));
      const department = matchedSelectedAddress?.department || postcode.slice(0, 2);
      const longitude = matchedSelectedAddress?.longitude !== undefined ? matchedSelectedAddress.longitude : '';
      const latitude = matchedSelectedAddress?.latitude !== undefined ? matchedSelectedAddress.latitude : '';
      const coordinates = longitude !== '' && latitude !== ''
        ? `${longitude},${latitude}`
        : '';
      const nextAddressState = {
        addressLine,
        postcode,
        city,
        department,
        coordinates,
        propertyType: this.nodes.propertyTypes.find((input) => input.checked)?.value || '',
        surface: normalizeAddressValue(this.nodes.surface?.value || '')
      };
      const previousCalendarContextIdentity = this.getCalendarContextIdentity(this.addressState);
      const nextCalendarContextIdentity = this.getCalendarContextIdentity(nextAddressState);
      const previousCoverageContextIdentity = this.getCoverageContextIdentity(this.addressState);
      const nextCoverageContextIdentity = this.getCoverageContextIdentity(nextAddressState);
      const calendarContextChanged = this.requiresCalendar && previousCalendarContextIdentity !== nextCalendarContextIdentity;
      this.addressState = nextAddressState;
      if (previousCoverageContextIdentity !== nextCoverageContextIdentity) this.invalidateCoverage();
      if (calendarContextChanged) this.clearCalendarState();
      this.renderSummary();
      this.updateButtons();
      if (calendarContextChanged && this.currentStep === 'calendar') this.renderIframe();
    }

    handleAddressInput() {
      this.clearRetainedAddress();
      if (!this.usesAddressAutocomplete()) {
        this.syncAddressState();
        return;
      }
      window.clearTimeout(this.addressDebounceTimer);
      const inputValue = this.normalizeWhitespace(this.nodes.addressLine?.value || '');
      const query = this.normalizeAddressQuery(inputValue);

      if (this.selectedAddress && inputValue !== this.selectedAddress.label) {
        this.selectedAddress = null;
        this.addressCoordinates = null;
        this.setAddressStatus('');
      }

      this.syncAddressState();

      if (query.length < ADDRESS_MIN_QUERY_LENGTH) {
        if (this.addressController) this.addressController.abort();
        this.closeAddressSuggestions();
        if (!this.selectedAddress) this.setAddressStatus('');
        return;
      }

      this.setAddressStatus(ADDRESS_STATUS_LOADING);
      this.addressDebounceTimer = window.setTimeout(() => {
        this.fetchAddressSuggestions(query)
          .then((suggestions) => {
            this.addressSuggestions = suggestions;
            this.activeAddressIndex = -1;
            this.renderAddressSuggestions();
            this.setAddressStatus(suggestions.length ? '' : ADDRESS_STATUS_EMPTY);
          })
          .catch((error) => {
            if (error?.name === 'AbortError') return;
            this.closeAddressSuggestions();
            this.setAddressStatus(ADDRESS_STATUS_ERROR, 'error');
          });
      }, ADDRESS_DEBOUNCE_DELAY);
    }

    handleAddressKeydown(event) {
      if (event.key === 'Escape') {
        this.closeAddressSuggestions();
        return;
      }

      if (this.nodes.addressSuggestions?.hidden || !this.addressSuggestions.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.activeAddressIndex = Math.min(this.activeAddressIndex + 1, this.addressSuggestions.length - 1);
        this.renderAddressSuggestions();
        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.activeAddressIndex = Math.max(this.activeAddressIndex - 1, 0);
        this.renderAddressSuggestions();
        return;
      }

      if (event.key === 'Enter' && this.activeAddressIndex >= 0) {
        event.preventDefault();
        this.selectAddressSuggestion(this.activeAddressIndex);
      }
    }

    normalizeAddressQuery(value) {
      return this.normalizeWhitespace(value).toLowerCase();
    }

    parseAddressFeature(feature) {
      const properties = feature?.properties || {};
      const coordinates = Array.isArray(feature?.geometry?.coordinates) ? feature.geometry.coordinates : [];
      const postcode = String(properties.postcode || '');

      return {
        label: properties.label || properties.name || '',
        streetNumber: properties.housenumber || '',
        street: properties.street || '',
        postcode,
        city: properties.city || properties.municipality || properties.name || '',
        department: postcode.slice(0, 2),
        longitude: coordinates.length >= 2 ? coordinates[0] : '',
        latitude: coordinates.length >= 2 ? coordinates[1] : '',
        source: 'geopf'
      };
    }

    cacheAddressResults(query, results) {
      if (this.addressCache.has(query)) this.addressCache.delete(query);
      this.addressCache.set(query, results);
      if (this.addressCache.size > ADDRESS_CACHE_LIMIT) {
        this.addressCache.delete(this.addressCache.keys().next().value);
      }
    }

    async fetchAddressSuggestions(query) {
      if (this.addressCache.has(query)) return this.addressCache.get(query);

      if (this.addressController) this.addressController.abort();
      this.addressController = new AbortController();

      const params = new URLSearchParams({
        q: query,
        limit: String(ADDRESS_LIMIT)
      });

      const response = await fetch(`${ADDRESS_GEOCODING_ENDPOINT}?${params.toString()}`, {
        method: 'GET',
        signal: this.addressController.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Address request failed.');
      const payload = await response.json();
      const suggestions = Array.isArray(payload?.features)
        ? payload.features.map((feature) => this.parseAddressFeature(feature)).filter((item) => item.label).slice(0, ADDRESS_LIMIT)
        : [];
      this.cacheAddressResults(query, suggestions);
      return suggestions;
    }

    closeAddressSuggestions() {
      if (!this.nodes.addressSuggestions) return;
      this.nodes.addressSuggestions.innerHTML = '';
      this.nodes.addressSuggestions.hidden = true;
      this.activeAddressIndex = -1;
      if (this.nodes.addressLine) {
        this.nodes.addressLine.setAttribute('aria-expanded', 'false');
        this.nodes.addressLine.removeAttribute('aria-activedescendant');
      }
    }

    renderAddressSuggestions() {
      if (!this.nodes.addressSuggestions || !this.nodes.addressLine) return;
      this.nodes.addressSuggestions.innerHTML = '';
      if (!this.addressSuggestions.length) {
        this.closeAddressSuggestions();
        return;
      }

      this.addressSuggestions.forEach((item, index) => {
        const option = document.createElement('li');
        const button = document.createElement('button');
        const optionId = `${this.nodes.addressSuggestions.id}-option-${index}`;
        option.id = optionId;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', index === this.activeAddressIndex ? 'true' : 'false');
        button.type = 'button';
        button.className = `nouvac-order-flow-v2__address-suggestion${index === this.activeAddressIndex ? ' is-active' : ''}`;
        button.setAttribute('data-nouvac-order-flow-v2-address-suggestion-index', String(index));
        button.textContent = item.label;
        option.appendChild(button);
        this.nodes.addressSuggestions.appendChild(option);
      });
      this.nodes.addressSuggestions.hidden = false;
      this.nodes.addressLine.setAttribute('aria-expanded', 'true');
      if (this.activeAddressIndex >= 0) {
        this.nodes.addressLine.setAttribute('aria-activedescendant', `${this.nodes.addressSuggestions.id}-option-${this.activeAddressIndex}`);
      } else {
        this.nodes.addressLine.removeAttribute('aria-activedescendant');
      }
    }

    selectAddressSuggestion(index) {
      const suggestion = this.addressSuggestions[index];
      if (!suggestion || !this.nodes.addressLine) return;

      window.clearTimeout(this.addressDebounceTimer);
      this.selectedAddress = suggestion;
      this.nodes.addressLine.value = suggestion.label;
      if (this.nodes.postcode) this.nodes.postcode.value = suggestion.postcode;
      if (this.nodes.city) this.nodes.city.value = suggestion.city;
      this.addressCoordinates = {
        label: suggestion.label,
        longitude: suggestion.longitude,
        latitude: suggestion.latitude
      };
      this.closeAddressSuggestions();
      this.syncAddressState();

      if (this.usesRequiredCompleteNoBlockAddress() && !this.isCompleteStructuredAddress(suggestion, true)) {
        this.setAddressStatus('Sélectionnez une adresse complète avec un code postal et une ville.', 'error');
        return;
      }

      this.setAddressStatus(ADDRESS_STATUS_SELECTED, 'valid');
    }

    getManualStructuredStreet(label, postcode, city) {
      const addressLine = this.getMeaningfulStructuredAddressLine({ addressLine: label, postcode, city });
      const match = addressLine.match(/^(\d+[A-Za-z]?(?:\s*(?:bis|ter|quater))?(?:[-/]\d+[A-Za-z]?)?)\s+(.+)$/i);
      if (!match) return { streetNumber: '', street: '' };
      const streetNumber = this.normalizeWhitespace(match[1]);
      const street = this.normalizeWhitespace(match[2].replace(/[,\s-]+$/, ''));
      if (street.length < 3 || !/[a-z]/.test(this.normalizeTitle(street))) {
        return { streetNumber: '', street: '' };
      }
      return { streetNumber, street };
    }

    getManualAddressCandidate() {
      const label = this.normalizeWhitespace(this.nodes.addressLine?.value || '');
      const requiresCanonicalCompleteAddress = this.usesCanonicalZoneAddress ||
        this.usesRequiredCompleteNoBlockAddress() ||
        (this.requiresPublicCoverageCheck && !this.usesPropertyContextAddressPresentation);
      const postcode = requiresCanonicalCompleteAddress
        ? label.match(/\b\d{5}\b/)?.[0] || ''
        : this.normalizeWhitespace(this.nodes.postcode?.value || '') || label.match(/\b\d{5}\b/)?.[0] || '';
      const city = requiresCanonicalCompleteAddress
        ? this.extractCityFromManualAddress(label, postcode)
        : this.normalizeWhitespace(this.nodes.city?.value || '') || (postcode ? '' : label);
      const structuredStreet = this.getManualStructuredStreet(label, postcode, city);
      if (this.usesRequiredNoBlockAddress()) {
        if (label.length < 2) return null;
        return {
          label,
          ...structuredStreet,
          postcode,
          city,
          department: postcode ? postcode.slice(0, 2) : '',
          longitude: '',
          latitude: '',
          source: 'manual'
        };
      }

      const candidate = {
        label,
        ...structuredStreet,
        postcode,
        city,
        department: postcode.slice(0, 2),
        longitude: '',
        latitude: '',
        source: 'manual'
      };
      if (!this.isCompleteStructuredAddress(candidate, this.usesRequiredCompleteNoBlockAddress())) return null;
      return candidate;
    }

    extractCityFromManualAddress(label, postcode) {
      if (!postcode) return '';
      const parts = String(label || '').split(postcode);
      if (parts.length < 2) return '';
      return this.normalizeWhitespace(parts.slice(1).join(postcode).replace(/^[,\s-]+/, ''));
    }

    validateManualAddress(showMessage = true) {
      const candidate = this.getManualAddressCandidate();
      if (!candidate) {
        if (showMessage) {
          this.setAddressStatus(
            this.usesRequiredNoBlockAddress()
              ? 'Saisissez une adresse, une ville ou un code postal.'
              : this.usesRequiredCompleteNoBlockAddress()
                ? 'Saisissez une adresse complète avec un code postal et une ville.'
                : 'Saisissez une adresse avec un code postal valide.',
            'error'
          );
        }
        return false;
      }

      this.selectedAddress = candidate;
      this.addressCoordinates = null;
      window.clearTimeout(this.addressDebounceTimer);
      if (this.addressController) this.addressController.abort();
      this.abortCoverageRequest();
      this.clearHandshakeTimer();
      this.clearHoldResponseTimer();
      this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
      this.closeAddressSuggestions();
      if (this.nodes.postcode && !this.nodes.postcode.value && candidate.postcode) this.nodes.postcode.value = candidate.postcode;
      if (this.nodes.city && !this.nodes.city.value && candidate.city) this.nodes.city.value = candidate.city;
      this.syncAddressState();
      if (showMessage) this.setAddressStatus(ADDRESS_STATUS_MANUAL, 'valid');
      return true;
    }

    ensureAddressReady(showMessage = true) {
      if (!this.hasStep('address')) return true;
      const inputValue = this.normalizeWhitespace(this.nodes.addressLine?.value || '');
      if (this.selectedAddress && this.selectedAddress.label === inputValue) {
        this.syncAddressState();
        const valid = this.isAddressValid();
        if (!valid && showMessage && this.usesRequiredCompleteNoBlockAddress()) {
          this.setAddressStatus('Sélectionnez une adresse complète avec un code postal et une ville.', 'error');
        }
        return valid;
      }
      return this.validateManualAddress(showMessage) && this.isAddressValid();
    }

    usesAddressAutocomplete() {
      if (this.contextPending && this.profile.steps[0] === 'address') return true;
      return this.hasStep('address') && this.activeContract?.addressMode !== 'none';
    }

    usesRequiredNoBlockAddress() {
      return this.activeContract?.addressMode === 'required-no-block';
    }

    usesRequiredCompleteNoBlockAddress() {
      return this.activeContract?.addressMode === 'required-complete-no-block';
    }

    usesAddressZoneRestriction() {
      return this.activeContract?.addressMode === 'required-zone-block-local';
    }

    get requiresPublicCoverageCheck() {
      return Boolean(
        this.hasStep('address') &&
        !this.requiresCalendar &&
        this.activeContract?.addressMode &&
        this.activeContract.addressMode !== 'none'
      );
    }

    getCoverageContextIdentity(addressState = this.addressState) {
      if (!this.requiresPublicCoverageCheck) return '';
      return JSON.stringify({
        serviceSlug: this.normalizeToken(this.runtimeServiceSlug),
        addressLine: this.normalizeWhitespace(addressState.addressLine),
        postcode: this.normalizeWhitespace(addressState.postcode),
        city: this.normalizeWhitespace(addressState.city)
      });
    }

    abortCoverageRequest() {
      if (this.coverageController) this.coverageController.abort();
      this.coverageController = null;
      this.coverageRequestIdentity = '';
      this.coveragePending = false;
    }

    invalidateCoverage() {
      this.abortCoverageRequest();
      this.coveredContextIdentity = '';
      this.coverageRetryRequired = false;
    }

    isPublicCoverageAddressStructurallyValid() {
      return Boolean(
        this.addressState.addressLine.length >= 2 &&
        this.addressState.addressLine.length <= 200 &&
        /^\d{5}$/.test(this.addressState.postcode) &&
        this.addressState.city.length >= 1 &&
        this.addressState.city.length <= 200 &&
        this.runtimeServiceSlug.length <= 200 &&
        PRODUCT_HANDLE_PATTERN.test(this.runtimeServiceSlug)
      );
    }

    async ensurePublicCoverage() {
      if (!this.requiresPublicCoverageCheck) return true;
      const identity = this.getCoverageContextIdentity();
      if (identity && identity === this.coveredContextIdentity) return true;
      if (this.coveragePending || !identity) return false;
      if (!this.runtimeServiceSlug || !this.isPublicCoverageAddressStructurallyValid()) {
        this.setAddressStatus(
          this.runtimeServiceSlug
            ? 'Saisissez un code postal à cinq chiffres et une ville.'
            : 'Cette prestation ne peut pas être vérifiée pour le moment.',
          'error'
        );
        return false;
      }

      this.abortCoverageRequest();
      const controller = new AbortController();
      this.coverageController = controller;
      this.coverageRequestIdentity = identity;
      this.coveragePending = true;
      this.coverageRetryRequired = false;
      this.setAddressStatus('Vérification de la zone d’intervention...');
      this.updateButtons();

      try {
        const body = {
          serviceSlug: this.runtimeServiceSlug,
          postcode: this.addressState.postcode,
          city: this.addressState.city,
          ...(this.addressState.addressLine ? { addressLine: this.addressState.addressLine } : {})
        };
        const response = await fetch(`${this.extranetOrigin}${PUBLIC_COVERAGE_PATH}`, {
          method: 'POST',
          credentials: 'omit',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        let result = null;
        try {
          result = await response.json();
        } catch (error) {
          result = null;
        }
        if (
          this.destroyed ||
          controller !== this.coverageController ||
          identity !== this.getCoverageContextIdentity()
        ) {
          return false;
        }
        const validResult = response.ok &&
          this.isPlainObject(result) &&
          this.hasOnlyKeys(result, ['contractVersion', 'status']) &&
          result.contractVersion === PUBLIC_COVERAGE_CONTRACT_VERSION &&
          COVERAGE_STATUSES.has(result.status);
        if (!validResult || result.status === 'TEMPORARY_FAILURE') {
          this.coverageRetryRequired = true;
          this.setAddressStatus('La vérification est temporairement indisponible. Cliquez sur Réessayer.', 'error');
          return false;
        }
        if (result.status === 'OUTSIDE_COVERAGE') {
          this.setAddressStatus(ADDRESS_OUTSIDE_ZONE_MESSAGE, 'error');
          return false;
        }
        if (result.status === 'INVALID_ADDRESS') {
          this.setAddressStatus('Cette adresse doit être corrigée avant de continuer.', 'error');
          return false;
        }
        if (result.status === 'SERVICE_UNAVAILABLE') {
          this.setAddressStatus('Cette prestation est temporairement indisponible à cette adresse.', 'error');
          return false;
        }
        this.coveredContextIdentity = identity;
        this.setAddressStatus('Adresse couverte. Les disponibilités éventuelles seront confirmées séparément.', 'valid');
        return true;
      } catch (error) {
        if (error?.name === 'AbortError') return false;
        if (controller === this.coverageController && identity === this.getCoverageContextIdentity()) {
          this.coverageRetryRequired = true;
          this.setAddressStatus('La vérification est temporairement indisponible. Cliquez sur Réessayer.', 'error');
        }
        return false;
      } finally {
        if (controller === this.coverageController) {
          this.coverageController = null;
          this.coverageRequestIdentity = '';
          this.coveragePending = false;
          this.updateButtons();
        }
      }
    }

    setAddressStatus(message, type = '') {
      if (!this.nodes.addressStatus) return;
      this.nodes.addressStatus.textContent = message;
      this.nodes.addressStatus.classList.toggle('is-valid', type === 'valid');
      this.nodes.addressStatus.classList.toggle('is-error', type === 'error');
      this.nodes.addressStatus.hidden = !message;
    }

    getMeaningfulStructuredAddressLine(address) {
      const fullAddress = this.normalizeWhitespace(address?.addressLine || address?.label);
      const postcode = this.normalizeWhitespace(address?.postcode);
      const city = this.normalizeWhitespace(address?.city);
      if (!fullAddress) return '';
      let addressLine = fullAddress;
      if (postcode && addressLine.includes(postcode)) {
        addressLine = addressLine.split(postcode)[0];
      }
      addressLine = this.normalizeWhitespace(addressLine.replace(/[,\s-]+$/, ''));
      if (!addressLine || addressLine === postcode || this.normalizeTitle(addressLine) === this.normalizeTitle(city)) return '';
      return addressLine;
    }

    isCompleteStructuredAddress(address, requireDistinctAddressLine = false) {
      const addressLine = this.normalizeWhitespace(address?.addressLine || address?.label);
      const postcode = this.normalizeWhitespace(address?.postcode);
      const city = this.normalizeWhitespace(address?.city);
      return Boolean(
        addressLine.length >= 3 &&
        /^\d{5}$/.test(postcode) &&
        city.length >= 2 &&
        (!requireDistinctAddressLine || this.getMeaningfulStructuredAddressLine({ addressLine, postcode, city }).length >= 3)
      );
    }

    isAddressValid() {
      if (this.isDiagnosticPrequalifiedReady) return true;
      if (this.requiresPublicCoverageCheck) {
        if (!this.isPublicCoverageAddressStructurallyValid()) return false;
        if (this.usesPropertyContextAddressPresentation) {
          const surface = Number(this.addressState.surface);
          return Boolean(
            ['Maison', 'Appartement'].includes(this.addressState.propertyType) &&
            Number.isFinite(surface) &&
            surface > 0
          );
        }
        return true;
      }
      if (this.usesRequiredNoBlockAddress()) {
        return this.addressState.addressLine.length >= 2;
      }
      if (this.usesRequiredCompleteNoBlockAddress()) {
        return this.isCompleteStructuredAddress(this.addressState, true);
      }
      if (this.usesAddressZoneRestriction() && this.usesCanonicalZoneAddress) {
        return this.isCompleteStructuredAddress(this.addressState);
      }
      const surface = Number(this.addressState.surface);
      return Boolean(
        this.isCompleteStructuredAddress(this.addressState) &&
        ['Maison', 'Appartement'].includes(this.addressState.propertyType) &&
        Number.isFinite(surface) &&
        surface > 0
      );
    }

    normalizeDpeNumber(value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 13);
    }

    isValidDpeNumber(value) {
      return /^\d{4}[A-Z]\d{7}[A-Z]$/.test(this.normalizeDpeNumber(value));
    }

    isDpeMissingBlocked() {
      return this.isDpeProjeteFlow && this.dpeNumberState.status === 'MISSING';
    }

    placePaymentButton() {
      if (!this.nodes.payment) return;
      const useDiagnosticPaymentSlot = Boolean(
        this.isDiagnosticPrequalifiedReady &&
        this.currentStep === 'calendar' &&
        this.nodes.diagnosticDesktopPaymentSlot
      );
      const useDpePaymentSlot = Boolean(
        this.isDpeProjeteFlow &&
        this.currentStep === 'dpe-number' &&
        !this.isDpeMissingBlocked() &&
        this.nodes.dpePaymentSlot
      );
      const useCalendarPaymentSlot = Boolean(
        this.usesCalendarPresentation &&
        this.currentStep === 'calendar' &&
        this.nodes.calendarPaymentSlot
      );
      const useAddressPaymentArea = Boolean(
        this.isCurrentStep('address') &&
        this.isFinalStep &&
        this.nodes.addressActions
      );
      const targetParent = useAddressPaymentArea
        ? this.nodes.addressActions
        : useDiagnosticPaymentSlot
          ? this.nodes.diagnosticDesktopPaymentSlot
          : useDpePaymentSlot
            ? this.nodes.dpePaymentSlot
            : useCalendarPaymentSlot
              ? this.nodes.calendarPaymentSlot
              : this.paymentHome.parent;
      if (!targetParent || this.nodes.payment.parentNode === targetParent) return;
      const anchor = useAddressPaymentArea || useDiagnosticPaymentSlot || useDpePaymentSlot || useCalendarPaymentSlot || this.paymentHome.nextSibling?.parentNode !== targetParent
        ? null
        : this.paymentHome.nextSibling;
      targetParent.insertBefore(this.nodes.payment, anchor);
    }

    placeSlotStatus() {
      if (!this.nodes.slotStatus) return;
      const useCalendarFrame = Boolean(
        this.usesCalendarPresentation &&
        this.currentStep === 'calendar' &&
        this.nodes.iframeWrap
      );
      const targetParent = useCalendarFrame ? this.nodes.iframeWrap : this.slotStatusHome.parent;
      if (targetParent && this.nodes.slotStatus.parentNode !== targetParent) {
        const anchor = useCalendarFrame || this.slotStatusHome.nextSibling?.parentNode !== targetParent
          ? null
          : this.slotStatusHome.nextSibling;
        targetParent.insertBefore(this.nodes.slotStatus, anchor);
      }
      this.updateSlotStatus();
    }

    updateSlotStatus() {
      if (!this.nodes.slotStatus) return;
      if (this.usesCalendarPresentation && this.currentStep === 'calendar') {
        this.nodes.slotStatus.hidden = true;
        return;
      }
      const hasSelectedSlot = Boolean(this.selectedSlot?.label);
      if (hasSelectedSlot) {
        this.nodes.slotStatus.textContent = `Créneau sélectionné : ${this.selectedSlot.label}`;
      } else if (!this.nodes.slotStatus.textContent) {
        this.nodes.slotStatus.textContent = 'Sélectionnez un créneau dans le calendrier.';
      }
      this.nodes.slotStatus.classList.toggle('is-selected', hasSelectedSlot);
      this.nodes.slotStatus.hidden = Boolean(this.usesCalendarPresentation && this.currentStep === 'calendar' && !hasSelectedSlot);
    }

    applyDpeNumberState() {
      if (!this.isDpeProjeteFlow) return;
      const blocked = this.isDpeMissingBlocked();
      this.root.dataset.nouvacOrderFlowV2DpeState = this.dpeNumberState.status || 'empty';
      this.placePaymentButton();
      if (this.currentStep === 'dpe-number' && this.nodes.title) {
        this.nodes.title.textContent = blocked ? 'DPE existant requis' : 'Saisissez le numéro de votre DPE';
      }
      if (this.nodes.dpeStep) this.nodes.dpeStep.textContent = 'ÉTAPE 3/3';
      if (this.nodes.dpeTitle) this.nodes.dpeTitle.textContent = blocked ? 'DPE existant requis' : 'Saisissez le numéro de votre DPE';
      if (this.nodes.dpeNumberEntry) this.nodes.dpeNumberEntry.hidden = blocked;
      if (this.nodes.dpeNumberActions) this.nodes.dpeNumberActions.hidden = blocked;
      if (this.nodes.dpeNumberBackActions) this.nodes.dpeNumberBackActions.hidden = true;
      if (this.nodes.dpeMissingPanel) this.nodes.dpeMissingPanel.hidden = !blocked;
      if (this.nodes.payment) this.nodes.payment.hidden = !this.isFinalStep || blocked;
      if (this.nodes.summary) this.nodes.summary.hidden = true;
      if (this.nodes.dpeSideSummary) this.nodes.dpeSideSummary.hidden = blocked || this.currentStep !== 'dpe-number';
      if (blocked && this.nodes.cartError) this.nodes.cartError.hidden = true;
      if (blocked && this.nodes.dpeNumberStatus) this.nodes.dpeNumberStatus.hidden = true;
      this.renderDpeSideSummary();
      this.renderMobileSummary();
    }

    renderDpeSideSummary() {
      if (!this.isDpeProjeteFlow || !this.nodes.dpeSideSummary) return;
      const rows = this.getDpeSummaryRows();
      const rowByKey = rows.reduce((result, row) => {
        result[row.key] = row.value;
        return result;
      }, {});
      if (this.nodes.dpeSummaryAddress) this.nodes.dpeSummaryAddress.textContent = rowByKey.address || '-';
      if (this.nodes.dpeSummaryService) this.nodes.dpeSummaryService.textContent = rowByKey.service || 'DPE Projeté';
      if (this.nodes.dpeSummaryFormula) this.nodes.dpeSummaryFormula.textContent = rowByKey.formula || '-';
      if (this.nodes.dpeSummaryPrice) this.nodes.dpeSummaryPrice.textContent = rowByKey.price || '-';
      if (this.nodes.dpeSummaryNumberRow) {
        this.nodes.dpeSummaryNumberRow.hidden = !rowByKey.dpeNumber;
      }
      if (this.nodes.dpeSummaryNumber) this.nodes.dpeSummaryNumber.textContent = rowByKey.dpeNumber || '-';
      this.renderMobileSummary();
    }

    getDpeSummaryRows() {
      const rows = [
        { key: 'address', label: 'Adresse', value: this.getDpeCustomerAddressLabel() },
        { key: 'service', label: 'Prestation', value: 'DPE Projeté' },
        { key: 'formula', label: 'Formule', value: this.selectedVariant ? this.selectedVariant.title : '-' },
        { key: 'price', label: 'Prix', value: this.getDisplayPriceLabel(this.selectedVariant?.price_formatted) }
      ];
      if (
        (this.dpeNumberState.status === 'PROVIDED' && this.dpeNumberState.normalized) ||
        this.dpeNumberState.status === 'DEFERRED'
      ) {
        rows.push({ key: 'dpeNumber', label: 'Numéro de DPE', value: this.getDpeNumberSummaryLabel() });
      }
      return rows;
    }

    isMobileFormulaActionEligible() {
      const isExplicitFormulaStep = Boolean(
        this.isCurrentStep('formula') &&
        this.usesFormulaCardSelection &&
        this.usesExplicitFormulaConfirmation
      );
      const isVariantQuestionStep = Boolean(
        this.isCurrentStep('details') &&
        this.usesVariantQuestionSelection
      );
      return isExplicitFormulaStep || isVariantQuestionStep;
    }

    isMobileFormulaActionReady() {
      if (this.contextPending) return false;
      return this.validateStep(this.currentStep);
    }

    renderMobileFormulaAction() {
      if (!this.nodes.mobileFormulaAction) return;
      const actionState = this.calculateActionState('mobile-next');
      this.nodes.mobileFormulaAction.hidden = !actionState.visible;
      this.root.dataset.nouvacOrderFlowV2MobileFormulaAction = actionState.visible ? 'active' : 'inactive';
      this.applyActionState(this.nodes.mobileFormulaNext, actionState);
      if (!actionState.visible) return;
      if (this.nodes.mobileFormulaService) {
        this.nodes.mobileFormulaService.textContent = this.product?.title || (this.usesDecisionSummary ? 'DPE Projeté' : 'Prestation');
      }
      if (this.nodes.mobileFormulaPrice) {
        const fallback = this.isCurrentStep('details') ? 'Sélectionnez une prestation' : 'Sélectionnez une formule';
        this.nodes.mobileFormulaPrice.textContent = this.selectedVariant?.available
          ? this.getDisplayPriceLabel(this.selectedVariant.price_formatted)
          : fallback;
      }
    }

    isMobileSummaryEligible() {
      const isFinalFormulaSummaryStep = Boolean(
        this.usesFinalFormulaSummary &&
        this.isFinalStep &&
        this.isAddressValid()
      );
      const isDecisionSummaryStep = Boolean(
        this.usesDecisionSummary &&
        this.isFinalStep &&
        !this.isDpeMissingBlocked()
      );
      const isCalendarSummaryStep = Boolean(
        this.usesCalendarSummary &&
        this.isFinalStep &&
        (this.isDiagnosticPrequalifiedReady || (this.isAddressValid() && this.validateDetailsStep(false)))
      );
      return isFinalFormulaSummaryStep || isDecisionSummaryStep || isCalendarSummaryStep;
    }

    isMobileSummaryOpen() {
      return Boolean(this.nodes.mobileSummary && this.nodes.mobileSummary.dataset.nouvacOrderFlowV2MobileSummaryOpen === 'true');
    }

    renderMobileSummary() {
      if (!this.nodes.mobileSummary) return;
      const eligible = this.isMobileSummaryEligible();
      this.nodes.mobileSummary.hidden = !eligible;
      this.root.dataset.nouvacOrderFlowV2MobileSummary = eligible ? 'active' : 'inactive';
      if (!eligible) {
        this.renderDiagnosticTransactionalSummary(null);
        this.closeMobileSummary(false);
        return;
      }

      const rows = this.getActiveSummaryRows();
      const diagnosticModel = this.getDiagnosticTransactionalSummaryModel();
      this.renderDiagnosticTransactionalSummary(diagnosticModel);
      const rowByKey = rows.reduce((result, row) => {
        result[row.key] = row.value;
        return result;
      }, {});
      if (this.nodes.mobileSummaryService) {
        this.nodes.mobileSummaryService.textContent = diagnosticModel
          ? 'Diagnostics immobiliers'
          : rowByKey.service || this.product?.title || (this.usesDecisionSummary ? 'DPE Projeté' : 'Prestation');
      }
      if (this.nodes.mobileSummaryPrice) this.nodes.mobileSummaryPrice.textContent = rowByKey.price || '-';
      if (this.nodes.mobileSummaryRows) {
        this.nodes.mobileSummaryRows.hidden = Boolean(diagnosticModel);
        this.nodes.mobileSummaryRows.innerHTML = '';
        if (diagnosticModel) return;
        rows.forEach((row) => {
          const item = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          item.className = 'nouvac-order-flow-v2__mobile-summary-row';
          term.textContent = row.label;
          description.textContent = row.value;
          item.append(term, description);
          this.nodes.mobileSummaryRows.appendChild(item);
        });
      }
    }

    toggleMobileSummary() {
      if (!this.isMobileSummaryEligible()) return;
      if (this.isMobileSummaryOpen()) {
        this.closeMobileSummary(false);
        return;
      }
      this.openMobileSummary();
    }

    openMobileSummary() {
      if (!this.nodes.mobileSummary || !this.nodes.mobileSummaryPanel || !this.nodes.mobileSummaryTrigger) return;
      this.renderMobileSummary();
      this.nodes.mobileSummary.dataset.nouvacOrderFlowV2MobileSummaryOpen = 'true';
      this.nodes.mobileSummaryPanel.hidden = false;
      this.nodes.mobileSummaryTrigger.setAttribute('aria-expanded', 'true');
    }

    closeMobileSummary(returnFocus) {
      if (!this.nodes.mobileSummary || !this.nodes.mobileSummaryPanel || !this.nodes.mobileSummaryTrigger) return;
      this.nodes.mobileSummary.dataset.nouvacOrderFlowV2MobileSummaryOpen = 'false';
      this.nodes.mobileSummaryPanel.hidden = true;
      this.nodes.mobileSummaryTrigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.nodes.mobileSummaryTrigger.focus({ preventScroll: true });
    }

    syncDpeNumberState() {
      const normalized = this.normalizeDpeNumber(this.nodes.dpeNumber?.value || '');
      if (this.nodes.dpeNumber) this.nodes.dpeNumber.value = normalized;
      this.dpeNumberState = {
        input: normalized,
        normalized: this.isValidDpeNumber(normalized) ? normalized : '',
        status: normalized ? (this.isValidDpeNumber(normalized) ? 'PROVIDED' : '') : ''
      };
      if (this.nodes.dpeNumberStatus) {
        this.nodes.dpeNumberStatus.textContent = normalized && !this.dpeNumberState.normalized
          ? 'Le numéro de DPE doit respecter le format attendu : 4 chiffres, 1 lettre, 7 chiffres, 1 lettre (il s’agit du numéro ADEME).'
          : '';
        this.nodes.dpeNumberStatus.classList.toggle('is-error', Boolean(this.nodes.dpeNumberStatus.textContent));
        this.nodes.dpeNumberStatus.hidden = !this.nodes.dpeNumberStatus.textContent;
      }
      this.applyDpeNumberState();
      this.renderSummary();
      this.updateButtons();
    }

    deferDpeNumber() {
      if (this.cartPending || this.holdPending) return;
      this.dpeNumberState = {
        input: '',
        normalized: '',
        status: 'DEFERRED'
      };
      if (this.nodes.dpeNumber) this.nodes.dpeNumber.value = '';
      if (this.nodes.dpeNumberStatus) {
        this.nodes.dpeNumberStatus.textContent = '';
        this.nodes.dpeNumberStatus.classList.remove('is-error');
        this.nodes.dpeNumberStatus.hidden = true;
      }
      this.applyDpeNumberState();
      this.renderSummary();
      this.updateButtons();
      this.submitPayment();
    }

    blockMissingDpeNumber() {
      if (this.cartPending || this.holdPending) return;
      this.dpeNumberState = {
        input: '',
        normalized: '',
        status: 'MISSING'
      };
      if (this.nodes.dpeNumber) this.nodes.dpeNumber.value = '';
      if (this.nodes.dpeNumberStatus) {
        this.nodes.dpeNumberStatus.textContent = '';
        this.nodes.dpeNumberStatus.classList.remove('is-error');
        this.nodes.dpeNumberStatus.hidden = true;
      }
      this.applyDpeNumberState();
      this.renderSummary();
      this.updateButtons();
    }

    isBookingIframeConnected(iframe = this.bookingIframe) {
      return Boolean(
        iframe &&
        iframe.isConnected &&
        this.root.contains(iframe) &&
        iframe.parentNode === this.nodes.iframeWrap
      );
    }

    recoverDisconnectedBookingIframe() {
      if (!this.hasCalendarCapability || this.holdPending || this.cartPending || !this.nodes.iframeWrap?.isConnected) return null;
      this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
      this.selectedSlot = null;
      this.bookingHold = null;
      this.renderIframe({ force: true });
      return this.bookingIframe;
    }

    isCalendarIframeCurrent() {
      const iframe = this.bookingIframe;
      const generation = this.calendarGeneration;
      return Boolean(
        this.isBookingIframeConnected(iframe) &&
        generation &&
        generation.iframe === iframe &&
        generation.state === BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED &&
        iframe.contentWindow &&
        this.calendarContextIdentity &&
        this.calendarContextIdentity === this.getCalendarContextIdentity() &&
        this.calendarIframeUrl &&
        iframe.getAttribute('src') === this.calendarIframeUrl
      );
    }

    clearHandshakeTimer() {
      if (!this.handshakeTimer) return;
      window.clearTimeout(this.handshakeTimer);
      this.handshakeTimer = null;
    }

    setHandshakeState(generation, state) {
      if (!generation || generation !== this.calendarGeneration) return false;
      generation.state = state;
      this.root.dataset.nouvacOrderFlowV2BookingHandshake = state;
      return true;
    }

    invalidateCalendarGeneration({ removeIframe = true, clearStatus = true } = {}) {
      this.clearHandshakeTimer();
      this.clearHoldResponseTimer();
      this.holdPending = false;
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      const generation = this.calendarGeneration;
      if (generation) generation.active = false;
      const iframe = this.bookingIframe;
      this.calendarGeneration = null;
      this.bookingIframe = null;
      this.nodes.iframe = null;
      this.calendarContextIdentity = '';
      this.calendarIframeUrl = '';
      delete this.root.dataset.nouvacOrderFlowV2BookingHandshake;
      if (removeIframe && iframe?.parentNode === this.nodes.iframeWrap) iframe.remove();
      if (removeIframe) {
        this.nodes.iframeWrap?.querySelectorAll('[data-nouvac-order-flow-v2-calendar-iframe]').forEach((candidate) => candidate.remove());
      }
      if (clearStatus && this.nodes.slotStatus) this.nodes.slotStatus.textContent = 'Sélectionnez un créneau dans le calendrier.';
    }

    normalizeInitializationText(value, maximumLength) {
      const normalized = this.normalizeWhitespace(value);
      return normalized && normalized.length <= maximumLength ? normalized : '';
    }

    normalizeInitializationSurface(value) {
      const normalized = this.normalizeWhitespace(value).replace(',', '.');
      if (!normalized) return undefined;
      const surface = Number(normalized);
      return Number.isFinite(surface) && surface > 0 && surface <= BOOKING_INITIALIZATION_MAX_SURFACE
        ? surface
        : undefined;
    }

    createBookingInitializationSnapshot() {
      const serviceSlug = this.normalizeInitializationText(this.runtimeServiceSlug, 200).toLowerCase();
      const productHandle = this.normalizeInitializationText(this.product?.handle, 200).toLowerCase();
      const shopifyVariantId = this.normalizeInitializationText(this.selectedVariant?.id, 32);
      const addressLine = this.normalizeInitializationText(this.addressState.addressLine, 200);
      const postcode = this.normalizeInitializationText(this.addressState.postcode, 5).replace(/\s+/g, '');
      const city = this.normalizeInitializationText(this.addressState.city, 200);
      if (
        !PRODUCT_HANDLE_PATTERN.test(serviceSlug) ||
        !PRODUCT_HANDLE_PATTERN.test(productHandle) ||
        !/^\d{1,32}$/.test(shopifyVariantId) ||
        !addressLine ||
        !/^\d{5}$/.test(postcode) ||
        !city
      ) {
        return null;
      }

      const propertyType = this.normalizeInitializationText(
        this.usesVariantQuestionSelection
          ? this.getSelectedOptionValueByName(['type de bien', 'type du bien', 'type de votre bien', 'type du logement'])
          : this.addressState.propertyType,
        100
      );
      const projectType = this.normalizeInitializationText(
        this.usesVariantQuestionSelection ? this.getQuestionVisibleValue('prestationContext') : '',
        100
      );
      const rawSurface = this.usesVariantQuestionSelection
        ? this.getSelectedOptionValueByName(['surface'])
        : this.addressState.surface;
      const surface = this.normalizeInitializationSurface(rawSurface);
      const constructionPeriod = this.normalizeInitializationText(
        this.usesVariantQuestionSelection
          ? this.getSelectedOptionValueByName(['annee de construction', 'construction', 'periode', 'period'])
          : '',
        100
      );
      return Object.freeze({
        serviceSlug,
        productHandle,
        shopifyVariantId,
        addressLine,
        postcode,
        city,
        ...(propertyType ? { propertyType } : {}),
        ...(projectType ? { projectType } : {}),
        ...(surface !== undefined ? { surface } : {}),
        ...(constructionPeriod ? { constructionPeriod } : {})
      });
    }

    createBookingIframe(generationId, { loadWhileHidden = false } = {}) {
      const iframe = document.createElement('iframe');
      iframe.className = 'nouvac-order-flow-v2__iframe';
      iframe.title = 'Calendrier de réservation NOUVAC';
      iframe.loading = loadWhileHidden ? 'eager' : 'lazy';
      iframe.setAttribute('data-nouvac-order-flow-v2-calendar-iframe', '');
      iframe.setAttribute('data-nouvac-order-flow-v2-calendar-generation', String(generationId));
      return iframe;
    }

    startHandshakeTimer(generation) {
      this.clearHandshakeTimer();
      this.handshakeTimer = window.setTimeout(() => {
        this.handshakeTimer = null;
        if (
          this.destroyed ||
          generation !== this.calendarGeneration ||
          generation.state === BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED
        ) {
          return;
        }
        this.failCalendarHandshake(generation, 'Le calendrier n’a pas pu être initialisé. Veuillez réessayer.');
      }, BOOKING_HANDSHAKE_TIMEOUT_MS);
    }

    failCalendarHandshake(generation, message, options = {}) {
      const preserveDiagnosticSelection = options.preserveDiagnosticSelection ?? Boolean(generation?.preserveDiagnosticSelection);
      const retryable = options.retryable ?? true;
      const showCartMessage = options.showCartMessage ?? true;
      if (!this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.CONTEXT_FAILED)) return;
      this.clearHandshakeTimer();
      if (generation.diagnostic) {
        this.clearDiagnosticContextTimer();
        this.diagnosticResumeState = 'FAILED';
        this.diagnosticFailureMessage = message;
        this.diagnosticContextExpiresAt = '';
        if (!preserveDiagnosticSelection) this.clearDiagnosticSelection();
        if (this.nodes.iframeWrap) this.nodes.iframeWrap.hidden = true;
        if (this.nodes.calendarHeading) this.nodes.calendarHeading.hidden = true;
      }
      if (!generation.diagnostic || !preserveDiagnosticSelection) {
        this.selectedSlot = null;
        this.bookingHold = null;
      }
      this.resetPendingHoldRequest();
      this.cartPending = false;
      this.cartRequestPromise = null;
      this.cartRequestContextIdentity = '';
      if (this.nodes.slotStatus) this.nodes.slotStatus.textContent = message;
      if (showCartMessage) {
        this.showCartError(message, ERROR_CATEGORIES.CALENDAR_CONTEXT_FAILED);
      } else {
        this.clearCartError();
      }
      if (this.nodes.retry) {
        this.nodes.retry.textContent = 'Réessayer';
        this.nodes.retry.hidden = !retryable;
      }
      this.renderSummary();
      this.renderDiagnosticPrequalifiedState();
      this.updateButtons();
    }

    retryCalendarIframe() {
      if (this.destroyed || this.holdPending || this.cartPending) return;
      const preserveDiagnosticSelection = Boolean(
        this.calendarGeneration?.preserveDiagnosticSelection ||
        (this.isDiagnosticPrequalifiedCandidate && this.diagnosticEntry.entry === 'SESSION')
      );
      this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
      this.clearCartError();
      if (this.nodes.retry) this.nodes.retry.hidden = true;
      this.renderIframe({ force: true, preserveDiagnosticSelection });
    }

    renderIframe({ force = false, preserveDiagnosticSelection = false } = {}) {
      if (this.contextPending) return false;
      const diagnosticInitialization = this.isDiagnosticPrequalifiedCandidate;
      const genericContextInvalid = !diagnosticInitialization && (
        !this.validateStep('address') ||
        !this.validateStep('formula') ||
        !this.validateStep('details')
      );
      const diagnosticContextInvalid = diagnosticInitialization && Boolean(
        this.product?.handle !== PACK_DIAGNOSTICS_PRODUCT_HANDLE ||
        this.runtimeServiceSlug !== PACK_DIAGNOSTICS_SERVICE_SLUG ||
        this.product?.metafields?.dossier_structure !== 'diagnostic_real_estate'
      );
      if (!this.hasCalendarCapability || genericContextInvalid || diagnosticContextInvalid) {
        if (this.nodes.slotStatus) this.nodes.slotStatus.textContent = 'Le contexte du calendrier est incomplet. Vérifiez la prestation, la formule et l’adresse.';
        return false;
      }
      if (this.holdPending || this.cartPending) return false;
      const nextContextIdentity = this.getCalendarContextIdentity();
      const snapshot = diagnosticInitialization
        ? Object.freeze({ diagnostic: true, identity: this.diagnosticEntry.identity })
        : this.createBookingInitializationSnapshot();
      if (!nextContextIdentity || !snapshot) {
        this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
        if (this.nodes.slotStatus) this.nodes.slotStatus.textContent = 'Le contexte du calendrier est incomplet. Vérifiez la prestation, la formule et l’adresse.';
        return false;
      }
      if (
        !force &&
        this.calendarGeneration?.contextIdentity === nextContextIdentity &&
        this.isBookingIframeConnected(this.calendarGeneration.iframe)
      ) {
        return false;
      }

      this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
      if (diagnosticInitialization) {
        this.diagnosticResumeState = this.diagnosticResumeState === 'REFRESHING' ? 'REFRESHING' : 'VERIFYING';
        if (!preserveDiagnosticSelection) this.clearDiagnosticSelection();
        if (this.nodes.iframeWrap) this.nodes.iframeWrap.hidden = true;
        if (this.nodes.calendarHeading) this.nodes.calendarHeading.hidden = true;
        this.renderDiagnosticPrequalifiedState();
      } else {
        this.selectedSlot = null;
        this.bookingHold = null;
      }
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      const generationId = ++this.calendarGenerationCounter;
      const iframe = this.createBookingIframe(generationId, {
        loadWhileHidden: diagnosticInitialization
      });
      const nextIframeUrl = `${this.extranetOrigin}${PUBLIC_BOOKING_PATH}`;
      const generation = {
        id: generationId,
        active: true,
        iframe,
        contextIdentity: nextContextIdentity,
        snapshot,
        diagnostic: diagnosticInitialization,
        diagnosticRefresh: Boolean(diagnosticInitialization && this.diagnosticEntry.entry === 'SESSION'),
        preserveDiagnosticSelection: Boolean(diagnosticInitialization && preserveDiagnosticSelection),
        state: BOOKING_HANDSHAKE_STATES.IFRAME_LOADING
      };
      this.calendarGeneration = generation;
      this.bookingIframe = iframe;
      this.nodes.iframe = iframe;
      this.calendarContextIdentity = nextContextIdentity;
      this.calendarIframeUrl = nextIframeUrl;
      this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.WAITING_FOR_READY);
      iframe.src = nextIframeUrl;
      this.nodes.iframeWrap.appendChild(iframe);
      this.startHandshakeTimer(generation);
      if (this.nodes.slotStatus) this.nodes.slotStatus.textContent = 'Initialisation sécurisée du calendrier...';
      this.placeSlotStatus();
      this.renderSummary();
      this.updateButtons();
      return true;
    }

    getSelectedOptionValueByName(aliases) {
      return this.getSelectedOptionPairByName(aliases)?.value || '';
    }

    getSelectedOptionPairByName(aliases) {
      const normalizedAliases = aliases.map((alias) => this.normalizeTitle(alias));
      const optionName = Object.keys(this.selectedOptionValues).find((name) => {
        const normalizedName = this.normalizeTitle(name);
        return normalizedAliases.some((alias) => normalizedName.includes(alias));
      });
      return optionName ? { name: optionName, value: this.selectedOptionValues[optionName] } : null;
    }

    getPackDiagnosticsIncluded() {
      if (this.isDiagnosticPrequalifiedReady) return [...this.diagnosticSummary.diagnostics];
      if (!this.isPackDiagnosticsFlow || !this.selectedVariant?.available) return [];
      const normalizedOptionTitle = this.normalizeTitle(PACK_CONSTRUCTION_YEAR_OPTION_TITLE).replace(/[’']/g, "'");
      const optionName = (this.product?.options || []).find((name) => {
        return this.normalizeTitle(name).replace(/[’']/g, "'") === normalizedOptionTitle;
      });
      const selectedValue = optionName ? this.selectedOptionValues[optionName] : '';
      const diagnostics = PACK_DIAGNOSTICS_INCLUDED_BY_CONSTRUCTION_YEAR[this.normalizeTitle(selectedValue)];
      return diagnostics ? [...diagnostics] : [];
    }

    getPackDiagnosticsIncludedLabel() {
      return this.getPackDiagnosticsIncluded().join(', ');
    }

    getQuestionVisibleValue(questionKey) {
      const question = this.getQuestionSchema(questionKey);
      const answer = question ? this.getQuestionValueSchema(question, this.questionAnswers[question.key]) : null;
      return answer?.label || '';
    }

    getCalendarContextIdentity(addressState = this.addressState) {
      if (this.isDiagnosticPrequalifiedCandidate) {
        return JSON.stringify({
          capability: DIAGNOSTIC_PREQUALIFIED_API.DIAGNOSTIC_CONTEXT_VERSION,
          identity: this.diagnosticEntry.identity
        });
      }
      const propertyType = this.usesVariantQuestionSelection
        ? this.getSelectedOptionValueByName(['type de bien', 'type du bien', 'type de votre bien', 'type du logement'])
        : addressState.propertyType;
      const projectType = this.usesVariantQuestionSelection ? this.getQuestionVisibleValue('prestationContext') : '';
      const surface = this.usesVariantQuestionSelection ? this.getSelectedOptionValueByName(['surface']) : addressState.surface;
      const constructionPeriod = this.usesVariantQuestionSelection
        ? this.getSelectedOptionValueByName(['annee de construction', 'construction', 'periode', 'period'])
        : '';
      return JSON.stringify({
        serviceSlug: this.normalizeToken(this.product?.metafields?.service_slug || this.route?.serviceSlug || ''),
        productHandle: this.normalizeToken(this.product?.handle || this.route?.productHandle || ''),
        variantId: this.selectedVariant ? String(this.selectedVariant.id) : '',
        addressLine: this.normalizeWhitespace(addressState.addressLine),
        postcode: this.normalizeWhitespace(addressState.postcode),
        city: this.normalizeWhitespace(addressState.city),
        propertyType: this.normalizeWhitespace(propertyType),
        projectType: this.normalizeWhitespace(projectType),
        surface: this.normalizeInitializationSurface(surface) ?? '',
        constructionPeriod: this.normalizeWhitespace(constructionPeriod)
      });
    }

    getSlotIdentity(slot) {
      const normalizedSlot = this.normalizeSlotPayload(slot);
      if (!normalizedSlot?.start || !normalizedSlot?.end) return '';
      return JSON.stringify({
        start: this.normalizeWhitespace(normalizedSlot.start),
        end: this.normalizeWhitespace(normalizedSlot.end),
        serviceSlug: this.normalizeToken(this.product?.metafields?.service_slug || this.route?.serviceSlug || '')
      });
    }

    isSameSlot(firstSlot, secondSlot) {
      const firstIdentity = this.getSlotIdentity(firstSlot);
      const secondIdentity = this.getSlotIdentity(secondSlot);
      return Boolean(firstIdentity && secondIdentity && firstIdentity === secondIdentity);
    }

    getBookingContextIdentity(slot = this.selectedSlot) {
      const slotIdentity = this.getSlotIdentity(slot);
      if (!slotIdentity) return '';
      return JSON.stringify({
        calendar: this.getCalendarContextIdentity(),
        slot: slotIdentity,
        ...(this.isDiagnosticPrequalifiedCandidate
          ? {
            offerKey: slot?.finalOffer?.offerKey || '',
            shopifyVariantId: slot?.finalOffer?.shopifyVariantId || ''
          }
          : {})
      });
    }

    parseIframeMessageData(rawData) {
      if (!this.isPlainObject(rawData) || !this.isBoundedMessageObject(rawData)) return null;
      try {
        return JSON.stringify(rawData).length <= 50000 ? rawData : null;
      } catch (error) {
        return null;
      }
    }

    isPlainObject(value) {
      if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
      const prototype = Object.getPrototypeOf(value);
      return prototype === Object.prototype || prototype === null;
    }

    hasOnlyKeys(value, allowedKeys, requiredKeys = allowedKeys) {
      if (!this.isPlainObject(value)) return false;
      const allowed = new Set(allowedKeys);
      const keys = Object.keys(value);
      return keys.every((key) => allowed.has(key)) && requiredKeys.every((key) => Object.prototype.hasOwnProperty.call(value, key));
    }

    isBoundedMessageObject(value, depth = 1, state = { nodes: 0 }) {
      state.nodes += 1;
      if (depth > 4 || state.nodes > 120 || !this.isPlainObject(value) || Object.keys(value).length > 40) return false;
      return Object.entries(value).every(([key, entry]) => {
        if (['__proto__', 'prototype', 'constructor'].includes(key)) return false;
        if (entry === undefined) return true;
        if (typeof entry === 'string') return entry.length <= 2000;
        if (typeof entry === 'number') return Number.isFinite(entry);
        if (typeof entry === 'boolean' || entry === null) return true;
        if (this.isPlainObject(entry)) return this.isBoundedMessageObject(entry, depth + 1, state);
        return false;
      });
    }

    isBoundedString(value, maximumLength, { required = true } = {}) {
      return typeof value === 'string' && value.length <= maximumLength && (!required || Boolean(this.normalizeWhitespace(value)));
    }

    isValidIsoInstant(value) {
      if (!this.isBoundedString(value, 40) || !/^\d{4}-\d{2}-\d{2}T/.test(value)) return false;
      const timestamp = Date.parse(value);
      return Number.isFinite(timestamp) && new Date(timestamp).toISOString() === value;
    }

    validateLineItemPropertyProjection(value) {
      const allowedKeys = [
        'Adresse du bien',
        'Créneau choisi',
        'Zone d’intervention',
        '_booking_payload',
        '_booking_hold_token',
        '_service_slug',
        '_variant_id',
        '_variant_title',
        '_rdv_date',
        '_rdv_start',
        '_rdv_end',
        '_rdv_zone',
        '_rdv_duration',
        '_dossier_structure',
        '_address_postcode',
        '_address_city',
        '_surcharge_type',
        '_product_handle'
      ];
      return this.isPlainObject(value) &&
        this.hasOnlyKeys(value, allowedKeys, []) &&
        Object.entries(value).every(([key, entry]) => key.length <= 100 && this.isBoundedString(entry, 2000, { required: false }));
    }

    validateBookingMessage(data) {
      if (!this.isPlainObject(data) || data.version !== BOOKING_MESSAGE_PROTOCOL_VERSION || !Object.values(BOOKING_MESSAGE_TYPES).includes(data.type)) return false;
      if ([BOOKING_MESSAGE_TYPES.IFRAME_READY, BOOKING_MESSAGE_TYPES.CONTEXT_ACCEPTED].includes(data.type)) {
        return this.hasOnlyKeys(data, ['type', 'version']);
      }
      if (!this.hasOnlyKeys(data, ['type', 'version', 'payload']) || !this.isPlainObject(data.payload)) return false;
      if (data.type === BOOKING_MESSAGE_TYPES.CONTEXT_FAILED) {
        return this.hasOnlyKeys(data.payload, ['code']) && BOOKING_CONTEXT_FAILURE_CODES.has(data.payload.code);
      }
      if (data.type === BOOKING_MESSAGE_TYPES.IFRAME_RESIZE) {
        return this.hasOnlyKeys(data.payload, ['height']) && Number.isFinite(data.payload.height);
      }
      if (data.type === BOOKING_MESSAGE_TYPES.HOLD_FAILED) {
        return this.hasOnlyKeys(data.payload, ['message', 'code', 'retryAfterSeconds'], ['message']) &&
          this.isBoundedString(data.payload.message, 500) &&
          (data.payload.code === undefined || this.isBoundedString(data.payload.code, 100)) &&
          (data.payload.retryAfterSeconds === undefined || (
            Number.isInteger(data.payload.retryAfterSeconds) &&
            data.payload.retryAfterSeconds > 0 &&
            data.payload.retryAfterSeconds <= 3600
          ));
      }
      if (data.type === BOOKING_MESSAGE_TYPES.SLOT_SELECTED) return this.validateSlotSelectedPayload(data.payload);
      if (data.type === BOOKING_MESSAGE_TYPES.HOLD_CREATED) return this.validateHoldCreatedPayload(data.payload);
      return false;
    }

    validateSlotSelectedPayload(payload) {
      const allowedKeys = [
        'rdvDate', 'rdvStart', 'rdvEnd', 'rdvZone', 'rdvDuration', 'label', 'displayLabel',
        'surchargeType', 'serviceSlug', 'dossierStructure', 'addressSummary', 'postcode', 'city',
        'productHandle', 'shopifyProductId', 'shopifyVariantId', 'offerKey', 'propertyType', 'projectType', 'surface',
        'constructionPeriod', 'variantTitle', 'priceLabel', 'lineItemProperties'
      ];
      const requiredKeys = [
        'rdvDate', 'rdvStart', 'rdvEnd', 'rdvZone', 'rdvDuration', 'label', 'displayLabel',
        'surchargeType', 'serviceSlug', 'dossierStructure', 'addressSummary', 'postcode', 'city',
        'productHandle', 'shopifyVariantId', 'lineItemProperties'
      ];
      if (!this.hasOnlyKeys(payload, allowedKeys, requiredKeys)) return false;
      const duration = payload.rdvDuration;
      const start = Date.parse(payload.rdvStart);
      const end = Date.parse(payload.rdvEnd);
      const lineItemProperties = payload.lineItemProperties;
      const optionalKeys = ['shopifyProductId', 'offerKey', 'propertyType', 'projectType', 'surface', 'constructionPeriod', 'variantTitle', 'priceLabel'];
      return /^\d{4}-\d{2}-\d{2}$/.test(payload.rdvDate) &&
        this.isValidIsoInstant(payload.rdvStart) &&
        this.isValidIsoInstant(payload.rdvEnd) &&
        end > start &&
        Number.isInteger(duration) &&
        duration > 0 &&
        duration <= 1440 &&
        Math.round((end - start) / 60000) === duration &&
        ['rdvZone', 'label', 'displayLabel', 'surchargeType', 'serviceSlug', 'dossierStructure', 'addressSummary', 'postcode', 'city', 'productHandle', 'shopifyVariantId']
          .every((key) => this.isBoundedString(payload[key], key === 'addressSummary' || key === 'label' || key === 'displayLabel' ? 500 : 200)) &&
        optionalKeys.every((key) => payload[key] === undefined || this.isBoundedString(payload[key], key === 'priceLabel' ? 200 : 100, { required: false })) &&
        this.validateLineItemPropertyProjection(lineItemProperties) &&
        lineItemProperties._rdv_date === payload.rdvDate &&
        lineItemProperties._rdv_start === payload.rdvStart &&
        lineItemProperties._rdv_end === payload.rdvEnd &&
        this.normalizeToken(lineItemProperties._rdv_zone) === this.normalizeToken(payload.rdvZone) &&
        String(lineItemProperties._rdv_duration) === String(payload.rdvDuration) &&
        this.normalizeToken(lineItemProperties._service_slug) === this.normalizeToken(payload.serviceSlug) &&
        this.normalizeToken(lineItemProperties._dossier_structure) === this.normalizeToken(payload.dossierStructure);
    }

    validateHoldCreatedPayload(payload) {
      const keys = [
        'bookingHoldToken', 'expiresAt', 'rdvDate', 'rdvStart', 'rdvEnd', 'rdvZone', 'rdvDuration',
        'serviceSlug', 'dossierStructure', 'addressSummary', 'postcode', 'city', 'surchargeType', 'finalOffer', 'lineItemProperties'
      ];
      const requiredKeys = keys.filter((key) => key !== 'finalOffer');
      if (!this.hasOnlyKeys(payload, keys, requiredKeys)) return false;
      const start = Date.parse(payload.rdvStart);
      const end = Date.parse(payload.rdvEnd);
      const lineItemProperties = payload.lineItemProperties;
      return /^[A-Za-z0-9_-]{16,512}$/.test(payload.bookingHoldToken) &&
        this.isValidIsoInstant(payload.expiresAt) &&
        /^\d{4}-\d{2}-\d{2}$/.test(payload.rdvDate) &&
        this.isValidIsoInstant(payload.rdvStart) &&
        this.isValidIsoInstant(payload.rdvEnd) &&
        end > start &&
        Number.isInteger(payload.rdvDuration) &&
        payload.rdvDuration > 0 &&
        payload.rdvDuration <= 1440 &&
        Math.round((end - start) / 60000) === payload.rdvDuration &&
        ['rdvZone', 'serviceSlug', 'dossierStructure', 'addressSummary', 'postcode', 'city', 'surchargeType']
          .every((key) => this.isBoundedString(payload[key], key === 'addressSummary' ? 500 : 200)) &&
        (payload.finalOffer === undefined || this.validateDiagnosticFinalOffer(payload.finalOffer, payload.surchargeType)) &&
        this.validateLineItemPropertyProjection(lineItemProperties) &&
        lineItemProperties._booking_hold_token === payload.bookingHoldToken &&
        lineItemProperties._rdv_date === payload.rdvDate &&
        lineItemProperties._rdv_start === payload.rdvStart &&
        lineItemProperties._rdv_end === payload.rdvEnd &&
        this.normalizeToken(lineItemProperties._rdv_zone) === this.normalizeToken(payload.rdvZone) &&
        String(lineItemProperties._rdv_duration) === String(payload.rdvDuration) &&
        this.normalizeToken(lineItemProperties._service_slug) === this.normalizeToken(payload.serviceSlug) &&
        this.normalizeToken(lineItemProperties._dossier_structure) === this.normalizeToken(payload.dossierStructure) &&
        this.normalizeWhitespace(lineItemProperties._address_postcode) === this.normalizeWhitespace(payload.postcode) &&
        this.normalizeTitle(lineItemProperties._address_city) === this.normalizeTitle(payload.city);
    }

    validateDiagnosticFinalOffer(value, expectedSurchargeType) {
      if (!this.isPlainObject(value)) return false;
      return this.hasOnlyKeys(value, ['productHandle', 'shopifyProductId', 'shopifyVariantId', 'offerKey', 'surchargeType']) &&
        value.productHandle === PACK_DIAGNOSTICS_PRODUCT_HANDLE &&
        /^\d{1,32}$/.test(value.shopifyProductId) &&
        /^\d{1,32}$/.test(value.shopifyVariantId) &&
        /^diagnostic-pack\.v1\.count-[3-7]\.surface-(?:9-80|81-150|151-200)\.(?:standard|weekend)$/.test(value.offerKey) &&
        ['STANDARD', 'WEEKEND'].includes(value.surchargeType) &&
        (!expectedSurchargeType || value.surchargeType === expectedSurchargeType);
    }

    sendBookingMessageToIframe(message, generation = this.calendarGeneration) {
      if (
        !generation ||
        generation !== this.calendarGeneration ||
        !generation.active ||
        !this.isBookingIframeConnected(generation.iframe) ||
        !generation.iframe.contentWindow
      ) {
        return false;
      }
      try {
        generation.iframe.contentWindow.postMessage(message, this.extranetOrigin);
        return true;
      } catch (error) {
        return false;
      }
    }

    handleIframeReady(generation) {
      if (
        !generation ||
        generation !== this.calendarGeneration ||
        generation.state === BOOKING_HANDSHAKE_STATES.CONTEXT_FAILED ||
        (generation.diagnostic && generation.state !== BOOKING_HANDSHAKE_STATES.WAITING_FOR_READY)
      ) {
        return;
      }
      const wasAccepted = generation.state === BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED;
      const initializationMessage = generation.diagnostic
        ? DIAGNOSTIC_PREQUALIFIED_API.buildInitializationMessage(this.diagnosticEntry)
        : {
          type: BOOKING_MESSAGE_TYPES.CONTEXT_INIT,
          version: BOOKING_MESSAGE_PROTOCOL_VERSION,
          payload: generation.snapshot
        };
      if (
        !initializationMessage ||
        (generation.diagnostic && !this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.CONTEXT_INIT_SENT))
      ) {
        this.failCalendarHandshake(generation, 'Le calendrier n’a pas pu être initialisé. Veuillez réessayer.');
        return;
      }
      const sent = this.sendBookingMessageToIframe(initializationMessage, generation);
      if (!sent) {
        this.failCalendarHandshake(generation, 'Le calendrier n’a pas pu être initialisé. Veuillez réessayer.');
        return;
      }
      if (!generation.diagnostic && !wasAccepted) this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.CONTEXT_INIT_SENT);
    }

    handleDiagnosticBookingContextMessage(result, generation) {
      if (!generation?.diagnostic || generation !== this.calendarGeneration) return false;
      if (generation.state !== BOOKING_HANDSHAKE_STATES.CONTEXT_INIT_SENT) return true;
      if (result.status === 'FAILED') {
        this.diagnosticResumeContractVersion = '';
        this.diagnosticChoicesExpanded = false;
        this.diagnosticFailureCode = result.code;
        const message = DIAGNOSTIC_PREQUALIFIED_API.getFailureMessage(result.code);
        const preserveDiagnosticSelection = Boolean(generation.preserveDiagnosticSelection);
        this.failCalendarHandshake(generation, message, {
          preserveDiagnosticSelection,
          retryable: result.code !== 'DIAGNOSTIC_SESSION_EXPIRED',
          showCartMessage: result.code !== 'DIAGNOSTIC_SESSION_EXPIRED'
        });
        this.renderDiagnosticPrequalifiedState();
        return true;
      }
      const contextRefresh = result.status === 'READY' ? result.booking.contextRefresh : undefined;
      if (
        generation.diagnosticRefresh && result.status === 'READY' &&
        !['UNCHANGED', 'RESELECTION_REQUIRED'].includes(contextRefresh)
      ) {
        this.failCalendarHandshake(
          generation,
          'Les disponibilités n’ont pas pu être actualisées. Veuillez réessayer.',
          { preserveDiagnosticSelection: true }
        );
        return true;
      }
      DIAGNOSTIC_PREQUALIFIED_API.cleanAcceptedEmailFragment(
        this.diagnosticEntry,
        window.location,
        window.history
      );
      if (result.status === 'READY' && this.diagnosticEntry.entry === 'EMAIL') {
        this.diagnosticEntry = DIAGNOSTIC_PREQUALIFIED_API.transitionEmailEntryToSession(this.diagnosticEntry);
      }
      this.clearHandshakeTimer();
      const activeBookingHold = generation.diagnosticRefresh && this.hasActiveDiagnosticBookingHold();
      const preserveHeldAuthority = activeBookingHold && contextRefresh === 'RESELECTION_REQUIRED';
      if (!preserveHeldAuthority) this.diagnosticSummary = result.summary;
      this.diagnosticResumeContractVersion = result.contractVersion;
      if (!result.summary.formAnswers) this.diagnosticChoicesExpanded = false;
      if (!preserveHeldAuthority) {
        this.addressState.addressLine = result.summary.address;
        this.addressState.postcode = '';
        this.addressState.city = '';
      }

      if (result.status === 'MANUAL') {
        this.clearDiagnosticContextTimer();
        this.diagnosticResumeState = 'MANUAL';
        this.diagnosticFailureCode = '';
        this.diagnosticFailureMessage = '';
        this.diagnosticContextExpiresAt = '';
        this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED);
        this.invalidateCalendarGeneration({ removeIframe: true, clearStatus: false });
        if (this.nodes.iframeWrap) this.nodes.iframeWrap.hidden = true;
        if (this.nodes.calendarHeading) this.nodes.calendarHeading.hidden = true;
        this.renderDiagnosticPrequalifiedState();
        this.renderSummary();
        this.updateButtons();
        return true;
      }

      if (generation.diagnosticRefresh && contextRefresh === 'RESELECTION_REQUIRED' && !activeBookingHold) {
        this.clearDiagnosticPreHoldSelection();
      }
      this.diagnosticResumeState = 'READY';
      this.diagnosticFailureCode = '';
      this.diagnosticFailureMessage = '';
      this.diagnosticContextExpiresAt = result.booking.expiresAt;
      this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED);
      if (this.nodes.iframeWrap) this.nodes.iframeWrap.hidden = false;
      if (this.nodes.calendarHeading) this.nodes.calendarHeading.hidden = false;
      if (this.nodes.slotStatus) {
        this.nodes.slotStatus.textContent = contextRefresh === 'RESELECTION_REQUIRED' && !activeBookingHold
          ? 'Les disponibilités ont été actualisées. Sélectionnez à nouveau un créneau.'
          : this.selectedSlot?.label
            ? `Créneau sélectionné : ${this.selectedSlot.label}`
            : 'Sélectionnez un créneau dans le calendrier.';
      }
      if (this.nodes.retry) this.nodes.retry.hidden = true;
      if (contextRefresh === 'RESELECTION_REQUIRED' && !activeBookingHold) {
        this.showCartError(
          'Les informations de votre demande ont évolué. Sélectionnez un nouveau créneau pour continuer.',
          ERROR_CATEGORIES.CALENDAR_CONTEXT_FAILED
        );
      } else {
        this.clearCartError();
      }
      this.scheduleDiagnosticContextRefresh(result.booking.expiresAt);
      this.renderDiagnosticPrequalifiedState();
      this.renderSummary();
      this.updateButtons();
      return true;
    }

    handleIframeMessage(event) {
      const generation = this.calendarGeneration;
      const iframe = generation?.iframe;
      if (
        this.destroyed ||
        !this.hasCalendarCapability ||
        !generation?.active ||
        generation !== this.calendarGeneration ||
        event.origin !== this.extranetOrigin ||
        !this.isBookingIframeConnected(iframe) ||
        event.source !== iframe.contentWindow
      ) {
        return;
      }
      if (generation.diagnostic) {
        const diagnosticResult = DIAGNOSTIC_PREQUALIFIED_API.parseDiagnosticMessage(event.data, Date.now());
        if (diagnosticResult && this.handleDiagnosticBookingContextMessage(diagnosticResult, generation)) return;
      }
      const data = this.parseIframeMessageData(event.data);
      if (!data || !this.validateBookingMessage(data)) return;

      if (data.type === BOOKING_MESSAGE_TYPES.IFRAME_READY) {
        this.handleIframeReady(generation);
        return;
      }
      if (data.type === BOOKING_MESSAGE_TYPES.CONTEXT_ACCEPTED) {
        if (generation.state !== BOOKING_HANDSHAKE_STATES.CONTEXT_INIT_SENT) return;
        this.clearHandshakeTimer();
        this.setHandshakeState(generation, BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED);
        if (this.nodes.slotStatus) this.nodes.slotStatus.textContent = 'Sélectionnez un créneau dans le calendrier.';
        if (this.nodes.retry) this.nodes.retry.hidden = true;
        this.clearCartError();
        this.updateButtons();
        return;
      }
      if (data.type === BOOKING_MESSAGE_TYPES.CONTEXT_FAILED) {
        if (generation.state !== BOOKING_HANDSHAKE_STATES.CONTEXT_INIT_SENT) return;
        this.failCalendarHandshake(generation, 'Le calendrier n’a pas pu vérifier ces informations. Corrigez-les ou réessayez.');
        return;
      }
      if (data.type === BOOKING_MESSAGE_TYPES.IFRAME_RESIZE) {
        const height = data.payload.height;
        if (height < BOOKING_IFRAME_MIN_HEIGHT || height > BOOKING_IFRAME_MAX_HEIGHT) return;
        const isMobile = window.matchMedia?.('(max-width: 749px)').matches;
        const presentationMaximum = this.usesCalendarPresentation ? (isMobile ? 500 : 620) : BOOKING_IFRAME_MAX_HEIGHT;
        iframe.style.height = `${Math.max(BOOKING_IFRAME_MIN_HEIGHT, Math.min(height, presentationMaximum))}px`;
        return;
      }
      if (generation.state !== BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED) return;
      if (data.type === BOOKING_MESSAGE_TYPES.SLOT_SELECTED) {
        this.handleContextBoundSlotSelected(data, generation);
        return;
      }
      if (data.type === BOOKING_MESSAGE_TYPES.HOLD_CREATED) {
        if (!this.holdPending || this.cartPending || this.cartRequestPromise) return;
        this.clearHoldResponseTimer();
        this.handleContextBoundHoldCreated(data, generation);
        return;
      }
      if (data.type === BOOKING_MESSAGE_TYPES.HOLD_FAILED) {
        if (!this.holdPending) return;
        this.handleContextBoundHoldFailed(data);
      }
    }

    handleContextBoundSlotSelected(data, generation = this.calendarGeneration) {
      const slot = this.normalizeSelectedSlot(data.payload, generation);
      if (!slot) {
        if (generation?.diagnostic) {
          this.clearDiagnosticSelection();
          this.showCartError(
            'Le tarif de ce créneau n’est plus disponible. Actualisez les disponibilités puis choisissez un autre créneau.',
            ERROR_CATEGORIES.VARIANT_UNAVAILABLE
          );
          this.renderDiagnosticPrequalifiedState();
          this.renderSummary();
          this.updateButtons();
        }
        return;
      }

      const sameOffer = !generation?.diagnostic || [
        'productHandle',
        'shopifyProductId',
        'shopifyVariantId',
        'offerKey',
        'surchargeType'
      ].every((key) => this.selectedSlot?.finalOffer?.[key] === slot.finalOffer?.[key]);
      const sameSlot = this.isSameSlot(this.selectedSlot, slot) && sameOffer;
      if (sameSlot && (this.holdPending || this.cartPending || this.isBookingHoldCurrent())) return;

      const holdWasPending = this.holdPending;
      if (holdWasPending) this.resetPendingHoldRequest();
      if (generation?.diagnostic) {
        const hadCommercialState = Boolean(this.selectedVariant || this.selectedSlot);
        this.selectedVariant = null;
        this.selectedSlot = null;
        this.bookingHold = null;
        if (hadCommercialState) {
          this.renderSummary();
          this.updateButtons();
        }
      }
      this.selectedSlot = slot;
      if (generation?.diagnostic) {
        this.selectedVariant = slot.approvedVariant;
        this.addressState.addressLine = this.diagnosticSummary?.address || slot.addressSummary;
        this.addressState.postcode = slot.postcode;
        this.addressState.city = slot.city;
      }
      this.bookingHold = null;
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
      if (!this.cartPending) {
        this.cartRequestPromise = null;
        this.cartRequestContextIdentity = '';
        this.cartCompleted = false;
      }
      this.clearCartError();
      this.placeSlotStatus();
      this.renderDiagnosticPrequalifiedState();
      this.renderSummary();
      this.updateButtons();
    }

    normalizeSelectedSlot(payload, generation = this.calendarGeneration) {
      const snapshot = generation?.snapshot;
      if (!snapshot || generation !== this.calendarGeneration || generation.state !== BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED) return null;
      if (generation.diagnostic) {
        if (!this.isDiagnosticPrequalifiedReady) return null;
        const resolution = DIAGNOSTIC_PREQUALIFIED_API.resolveNativeVariant(this.product, payload);
        if (
          !resolution ||
          this.normalizeToken(payload.serviceSlug) !== PACK_DIAGNOSTICS_SERVICE_SLUG ||
          this.normalizeToken(payload.dossierStructure) !== 'diagnostic_real_estate'
        ) {
          return null;
        }
        return Object.freeze({
          label: this.normalizeWhitespace(payload.displayLabel || payload.label).slice(0, 500),
          start: payload.rdvStart,
          end: payload.rdvEnd,
          timezone: 'Europe/Paris',
          zone: this.normalizeToken(payload.rdvZone).slice(0, 200),
          duration: payload.rdvDuration,
          surchargeType: resolution.finalOffer.surchargeType,
          productHandle: resolution.finalOffer.productHandle,
          shopifyProductId: resolution.finalOffer.shopifyProductId,
          shopifyVariantId: resolution.finalOffer.shopifyVariantId,
          offerKey: resolution.finalOffer.offerKey,
          finalOffer: resolution.finalOffer,
          approvedVariant: resolution.variant,
          addressSummary: this.normalizeWhitespace(payload.addressSummary).slice(0, 500),
          postcode: this.normalizeWhitespace(payload.postcode).slice(0, 20),
          city: this.normalizeWhitespace(payload.city).slice(0, 200)
        });
      }
      const matches = Boolean(
        this.normalizeToken(payload.serviceSlug) === snapshot.serviceSlug &&
        this.normalizeToken(payload.productHandle) === snapshot.productHandle &&
        this.normalizeWhitespace(payload.shopifyVariantId) === snapshot.shopifyVariantId &&
        this.normalizeWhitespace(payload.postcode) === snapshot.postcode &&
        this.normalizeTitle(payload.city) === this.normalizeTitle(snapshot.city) &&
        this.normalizeToken(payload.dossierStructure) === this.normalizeToken(this.getCanonicalDossierStructure()) &&
        (!snapshot.propertyType || this.normalizeWhitespace(payload.propertyType) === snapshot.propertyType) &&
        (!snapshot.projectType || this.normalizeWhitespace(payload.projectType) === snapshot.projectType) &&
        (!snapshot.constructionPeriod || this.normalizeWhitespace(payload.constructionPeriod) === snapshot.constructionPeriod) &&
        (snapshot.surface === undefined || Number(payload.surface) === snapshot.surface)
      );
      if (!matches) return null;
      return Object.freeze({
        label: this.normalizeWhitespace(payload.displayLabel || payload.label).slice(0, 500),
        start: payload.rdvStart,
        end: payload.rdvEnd,
        timezone: 'Europe/Paris',
        zone: this.normalizeToken(payload.rdvZone).slice(0, 200),
        duration: payload.rdvDuration
      });
    }

    normalizeSlotPayload(payload) {
      if (!payload || typeof payload !== 'object') return null;
      return {
        label: payload.label || payload.slotLabel || payload.displayLabel || payload.startLabel || '',
        start: payload.start || payload.startAt || payload.rdvStart || payload._rdv_start || '',
        end: payload.end || payload.endAt || payload.rdvEnd || payload._rdv_end || '',
        timezone: payload.timezone || payload.timeZone || 'Europe/Paris',
        zone: payload.zone || payload.zoneLabel || payload._rdv_zone || '',
        duration: payload.duration || payload.durationMinutes || payload._rdv_duration || ''
      };
    }

    getFirstScalarValue(sources, keys) {
      for (const source of sources) {
        if (!source || typeof source !== 'object') continue;
        for (const key of keys) {
          const value = source[key];
          if (value !== '' && value !== null && value !== undefined && ['string', 'number', 'boolean'].includes(typeof value)) return value;
        }
      }
      return '';
    }

    getHoldMessageSources(payload) {
      if (!payload || typeof payload !== 'object') return [];
      const holdPayload = payload.payload && typeof payload.payload === 'object' ? payload.payload : {};
      const holdObject = payload.hold && typeof payload.hold === 'object' ? payload.hold : {};
      const errorPayload = holdPayload.error && typeof holdPayload.error === 'object' ? holdPayload.error : {};
      const errorObject = payload.error && typeof payload.error === 'object' ? payload.error : {};
      return [holdPayload, holdObject, errorPayload, errorObject, payload];
    }

    classifyHoldFailure(payload) {
      const sources = this.getHoldMessageSources(payload);
      const status = Number(this.getFirstScalarValue(sources, ['status', 'statusCode', 'httpStatus']));
      const failureText = [
        this.getFirstScalarValue(sources, ['code', 'errorCode', 'reasonCode', 'type']),
        this.getFirstScalarValue(sources, ['status', 'statusText']),
        this.getFirstScalarValue(sources, ['reason', 'message', 'description', 'error'])
      ].filter(Boolean).join(' ');
      const normalizedFailure = this.normalizeTitle(failureText).replace(/[_-]+/g, ' ');
      const slotUnavailable = status === 409 || ['conflict', 'unavailable'].includes(normalizedFailure) || [
        'slot unavailable',
        'slot is unavailable',
        'slot not available',
        'slot conflict',
        'booking conflict',
        'slot already booked',
        'slot already reserved',
        'already reserved',
        'slot no longer available',
        'slot taken',
        'creneau indisponible',
        'creneau en conflit',
        'creneau deja reserve',
        'creneau n est plus disponible'
      ].some((term) => normalizedFailure.includes(term));
      const contextRejected = status === 422 || [
        'invalid context',
        'context invalid',
        'context mismatch',
        'invalid booking context',
        'invalid service',
        'service mismatch',
        'mismatched service',
        'invalid slot',
        'slot mismatch',
        'mismatched slot',
        'service slot mismatch',
        'slot service mismatch',
        'contexte invalide',
        'service incompatible',
        'creneau incompatible'
      ].some((term) => normalizedFailure.includes(term));
      return {
        explicitBusinessFailure: slotUnavailable || contextRejected,
        slotUnavailable,
        contextRejected
      };
    }

    clearHoldResponseTimer() {
      if (!this.holdResponseTimer) return;
      window.clearTimeout(this.holdResponseTimer);
      this.holdResponseTimer = null;
    }

    resetPendingHoldRequest() {
      this.clearHoldResponseTimer();
      this.holdPending = false;
      this.pendingHoldContextIdentity = '';
      this.pendingHoldSlot = null;
    }

    handleContextBoundHoldTransportFailure(message, category = ERROR_CATEGORIES.HOLD_FAILED) {
      const iframeWasDisconnected = !this.isBookingIframeConnected();
      this.resetPendingHoldRequest();
      if (iframeWasDisconnected) {
        const iframe = this.recoverDisconnectedBookingIframe();
        if (iframe) this.renderIframe();
        return;
      }
      this.restorePaymentButton();
      this.showCartError(message, category);
    }

    handleContextBoundHoldFailed(payload) {
      const diagnosticFailureCode = this.isDiagnosticPrequalifiedCandidate
        ? this.normalizeToken(payload?.payload?.code).toUpperCase()
        : '';
      const failure = this.classifyHoldFailure(payload);
      this.resetPendingHoldRequest();
      this.bookingHold = null;
      if (
        failure.slotUnavailable ||
        (this.isDiagnosticPrequalifiedCandidate && failure.contextRejected) ||
        ['BOOKING_CONTEXT_EXPIRED', 'DIAGNOSTIC_FINAL_VARIANT_UNAVAILABLE'].includes(diagnosticFailureCode)
      ) {
        if (this.isDiagnosticPrequalifiedCandidate) {
          this.clearDiagnosticSelection();
        } else {
          this.selectedSlot = null;
        }
      }
      this.placeSlotStatus();
      this.renderSummary();
      this.renderDiagnosticPrequalifiedState();
      this.restorePaymentButton();
      if (failure.slotUnavailable) {
        this.showCartError('Ce créneau n’est plus disponible. Veuillez en sélectionner un autre.', ERROR_CATEGORIES.HOLD_FAILED);
        return;
      }
      if (diagnosticFailureCode === 'DIAGNOSTIC_FINAL_VARIANT_UNAVAILABLE') {
        this.showCartError('Le tarif associé à ce créneau n’est plus disponible. Les disponibilités vont être actualisées.', ERROR_CATEGORIES.HOLD_FAILED);
        this.renderDiagnosticPrequalifiedState();
        this.renderIframe({ force: true });
        return;
      }
      if (diagnosticFailureCode === 'BOOKING_CONTEXT_EXPIRED') {
        this.diagnosticResumeState = 'REFRESHING';
        this.showCartError('Votre session de réservation a expiré. Les disponibilités vont être actualisées.', ERROR_CATEGORIES.HOLD_FAILED);
        this.renderDiagnosticPrequalifiedState();
        this.renderIframe({ force: true });
        return;
      }
      if (failure.contextRejected) {
        this.showCartError('Ce créneau ne correspond plus aux informations sélectionnées. Veuillez vérifier vos choix puis réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
        if (this.isDiagnosticPrequalifiedCandidate) this.renderIframe({ force: true });
        return;
      }
      this.showCartError('Impossible de confirmer ce créneau pour le moment. Veuillez réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
    }

    startHoldResponseTimer(generation = this.calendarGeneration) {
      this.clearHoldResponseTimer();
      this.holdResponseTimer = window.setTimeout(() => {
        this.holdResponseTimer = null;
        if (!this.holdPending || generation !== this.calendarGeneration) return;
        this.handleContextBoundHoldTransportFailure('Impossible de confirmer ce créneau pour le moment. Veuillez réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
      }, CONTEXT_BOUND_BOOKING_HOLD_TIMEOUT_MS);
    }

    handleContextBoundHoldCreated(payload, generation = this.calendarGeneration) {
      if (!this.holdPending || this.cartPending || this.cartRequestPromise || this.cartCompleted) return;
      if (!generation || generation !== this.calendarGeneration || generation.state !== BOOKING_HANDSHAKE_STATES.CONTEXT_ACCEPTED) return;
      const pendingContextIdentity = this.pendingHoldContextIdentity;
      const pendingSlot = this.pendingHoldSlot;
      if (!pendingContextIdentity || pendingContextIdentity !== this.getBookingContextIdentity()) {
        this.resetPendingHoldRequest();
        this.bookingHold = null;
        this.restorePaymentButton();
        this.showCartError('Le contexte de réservation a changé. Veuillez sélectionner à nouveau un créneau.', ERROR_CATEGORIES.HOLD_FAILED);
        return;
      }

      const hold = this.normalizeHoldPayload(payload, pendingSlot, pendingContextIdentity);
      if (!hold) {
        this.handleContextBoundHoldTransportFailure('Impossible de confirmer ce créneau pour le moment. Veuillez réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
        return;
      }
      if (!this.isContextBoundHoldResponseCompatible(payload) || !this.isSameSlot(pendingSlot, hold.slot)) {
        this.resetPendingHoldRequest();
        this.bookingHold = null;
        this.restorePaymentButton();
        this.showCartError('Ce créneau ne correspond plus aux informations sélectionnées. Veuillez vérifier vos choix puis réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
        return;
      }
      if (this.isBookingHoldExpired(hold)) {
        this.handleContextBoundHoldTransportFailure('Impossible de confirmer ce créneau pour le moment. Veuillez réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
        return;
      }

      this.selectedSlot = hold.slot;
      this.bookingHold = hold;
      this.resetPendingHoldRequest();
      this.renderSummary();
      this.startContextBoundCartPhase(hold);
    }

    isContextBoundHoldResponseCompatible(payload) {
      const source = payload?.payload;
      const snapshot = this.calendarGeneration?.snapshot;
      const lineItemProperties = source?.lineItemProperties;
      if (!this.isPlainObject(source) || !snapshot || !this.isPlainObject(lineItemProperties)) return false;
      if (this.calendarGeneration?.diagnostic) {
        const resolution = DIAGNOSTIC_PREQUALIFIED_API.resolveHoldApprovedVariant(this.product, this.selectedSlot, source);
        return Boolean(
          resolution &&
          this.isDiagnosticPrequalifiedReady &&
          this.normalizeToken(source.serviceSlug) === PACK_DIAGNOSTICS_SERVICE_SLUG &&
          this.normalizeToken(source.dossierStructure) === 'diagnostic_real_estate' &&
          this.normalizeWhitespace(source.postcode) === this.normalizeWhitespace(this.selectedSlot?.postcode) &&
          this.normalizeTitle(source.city) === this.normalizeTitle(this.selectedSlot?.city)
        );
      }
      const serviceSlug = this.normalizeToken(source.serviceSlug);
      return Boolean(
        serviceSlug === this.runtimeServiceSlug &&
        this.normalizeToken(source.dossierStructure) === this.normalizeToken(this.getCanonicalDossierStructure()) &&
        this.normalizeWhitespace(source.postcode) === this.addressState.postcode &&
        this.normalizeTitle(source.city) === this.normalizeTitle(this.addressState.city) &&
        this.normalizeToken(lineItemProperties._product_handle) === snapshot.productHandle &&
        this.normalizeWhitespace(lineItemProperties._variant_id) === snapshot.shopifyVariantId
      );
    }

    getBookingHoldExpiryTimestamp(expiresAt) {
      if (expiresAt === '' || expiresAt === null || expiresAt === undefined) return null;
      const numericExpiry = Number(expiresAt);
      if (Number.isFinite(numericExpiry) && numericExpiry > 0) {
        return numericExpiry < 1e12 ? numericExpiry * 1000 : numericExpiry;
      }
      const parsedExpiry = Date.parse(String(expiresAt));
      return Number.isFinite(parsedExpiry) ? parsedExpiry : null;
    }

    isBookingHoldExpired(hold) {
      const expiryTimestamp = this.getBookingHoldExpiryTimestamp(hold?.expiresAt);
      return expiryTimestamp !== null && expiryTimestamp <= Date.now();
    }

    isBookingHoldCurrent(hold = this.bookingHold) {
      if (!this.usesContextBoundBookingLifecycle || !hold?.token || !hold?.contextIdentity || this.isBookingHoldExpired(hold)) return false;
      if (this.isDiagnosticPrequalifiedCandidate) {
        const resolution = DIAGNOSTIC_PREQUALIFIED_API.resolveHoldApprovedVariant(this.product, this.selectedSlot, hold);
        if (!resolution || String(this.selectedVariant?.id || '') !== resolution.finalOffer.shopifyVariantId) return false;
      }
      return Boolean(
        hold.contextIdentity === this.getBookingContextIdentity() &&
        this.isSameSlot(hold.slot, this.selectedSlot)
      );
    }

    normalizeHoldPayload(message, fallbackSlot = this.selectedSlot, contextIdentity = this.pendingHoldContextIdentity) {
      const payload = message?.payload;
      if (!this.isPlainObject(payload) || !fallbackSlot || !contextIdentity) return null;
      const slot = Object.freeze({
        label: this.normalizeWhitespace(fallbackSlot.label).slice(0, 500),
        start: payload.rdvStart,
        end: payload.rdvEnd,
        timezone: this.normalizeWhitespace(fallbackSlot.timezone || 'Europe/Paris').slice(0, 100),
        zone: this.normalizeToken(payload.rdvZone).slice(0, 200),
        duration: payload.rdvDuration,
        ...(this.calendarGeneration?.diagnostic
          ? {
            surchargeType: payload.finalOffer?.surchargeType,
            productHandle: payload.finalOffer?.productHandle,
            shopifyProductId: payload.finalOffer?.shopifyProductId,
            shopifyVariantId: payload.finalOffer?.shopifyVariantId,
            offerKey: payload.finalOffer?.offerKey,
            finalOffer: payload.finalOffer,
            approvedVariant: this.selectedVariant,
            addressSummary: fallbackSlot.addressSummary,
            postcode: fallbackSlot.postcode,
            city: fallbackSlot.city
          }
          : {})
      });
      if (
        !this.isSameSlot(slot, fallbackSlot) ||
        Number(slot.duration) !== Number(fallbackSlot.duration) ||
        this.normalizeToken(slot.zone) !== this.normalizeToken(fallbackSlot.zone) ||
        !this.isContextBoundHoldResponseCompatible(message)
      ) {
        return null;
      }
      return Object.freeze({
        token: payload.bookingHoldToken,
        expiresAt: payload.expiresAt,
        slot,
        surchargeType: this.normalizeToken(payload.surchargeType).slice(0, 100),
        ...(this.calendarGeneration?.diagnostic
          ? {
            finalOffer: Object.freeze({ ...payload.finalOffer }),
            lineItemProperties: Object.freeze({ ...payload.lineItemProperties }),
            approvedVariant: this.selectedVariant
          }
          : {}),
        contextIdentity
      });
    }

    requestContextBoundBookingHold() {
      if (this.contextPending) return;
      const iframe = this.bookingIframe;
      if (!this.isCalendarIframeCurrent() || !iframe?.contentWindow) {
        this.handleContextBoundHoldTransportFailure('Impossible de contacter le calendrier pour le moment. Veuillez réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
        return;
      }
      this.bookingHold = null;
      this.cartPending = false;
      this.cartCompleted = false;
      this.holdPending = true;
      this.pendingHoldSlot = this.isDiagnosticPrequalifiedCandidate
        ? this.selectedSlot
        : this.normalizeSlotPayload(this.selectedSlot);
      this.pendingHoldContextIdentity = this.getBookingContextIdentity(this.pendingHoldSlot);
      this.updateButtons();
      this.startHoldResponseTimer(this.calendarGeneration);
      if (!this.sendBookingMessageToIframe(this.buildHoldRequestMessage())) {
        this.handleContextBoundHoldTransportFailure('Impossible de contacter le calendrier pour le moment. Veuillez réessayer.', ERROR_CATEGORIES.HOLD_FAILED);
      }
    }

    startContextBoundCartPhase(hold) {
      if (this.contextPending || !this.usesContextBoundBookingLifecycle || this.cartPending || this.cartRequestPromise || this.cartCompleted) return this.cartRequestPromise;
      if (!this.selectedVariant?.available || !this.isBookingHoldCurrent(hold)) {
        this.bookingHold = null;
        this.restorePaymentButton();
        this.showCartError('Le contexte de réservation a changé. Veuillez sélectionner à nouveau un créneau.', ERROR_CATEGORIES.HOLD_FAILED);
        return null;
      }
      if (
        this.isDiagnosticPrequalifiedCandidate &&
        String(hold?.finalOffer?.shopifyVariantId || '') !== String(this.selectedVariant.id)
      ) {
        this.bookingHold = null;
        this.restorePaymentButton();
        this.showCartError('Le tarif autorisé ne correspond plus au créneau sélectionné. Veuillez actualiser les disponibilités.', ERROR_CATEGORIES.HOLD_FAILED);
        return null;
      }

      this.holdPending = false;
      this.cartPending = true;
      this.cartCompleted = false;
      this.cartRequestContextIdentity = hold.contextIdentity;
      this.clearCartError();
      this.updateButtons();

      const cartPromise = this.addCalendarFlowToCart(hold);
      this.cartRequestPromise = cartPromise;
      cartPromise.catch((error) => {
        if (this.cartRequestPromise !== cartPromise) return;
        this.cartPending = false;
        this.cartCompleted = false;
        this.cartRequestPromise = null;
        this.cartRequestContextIdentity = '';
        if (!this.isBookingHoldCurrent(hold)) this.bookingHold = null;
        this.restorePaymentButton();
        this.showCartError(this.getCartFailureMessage(error), ERROR_CATEGORIES.CART_FAILED);
      });
      return cartPromise;
    }

    async submitPayment() {
      if (this.contextPending) return;
      if (!this.isDiagnosticPrequalifiedReady) {
        if (this.hasStep('address') && !this.ensureAddressReady(true)) return;
        if (this.requiresPublicCoverageCheck && !await this.ensurePublicCoverage()) return;
      }
      if (this.destroyed) return;
      if (this.hasCalendarCapability && !this.isBookingIframeConnected()) {
        this.renderIframe();
        return;
      }
      if (!this.canSubmitPayment()) return;

      if (this.requiresBookingHold && this.usesContextBoundBookingLifecycle) {
        this.clearCartError();
        if (this.isBookingHoldCurrent()) {
          this.startContextBoundCartPhase(this.bookingHold);
          return;
        }
        this.requestContextBoundBookingHold();
        return;
      }

      this.cartPending = true;
      this.holdPending = this.requiresBookingHold;
      this.clearCartError();
      this.updateButtons();

      if (this.requiresBookingHold) {
        this.requestContextBoundBookingHold();
        return;
      }

      const cartPromise = this.route.flowType === FLOW_ADDRESS_CHECKOUT
        ? this.addAddressCheckoutToCart()
        : this.isFormulaAddressFlow || this.isAddressFormulaCheckoutFlow
          ? this.addFormulaAddressToCart()
          : this.isDpeProjeteFlow
            ? this.addDpeProjeteToCart()
            : this.addFormulaCheckoutToCart();
      cartPromise.catch((error) => {
        this.cartPending = false;
        this.holdPending = false;
        this.restorePaymentButton();
        this.showCartError(
          this.route.flowType === FLOW_ADDRESS_CHECKOUT
            ? this.getCartFailureMessage(error)
            : 'Impossible d’ajouter cette prestation au panier. Veuillez réessayer.',
          ERROR_CATEGORIES.CART_FAILED
        );
      });
    }

    buildHoldRequestMessage() {
      return {
        type: BOOKING_MESSAGE_TYPES.CREATE_HOLD_REQUEST,
        version: BOOKING_MESSAGE_PROTOCOL_VERSION
      };
    }

    canSubmitPayment() {
      if (this.contextPending || this.coveragePending || this.cartPending || this.holdPending || this.cartRequestPromise || this.cartCompleted || !this.selectedVariant?.available) return false;
      if (!this.product) return false;
      if (this.isDiagnosticPrequalifiedCandidate) {
        const resolution = this.isDiagnosticPrequalifiedReady
          ? DIAGNOSTIC_PREQUALIFIED_API.resolveNativeVariant(this.product, this.selectedSlot || {})
          : null;
        return Boolean(
          resolution &&
          this.isCalendarIframeCurrent() &&
          String(resolution.variant.id) === String(this.selectedVariant.id)
        );
      }
      if (this.usesUniqueAvailableVariantSelection) {
        const canonicalVariants = this.getContractVariants(this.activeContract, this.product);
        const canonicalVariant = canonicalVariants.find((variant) => variant.available);
        if (canonicalVariants.length !== 1 || String(canonicalVariant?.id || '') !== String(this.selectedVariant.id)) return false;
      }
      return this.profile.steps.every((stepName) => this.isStepComplete(stepName));
    }

    buildBaseBookingPayload(missionKey, requiresCalendar) {
      const dossierStructure = this.getCanonicalDossierStructure();
      return {
        flowType: this.route.flowType,
        requiresCalendar,
        dossierStructure,
        serviceSlug: this.product.metafields?.service_slug || '',
        productHandle: this.product.handle,
        variantId: String(this.selectedVariant.id),
        variantTitle: this.selectedVariant.title,
        missionKey
      };
    }

    buildBaseHiddenProperties(missionKey, bookingPayload) {
      return {
        _service_slug: bookingPayload.serviceSlug,
        _nouvac_process_type: bookingPayload.flowType,
        _nouvac_dossier_structure: bookingPayload.dossierStructure,
        _nouvac_mission_key: missionKey,
        _product_handle: bookingPayload.productHandle,
        _variant_id: bookingPayload.variantId,
        _variant_title: bookingPayload.variantTitle,
        _booking_payload: this.serializeBookingPayload(bookingPayload),
        _booking_payload_version: SHOPIFY_ORDER_PAYLOAD_VERSION,
        _dossier_structure: bookingPayload.dossierStructure
      };
    }

    serializeBookingPayload(bookingPayload) {
      const state = { nodes: 0 };
      const forbiddenVersionKeys = new Set([
        'processVersion',
        'payloadVersion',
        'version',
        'booking_payload_version',
        'bookingPayloadVersion',
        'contractVersion'
      ]);
      const inspect = (value, depth) => {
        state.nodes += 1;
        if (depth > 5 || state.nodes > 500) throw new Error('Booking payload bounds exceeded');
        if (typeof value === 'string') {
          if (value.length > 2000) throw new Error('Booking payload string is too long');
          return;
        }
        if (typeof value === 'number') {
          if (!Number.isFinite(value)) throw new Error('Booking payload number is invalid');
          return;
        }
        if (typeof value === 'boolean' || value === null) return;
        if (Array.isArray(value)) {
          if (value.length > 50) throw new Error('Booking payload array is too large');
          value.forEach((entry) => inspect(entry, depth + 1));
          return;
        }
        if (!this.isPlainObject(value) || Object.keys(value).length > 100) throw new Error('Booking payload object is invalid');
        Object.entries(value).forEach(([key, entry]) => {
          if (
            forbiddenVersionKeys.has(key) ||
            /Version$/.test(key) ||
            /(?:^|[_-])version(?:$|[_-])/i.test(key) ||
            ['raw', 'lineItemProperties', 'pricingSnapshot', 'bookingHold', 'hold'].includes(key)
          ) {
            throw new Error('Booking payload contains a forbidden field');
          }
          inspect(entry, depth + 1);
        });
      };
      inspect(bookingPayload, 1);
      const serialized = JSON.stringify(bookingPayload);
      if (new TextEncoder().encode(serialized).byteLength > 16 * 1024) throw new Error('Booking payload is too large');
      return serialized;
    }

    getVisibleQuestionAnswers() {
      return this.questions.schema.reduce((answers, question) => {
        const value = this.questionAnswers[question.key];
        const valueSchema = this.getQuestionValueSchema(question, value);
        if (!valueSchema || !question.includeInSummary) return answers;
        answers.push({
          key: question.key,
          rawKey: question.rawKey,
          label: question.summaryLabel || question.label,
          cartLabel: question.cartLabel || question.summaryLabel || question.label,
          questionLabel: question.label,
          value: valueSchema.value,
          valueLabel: valueSchema.label
        });
        return answers;
      }, []);
    }

    buildVisibleQuestionProperties() {
      return Object.fromEntries(this.getVisibleQuestionAnswers()
        .filter((answer) => this.getQuestionSchema(answer.key)?.includeAsVisibleCartProperty)
        .map((answer) => [answer.cartLabel || answer.label, answer.valueLabel]));
    }

    buildTechnicalQuestionAnswers() {
      return Object.fromEntries(this.questions.schema
        .filter((question) => question.includeInPayload)
        .map((question) => [question.key, this.questionAnswers[question.key] || ''])
        .filter(([, value]) => value));
    }

    buildPayloadQuestionAnswers() {
      return this.getVisibleQuestionAnswers().map((answer) => ({
        key: answer.rawKey || answer.key,
        label: answer.questionLabel || answer.label,
        value: answer.valueLabel
      }));
    }

    async addFormulaCheckoutToCart() {
      const missionKey = this.createMissionKey();
      const dossierStructure = this.getCanonicalDossierStructure();
      if (!dossierStructure) throw new Error('Invalid dossier structure');
      const bookingPayload = this.buildBaseBookingPayload(missionKey, false);
      await this.addCartItem(this.buildBaseHiddenProperties(missionKey, bookingPayload));
      window.location.href = '/checkout';
    }

    async addAddressCheckoutToCart() {
      const canonicalValidation = this.validateEligibility(this.product, this.route);
      const canonicalContract = canonicalValidation.valid ? canonicalValidation.contract : null;
      const dossierStructure = this.getCanonicalDossierStructure();
      const canonicalVariants = this.getContractVariants(canonicalContract, this.product);
      const canonicalVariant = canonicalVariants.length === 1
        ? canonicalVariants.find((variant) => variant.available) || null
        : null;
      if (
        !canonicalContract?.addressCheckout ||
        canonicalContract.flowType !== FLOW_ADDRESS_CHECKOUT ||
        !dossierStructure ||
        !canonicalVariant?.available ||
        String(canonicalVariant.id) !== String(this.selectedVariant?.id || '') ||
        !this.ensureAddressReady(false)
      ) {
        throw new Error('Invalid address checkout context');
      }
      const missionKey = this.createMissionKey();
      const bookingPayload = {
        ...this.buildBaseBookingPayload(missionKey, false),
        address: {
          addressLine: this.addressState.addressLine,
          postcode: this.addressState.postcode,
          city: this.addressState.city,
          department: this.addressState.department,
          coordinates: this.addressState.coordinates
        },
        missionKey
      };

      await this.addCartItem({
        'Adresse du bien': this.getDpeCustomerAddressLabel(),
        ...this.buildBaseHiddenProperties(missionKey, bookingPayload),
        _address_postcode: this.addressState.postcode,
        _address_city: this.addressState.city,
        _address_department: this.addressState.department,
        _address_coordinates: this.addressState.coordinates
      }, { parseResponse: true });

      window.location.href = '/checkout';
    }

    async addFormulaAddressToCart() {
      const canonicalValidation = this.validateEligibility(this.product, this.route);
      const canonicalContract = canonicalValidation.valid ? canonicalValidation.contract : null;
      const dossierStructure = this.getCanonicalDossierStructure();
      const selectedVariant = this.getContractVariants(canonicalContract, this.product)
        .find((variant) => String(variant?.id || '') === String(this.selectedVariant?.id || '') && variant.available);
      const supportedFlow = canonicalContract?.flowType === FLOW_FORMULA_ADDRESS_CHECKOUT ||
        canonicalContract?.flowType === FLOW_ADDRESS_FORMULA_CHECKOUT;
      if (
        !supportedFlow ||
        canonicalContract.flowType !== this.route.flowType ||
        dossierStructure !== canonicalContract.dossierStructure ||
        !selectedVariant ||
        !this.ensureAddressReady(false)
      ) {
        throw new Error('Invalid dossier structure');
      }
      const missionKey = this.createMissionKey();
      const bookingPayload = {
        ...this.buildBaseBookingPayload(missionKey, false),
        address: {
          addressLine: this.addressState.addressLine,
          postcode: this.addressState.postcode,
          city: this.addressState.city
        },
        appointmentMode: 'REMOTE',
        missionKey
      };

      await this.addCartItem({
        'Adresse du projet': this.isAddressFormulaCheckoutFlow ? this.getCanonicalCustomerAddressLabel() : this.getAddressLabel(),
        ...this.buildBaseHiddenProperties(missionKey, bookingPayload),
        _address_postcode: this.addressState.postcode,
        _address_city: this.addressState.city
      });

      window.location.href = '/checkout';
    }

    async addDpeProjeteToCart() {
      const dossierStructure = this.getCanonicalDossierStructure();
      if (dossierStructure !== 'general') {
        throw new Error('Invalid dossier structure');
      }
      const missionKey = this.createMissionKey();
      const dpeStatus = this.dpeNumberState.status === 'PROVIDED' ? 'PROVIDED' : 'DEFERRED';
      const dpeNumberLabel = dpeStatus === 'PROVIDED' ? this.dpeNumberState.normalized : DPE_NUMBER_DEFERRED_LABEL;
      const bookingPayload = {
        ...this.buildBaseBookingPayload(missionKey, false),
        address: {
          addressLine: this.addressState.addressLine,
          postcode: this.addressState.postcode,
          city: this.addressState.city
        },
        dpeNumberStatus: dpeStatus,
        dpeNumber: dpeStatus === 'PROVIDED' ? this.dpeNumberState.normalized : '',
        missionKey
      };

      await this.addCartItem({
        'Adresse du bien': this.getDpeCustomerAddressLabel(),
        'N° de DPE': dpeNumberLabel,
        ...this.buildBaseHiddenProperties(missionKey, bookingPayload),
        _address_postcode: this.addressState.postcode,
        _address_city: this.addressState.city,
        _dpe_number_status: dpeStatus
      });

      window.location.href = '/checkout';
    }

    async addCalendarFlowToCart(hold) {
      await this.addAddressVariantCalendarToCart(hold);
    }

    async addAddressVariantCalendarToCart(hold) {
      if (this.isDiagnosticPrequalifiedReady) {
        await this.addDiagnosticPrequalifiedCalendarToCart(hold);
        return;
      }
      const missionKey = this.createMissionKey();
      const slot = hold.slot;
      const dossierStructure = this.getCanonicalDossierStructure();
      if (!dossierStructure) {
        throw new Error('Invalid dossier structure');
      }
      const bookingPayload = this.buildAddressVariantCalendarPayload(missionKey, hold);
      const holdProperties = this.getAllowedHoldLineItemProperties(hold);
      const diagnosticsIncludedLabel = this.getPackDiagnosticsIncludedLabel();

      await this.addCartItem({
        'Adresse du bien': this.getAddressVariantCalendarCustomerAddressLabel(),
        ...(this.usesPropertyContextAddressPresentation
          ? {
            'Type de bien': this.addressState.propertyType,
            'Surface': `${this.addressState.surface} m²`
          }
          : {}),
        ...this.buildVisibleQuestionProperties(),
        ...(diagnosticsIncludedLabel ? { [PACK_DIAGNOSTICS_INCLUDED_LABEL]: diagnosticsIncludedLabel } : {}),
        'Créneau choisi': this.getCalendarSlotDisplayLabel(slot),
        ...this.buildBaseHiddenProperties(missionKey, bookingPayload),
        _booking_hold_token: hold.token,
        _booking_expires_at: hold.expiresAt,
        _address_postcode: this.addressState.postcode,
        _address_city: this.addressState.city,
        _address_department: this.addressState.department,
        _address_coordinates: this.addressState.coordinates,
        _rdv_start: slot.start,
        _rdv_end: slot.end,
        _rdv_timezone: slot.timezone,
        _rdv_zone: slot.zone,
        _rdv_duration: String(slot.duration),
        _surcharge_type: holdProperties._surcharge_type,
      }, { parseResponse: true });

      this.cartCompleted = true;
      window.location.href = '/checkout';
    }

    buildDiagnosticCartLineItemProperties(slot, holdLineItemProperties) {
      const visibleLineItemProperties = {
        'Diagnostics inclus': this.diagnosticSummary.diagnostics
          .map((code) => this.getDiagnosticDisplayLabel(code))
          .join(', '),
        'Adresse du bien': this.diagnosticSummary.address,
        'Créneau choisi': this.getCalendarSlotDisplayLabel(slot)
      };
      const hiddenHoldLineItemProperties = Object.fromEntries(
        Object.entries(holdLineItemProperties).filter(([key]) => key.startsWith('_'))
      );
      return { ...visibleLineItemProperties, ...hiddenHoldLineItemProperties };
    }

    async addDiagnosticPrequalifiedCalendarToCart(hold) {
      const resolution = DIAGNOSTIC_PREQUALIFIED_API.resolveHoldApprovedVariant(this.product, this.selectedSlot, {
        finalOffer: hold?.finalOffer,
        lineItemProperties: hold?.lineItemProperties
      });
      if (!resolution || String(resolution.variant.id) !== String(this.selectedVariant?.id || '')) {
        throw new Error('Diagnostic hold variant mismatch');
      }
      const missionKey = this.createMissionKey();
      const slot = hold.slot;
      const lineItemProperties = hold.lineItemProperties;
      const cartLineItemProperties = this.buildDiagnosticCartLineItemProperties(slot, lineItemProperties);
      const bookingPayload = this.removeEmptyProperties({
        ...this.buildBaseBookingPayload(missionKey, true),
        address: {
          addressLine: this.diagnosticSummary.address,
          postcode: lineItemProperties._address_postcode,
          city: lineItemProperties._address_city,
          country: 'France'
        },
        objective: this.diagnosticSummary.objective,
        diagnosticsIncluded: [...this.diagnosticSummary.diagnostics],
        diagnosticCount: this.diagnosticSummary.diagnosticCount,
        surfaceBand: this.diagnosticSummary.surfaceBand,
        requiresAddress: true,
        requiresCalendar: true,
        appointmentMode: 'SLOT',
        appointment: {
          startsAt: slot.start,
          endsAt: slot.end,
          durationMinutes: Number(slot.duration),
          zone: slot.zone,
          timezone: slot.timezone,
          displayLabel: this.getCalendarSlotDisplayLabel(slot)
        },
        bookingHoldToken: hold.token,
        bookingHoldExpiresAt: hold.expiresAt,
        missionKey
      });

      await this.addCartItem({
        ...cartLineItemProperties,
        ...this.buildBaseHiddenProperties(missionKey, bookingPayload),
        _booking_hold_token: hold.token,
        _booking_expires_at: hold.expiresAt
      }, {
        parseResponse: true,
        variantId: hold.finalOffer.shopifyVariantId
      });

      this.cartCompleted = true;
      window.location.href = '/checkout';
    }

    buildAddressVariantCalendarPayload(missionKey, hold) {
      const slot = hold.slot;
      const selectedOptions = this.buildSelectedOptionPairs();
      const extraQuestions = this.buildPayloadQuestionAnswers();
      const propertyType = this.usesVariantQuestionSelection
        ? this.getSelectedOptionValueByName(['type de bien', 'type du bien', 'type de votre bien', 'type du logement'])
        : this.addressState.propertyType;
      const surface = this.usesVariantQuestionSelection
        ? this.getSelectedOptionValueByName(['surface'])
        : this.addressState.surface;
      const constructionPeriod = this.usesVariantQuestionSelection
        ? this.getSelectedOptionValueByName(['annee de construction', 'construction', 'periode', 'period'])
        : '';
      const diagnosticsIncluded = this.getPackDiagnosticsIncluded();
      const payload = {
        ...this.buildBaseBookingPayload(missionKey, true),
        address: {
          addressLine: this.addressState.addressLine,
          postcode: this.addressState.postcode,
          city: this.addressState.city,
          department: this.addressState.department,
          country: 'France',
          ...(this.addressState.coordinates ? { coordinates: this.addressState.coordinates } : {})
        },
        propertyType,
        surface,
        constructionPeriod,
        prestationContext: this.getQuestionVisibleValue('prestationContext'),
        requiresAddress: true,
        requiresCalendar: true,
        appointmentMode: 'SLOT',
        appointment: {
          startsAt: slot.start,
          endsAt: slot.end,
          durationMinutes: Number(slot.duration),
          zone: slot.zone,
          timezone: slot.timezone,
          displayLabel: this.getCalendarSlotDisplayLabel(slot)
        },
        ...(selectedOptions.length ? { selectedOptions } : {}),
        ...(extraQuestions.length ? { extraQuestions } : {}),
        ...(this.isPackDiagnosticsFlow
          ? {
            ...(diagnosticsIncluded.length ? { diagnosticsIncluded } : {}),
            estimatedDurationLabel: PACK_ESTIMATED_DURATION_LABEL,
            estimatedDurationMinMinutes: PACK_ESTIMATED_DURATION_MIN_MINUTES,
            estimatedDurationMaxMinutes: PACK_ESTIMATED_DURATION_MAX_MINUTES
          }
          : {}),
        bookingHoldToken: hold.token,
        bookingHoldExpiresAt: hold.expiresAt,
        missionKey
      };
      return this.removeEmptyProperties(payload);
    }

    buildSelectedOptionPairs() {
      return this.getMeaningfulOptionNames()
        .map((name) => ({ name, value: this.selectedOptionValues[name] || '' }))
        .filter((item) => item.value);
    }

    getAllowedHoldLineItemProperties(hold) {
      const surchargeType = this.normalizeToken(hold?.surchargeType).slice(0, 100);
      return surchargeType ? { _surcharge_type: surchargeType } : {};
    }

    async addCartItem(properties, options = {}) {
      if (this.contextPending) throw new Error('Product context is not ready');
      const cartVariantId = String(options.variantId || this.selectedVariant?.id || '');
      if (!/^\d{1,32}$/.test(cartVariantId)) throw new Error('Invalid cart variant');
      if (this.isDiagnosticPrequalifiedCandidate) {
        const exactVariant = this.product?.variants?.find((variant) => String(variant.id) === cartVariantId && variant.available === true);
        if (!exactVariant || String(this.bookingHold?.finalOffer?.shopifyVariantId || '') !== cartVariantId) {
          throw new Error('Diagnostic cart variant is not hold-approved');
        }
      }
      const controller = new AbortController();
      this.cartController = controller;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(cartVariantId),
            quantity: 1,
            properties: this.removeEmptyProperties(properties)
          }]
        })
      });
      if (this.cartController === controller) this.cartController = null;
      if (this.destroyed) throw new DOMException('Instance destroyed.', 'AbortError');
      if (response.ok) {
        this.clearRetainedAddress();
        if (options.parseResponse === true) {
          try {
            await response.json();
          } catch (error) {
            // A successful Shopify response does not require a particular response-body shape.
          }
        }
        return response;
      }

      if (options.parseResponse !== true) throw new Error('Cart add failed');

      let shopifyMessage = '';
      try {
        const errorPayload = await response.json();
        const errorDescription = typeof errorPayload?.description === 'string'
          ? errorPayload.description
          : typeof errorPayload?.message === 'string'
            ? errorPayload.message
            : '';
        shopifyMessage = this.normalizeWhitespace(errorDescription).slice(0, 240);
      } catch (error) {
        shopifyMessage = '';
      }
      const cartError = new Error('Cart add failed');
      cartError.customerMessage = shopifyMessage
        ? `Impossible d’ajouter cette prestation au panier. ${shopifyMessage}`
        : 'Impossible d’ajouter cette prestation au panier. Veuillez réessayer.';
      throw cartError;
    }

    getCartFailureMessage(error) {
      return this.normalizeWhitespace(error?.customerMessage) || 'Impossible d’ajouter cette prestation au panier. Veuillez réessayer.';
    }

    removeEmptyProperties(properties) {
      return Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== '' && value !== null && value !== undefined));
    }

    createMissionKey() {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      return `mission-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    }

    replaceVariantInUrl(variantId, markFormulaSelected = false) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      if (markFormulaSelected) url.searchParams.set('formulaSelected', 'true');
      window.history.replaceState({}, '', url.toString());
    }

    getActiveSummaryRows() {
      if (this.usesDecisionSummary) return this.getDpeSummaryRows();
      if (this.usesCalendarSummary) return this.getAddressVariantCalendarSummaryRows();
      if (this.usesFinalFormulaSummary) return this.getFinalFormulaSummaryRows();
      return this.getInlineSummaryRows();
    }

    getFinalFormulaSummaryRows() {
      const rows = [];
      if (this.product?.title) {
        rows.push({ key: 'service', label: 'Prestation', value: this.product.title });
      }
      if (this.selectedVariant?.title) {
        rows.push({ key: 'formula', label: 'Formule', value: this.selectedVariant.title });
      }
      if (this.isAddressValid()) {
        const address = this.getCanonicalCustomerAddressLabel();
        if (address && address !== '-') {
          rows.push({ key: 'address', label: 'Adresse', value: address });
        }
      }
      const price = this.formatEuroCents(this.selectedVariant?.price);
      if (price) {
        rows.push({ key: 'price', label: 'Prix', value: price });
      }
      return rows;
    }

    getInlineSummaryRows() {
      const rows = [];
      if (this.selectedVariant) {
        rows.push({ key: 'formula', label: 'Formule', value: this.selectedVariant.title });
      }
      if (this.product) {
        rows.push({ key: 'service', label: 'Prestation', value: this.product.title });
      }
      if (this.selectedVariant?.price_formatted) {
        rows.push({ key: 'price', label: 'Prix', value: this.selectedVariant.price_formatted });
      }
      if (this.usesProjectAddressPresentation) {
        rows.push({
          key: 'address',
          label: 'Adresse',
          value: this.addressState.addressLine ? this.getAddressLabel() : 'À renseigner'
        });
      } else if (this.usesPropertyContextAddressPresentation && this.isAddressValid()) {
        rows.push({ key: 'address', label: 'Adresse', value: this.getAddressLabel() });
        rows.push({
          key: 'property',
          label: 'Bien',
          value: `${this.addressState.propertyType || '-'}${this.addressState.surface ? ` · ${this.addressState.surface} m²` : ''}`
        });
      }
      if (this.selectedSlot && this.usesPropertyContextAddressPresentation) {
        rows.push({ key: 'slot', label: 'Créneau', value: this.selectedSlot.label || '-' });
      }
      return rows;
    }

    renderSummary() {
      if (this.usesNoSummary) {
        this.nodes.summary.hidden = true;
        this.renderMobileSummary();
        return;
      }
      if (this.usesDecisionSummary) {
        this.nodes.summary.hidden = true;
        this.renderDpeSideSummary();
        this.renderMobileFormulaAction();
        return;
      }
      if (this.usesCalendarSummary) {
        this.nodes.summary.hidden = true;
        this.renderCalendarSideSummary();
        this.renderMobileFormulaAction();
        this.renderMobileSummary();
        return;
      }
      if (!this.isFinalStep) {
        this.nodes.summary.hidden = true;
        this.renderMobileSummary();
        return;
      }
      if (this.usesProjectAddressPresentation && !this.selectedVariant) {
        this.nodes.summary.hidden = true;
        this.renderMobileSummary();
        return;
      }
      const rows = this.getActiveSummaryRows();
      const rowByKey = rows.reduce((result, row) => {
        result[row.key] = row.value;
        return result;
      }, {});
      if (this.usesFinalFormulaSummary) this.orderFinalFormulaSummaryRows();
      this.nodes.summary.hidden = false;
      this.nodes.summaryFormula.closest('.nouvac-order-flow-v2__summary-row').hidden = !rowByKey.formula;
      this.nodes.summaryService.closest('.nouvac-order-flow-v2__summary-row').hidden = !rowByKey.service;
      this.nodes.summaryPrice.closest('.nouvac-order-flow-v2__summary-row').hidden = !rowByKey.price;
      this.nodes.summaryFormula.textContent = rowByKey.formula || '-';
      this.nodes.summaryService.textContent = rowByKey.service || '-';
      this.nodes.summaryPrice.textContent = rowByKey.price || '-';
      this.nodes.summaryAddressRow.hidden = !rowByKey.address;
      this.nodes.summaryPropertyRow.hidden = !rowByKey.property;
      this.nodes.summarySlotRow.hidden = !rowByKey.slot;
      if (this.nodes.summaryDpeRow) this.nodes.summaryDpeRow.hidden = true;
      this.nodes.summaryAddress.textContent = rowByKey.address || '-';
      this.nodes.summaryProperty.textContent = rowByKey.property || '-';
      this.nodes.summarySlot.textContent = rowByKey.slot || '-';
      this.renderQuestionSummaryRows();
      this.renderMobileSummary();
    }

    orderFinalFormulaSummaryRows() {
      const summaryList = this.nodes.summary?.querySelector('.nouvac-order-flow-v2__summary-list');
      if (!summaryList) return;
      [
        this.nodes.summaryPrice?.closest('.nouvac-order-flow-v2__summary-row'),
        this.nodes.summaryAddressRow,
        this.nodes.summaryFormula?.closest('.nouvac-order-flow-v2__summary-row'),
        this.nodes.summaryService?.closest('.nouvac-order-flow-v2__summary-row')
      ].forEach((row) => {
        if (row) summaryList.insertBefore(row, summaryList.firstChild);
      });
    }

    renderCalendarSideSummary() {
      if (!this.nodes.packSideSummary || !this.nodes.packSummaryRows) return;
      const eligible = Boolean(
        this.usesCalendarSummary &&
        this.currentStep === 'calendar' &&
        (this.isDiagnosticPrequalifiedReady || (this.isAddressValid() && this.validateDetailsStep(false)))
      );
      this.nodes.packSideSummary.hidden = !eligible;
      this.nodes.packSummaryRows.innerHTML = '';
      const diagnosticModel = eligible ? this.getDiagnosticTransactionalSummaryModel() : null;
      this.renderDiagnosticTransactionalSummary(diagnosticModel);
      this.nodes.packSummaryRows.hidden = Boolean(diagnosticModel);
      if (!eligible || diagnosticModel) return;
      this.getActiveSummaryRows().forEach((row) => {
        const item = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        item.className = 'nouvac-order-flow-v2__pack-summary-row';
        term.textContent = row.label;
        description.textContent = row.value;
        item.append(term, description);
        this.nodes.packSummaryRows.appendChild(item);
      });
    }

    getAddressVariantCalendarSummaryRows() {
      if (this.isDiagnosticPrequalifiedReady) {
        const model = this.getDiagnosticTransactionalSummaryModel();
        return [
          { key: 'service', label: 'Prestation', value: DIAGNOSTIC_PREQUALIFIED_SERVICE_LABEL },
          { key: 'price', label: 'Total TTC', value: model?.price || 'Sélectionnez un créneau pour afficher votre tarif' }
        ];
      }
      const rows = [];
      if (this.product?.title) {
        rows.push({ key: 'service', label: 'Prestation', value: this.product.title });
      }
      if (this.selectedVariant?.title) {
        rows.push({ key: 'formula', label: 'Formule', value: this.selectedVariant.title });
      }
      this.getVisibleQuestionAnswers().forEach((answer) => {
        if (!answer.label || !answer.valueLabel) return;
        rows.push({
          key: answer.key,
          label: answer.label,
          value: answer.valueLabel
        });
      });
      const diagnosticsIncludedLabel = this.getPackDiagnosticsIncludedLabel();
      if (diagnosticsIncludedLabel) {
        rows.push({ key: 'diagnosticsIncluded', label: PACK_DIAGNOSTICS_INCLUDED_LABEL, value: diagnosticsIncludedLabel });
      }
      if (this.addressState.addressLine || this.addressState.postcode || this.addressState.city) {
        const address = this.getAddressVariantCalendarCustomerAddressLabel();
        if (address && address !== '-') {
          rows.push({ key: 'address', label: 'Adresse', value: address });
        }
      }
      const price = this.formatEuroCents(this.selectedVariant?.price);
      if (price) {
        rows.push({ key: 'price', label: 'Prix', value: price });
      }
      if (this.selectedSlot?.start || this.selectedSlot?.label) {
        rows.push({ key: 'slot', label: 'Créneau choisi', value: this.getCalendarSlotDisplayLabel(this.selectedSlot) });
      }
      return rows;
    }

    renderQuestionSummaryRows() {
      if (!this.nodes.summaryQuestions) return;
      this.nodes.summaryQuestions.innerHTML = '';
      this.getVisibleQuestionAnswers().forEach((answer) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        row.className = 'nouvac-order-flow-v2__summary-row';
        term.textContent = answer.label;
        description.textContent = answer.valueLabel;
        row.append(term, description);
        this.nodes.summaryQuestions.appendChild(row);
      });
    }

    getDpeNumberSummaryLabel() {
      if (this.dpeNumberState.status === 'PROVIDED' && this.dpeNumberState.normalized) return this.dpeNumberState.normalized;
      if (this.dpeNumberState.status === 'DEFERRED') return DPE_NUMBER_DEFERRED_LABEL;
      if (this.dpeNumberState.status === 'MISSING') return 'DPE existant requis';
      return 'À renseigner';
    }

    normalizeDisplayText(value) {
      return this.normalizeWhitespace(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    displayTextIncludes(source, value) {
      const needle = this.normalizeDisplayText(value);
      if (!needle) return false;
      return this.normalizeDisplayText(source).includes(needle);
    }

    getCanonicalCustomerAddressLabel() {
      const addressLine = this.normalizeWhitespace(this.selectedAddress?.label || this.addressState.addressLine);
      const postcode = this.normalizeWhitespace(this.addressState.postcode);
      const city = this.normalizeWhitespace(this.addressState.city);
      if (!addressLine) return [postcode, city].filter(Boolean).join(' ') || '-';

      const localityParts = [];
      if (postcode && !this.displayTextIncludes(addressLine, postcode)) localityParts.push(postcode);
      if (city && !this.displayTextIncludes(addressLine, city)) localityParts.push(city);
      const locality = localityParts.join(' ');
      return locality ? `${addressLine}, ${locality}` : addressLine;
    }

    getDpeCustomerAddressLabel() {
      return this.getCanonicalCustomerAddressLabel();
    }

    getAddressVariantCalendarCustomerAddressLabel() {
      if (this.isDiagnosticPrequalifiedReady) return this.diagnosticSummary.address;
      return this.getCanonicalCustomerAddressLabel();
    }

    getCalendarSlotDisplayLabel(slot = this.selectedSlot) {
      const start = Date.parse(String(slot?.start || ''));
      if (Number.isFinite(start)) {
        try {
          return new Intl.DateTimeFormat('fr-FR', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
            timeZone: 'Europe/Paris'
          }).format(new Date(start));
        } catch (error) {
          // Fall back to the calendar-provided label if the browser cannot format the timestamp.
        }
      }
      return this.normalizeWhitespace(slot?.label) || 'Créneau sélectionné';
    }

    getDisplayPriceLabel(value) {
      const label = this.normalizeWhitespace(value);
      if (!label) return '-';
      if (/[€$£]/.test(label)) return label;
      if (/\bEUR\b/i.test(label)) return label.replace(/\bEUR\b/i, '€');
      return /\d/.test(label) ? `${label} €` : label;
    }

    formatEuroCents(cents, { useGrouping = false } = {}) {
      const amount = Number(cents);
      if (!Number.isFinite(amount)) return '';
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        useGrouping,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount / 100).replace(/\u00a0/g, ' ');
    }

    getAddressLabel() {
      return [this.addressState.addressLine, this.addressState.postcode, this.addressState.city].filter(Boolean).join(', ') || '-';
    }

    calculateActionState(actionName, stepName = this.currentStep) {
      const blockedByContext = this.contextPending;
      if (actionName === 'previous') {
        return {
          actionType: 'previous',
          label: stepName === 'address' && this.usesProjectAddressPresentation ? 'Modifier la formule' : 'Retour',
          visible: !this.isDiagnosticPrequalifiedCandidate && Boolean(this.getPreviousStep(stepName)),
          disabled: false,
          loading: false
        };
      }
      if (actionName === 'formula-next') {
        return {
          actionType: 'next',
          label: 'Suivant',
          visible: this.usesExplicitFormulaConfirmation && Boolean(this.getNextStep('formula')),
          disabled: blockedByContext || !this.validateStep('formula'),
          loading: false
        };
      }
      if (actionName === 'address-next') {
        const nextStep = this.getNextStep('address');
        return {
          actionType: 'next',
          label: this.coveragePending
            ? 'Vérification...'
            : this.coverageRetryRequired
              ? 'Réessayer'
              : this.usesCanonicalZoneAddress ? 'Voir les prix' : (nextStep === 'formula' ? 'Suivant' : 'Continuer'),
          visible: Boolean(nextStep),
          disabled: blockedByContext || this.coveragePending || !this.validateStep('address'),
          loading: this.coveragePending
        };
      }
      if (actionName === 'details-next') {
        return {
          actionType: 'next',
          label: this.usesVariantQuestionSelection ? 'Suivant' : 'Continuer',
          visible: this.hasStep('details'),
          disabled: blockedByContext || !this.validateStep('details'),
          loading: false
        };
      }
      if (actionName === 'mobile-next') {
        return {
          actionType: 'next',
          label: 'Suivant',
          visible: this.isMobileFormulaActionEligible(),
          disabled: blockedByContext || !this.isMobileFormulaActionReady(),
          loading: false
        };
      }
      if (actionName === 'payment' || actionName === 'mobile-payment') {
        const isMobilePayment = actionName === 'mobile-payment';
        const loading = this.coveragePending || this.cartPending || this.holdPending;
        const label = this.coveragePending
          ? 'Vérification...'
          : this.holdPending
          ? 'Réservation du créneau...'
          : this.cartPending
            ? 'Ajout au panier...'
            : this.coverageRetryRequired && this.requiresPublicCoverageCheck
              ? 'Réessayer'
              : this.isDiagnosticPrequalifiedCandidate && !isMobilePayment
                ? 'Continuer vers le paiement'
                : 'Passer au paiement';
        return {
          actionType: 'payment',
          label,
          visible: this.isFinalStep && !this.isDpeMissingBlocked() && (!this.isDiagnosticPrequalifiedCandidate || this.isDiagnosticPrequalifiedReady),
          disabled: blockedByContext || !this.canSubmitPayment(),
          loading
        };
      }
      return {
        actionType: 'unavailable',
        label: '',
        visible: false,
        disabled: true,
        loading: false
      };
    }

    applyActionState(button, state, { manageVisibility = true } = {}) {
      if (!button || !state) return;
      if (manageVisibility) button.hidden = !state.visible;
      button.disabled = state.disabled;
      button.textContent = state.label;
      button.setAttribute('aria-busy', state.loading ? 'true' : 'false');
      button.dataset.nouvacOrderFlowV2ActionType = state.actionType;
    }

    updateButtons() {
      this.applyActionState(this.nodes.backFormula, this.calculateActionState('previous', 'address'));
      this.applyActionState(this.nodes.backDetails, this.calculateActionState('previous', 'details'));
      this.applyActionState(this.nodes.backAddress, this.calculateActionState('previous', 'calendar'));
      this.applyActionState(this.nodes.backFormulaFromDpe, this.calculateActionState('previous', 'dpe-number'));
      this.applyActionState(this.nodes.nextAddress, this.calculateActionState('formula-next'));
      this.applyActionState(this.nodes.nextCalendar, this.calculateActionState('address-next'));
      this.applyActionState(this.nodes.nextDetails, this.calculateActionState('details-next'));
      this.applyActionState(this.nodes.mobileFormulaNext, this.calculateActionState('mobile-next'));
      const paymentState = this.calculateActionState('payment');
      this.applyActionState(this.nodes.payment, paymentState);
      this.applyActionState(this.nodes.mobilePayment, this.calculateActionState('mobile-payment'), { manageVisibility: false });
    }

    setPaymentEnabled(enabled) {
      [this.nodes.payment, this.nodes.mobilePayment].forEach((button) => {
        if (button) button.disabled = !enabled;
      });
    }

    restorePaymentButton() {
      this.updateButtons();
    }

    applyBackLink(productUrl) {
      if (this.nodes.back && productUrl) this.nodes.back.href = productUrl;
    }

    applyDiagnosticLandingReturnLinks() {
      if (this.nodes.diagnosticReturn) this.nodes.diagnosticReturn.href = this.diagnosticReturnPath;
      this.nodes.diagnosticModifyLinks?.forEach((link) => {
        link.href = this.diagnosticReturnPath;
      });
    }

    setInitializing(isInitializing) {
      this.root.dataset.nouvacOrderFlowV2Initializing = isInitializing ? 'true' : 'false';
    }

    setContextPending(isPending) {
      this.contextPending = Boolean(isPending);
      this.root.dataset.nouvacOrderFlowV2ContextPending = this.contextPending ? 'true' : 'false';
      if (this.contextPending) this.root.dataset.nouvacOrderFlowV2Ready = 'false';
    }

    showOnly(type, message, category = ERROR_CATEGORIES.INVALID_PRODUCT_CONFIG) {
      this.setContextPending(false);
      this.root.dataset.nouvacOrderFlowV2Ready = 'false';
      window.clearTimeout(this.addressDebounceTimer);
      if (this.addressController) this.addressController.abort();
      this.closeAddressSuggestions();
      this.hideAllMessages();
      this.nodes.loading.hidden = true;
      this.nodes.content.hidden = true;
      const node = this.nodes[type];
      if (node) {
        if (message) node.textContent = message;
        node.dataset.nouvacOrderFlowV2ErrorCategory = category;
        this.root.dataset.nouvacOrderFlowV2ErrorCategory = category;
        this.root.dataset.nouvacOrderFlowV2CurrentStep = this.currentStep;
        this.root.dataset.nouvacOrderFlowV2FlowType = this.route?.flowType || '';
        this.root.dataset.nouvacOrderFlowV2ProductHandle = this.product?.handle || this.route?.productHandle || '';
        this.root.dataset.nouvacOrderFlowV2RendererKey = this.renderer?.key || '';
        if (this.debugEnabled) {
          node.dataset.nouvacOrderFlowV2Diagnostic = [
            this.product?.handle || this.route?.productHandle || '',
            this.product?.metafields?.service_slug || '',
            this.route?.flowType || '',
            this.currentStep,
            category,
            this.renderer?.key || '',
            this.validationDiagnostic?.field || '',
            this.validationDiagnostic?.expected || '',
            this.validationDiagnostic?.actual || ''
          ].filter(Boolean).join('|');
        }
        node.hidden = false;
        window.requestAnimationFrame(() => {
          node.setAttribute('tabindex', '-1');
          node.focus({ preventScroll: false });
        });
      }
      if (this.nodes.retry) {
        this.nodes.retry.hidden = ![ERROR_CATEGORIES.PRODUCT_CONTEXT_FAILED, ERROR_CATEGORIES.OFFERS_RENDERER_MISSING, ERROR_CATEGORIES.CALENDAR_CONTEXT_FAILED].includes(category);
      }
      this.setPaymentEnabled(false);
      this.closeMobileSummary(false);
      if (this.nodes.mobileSummary) this.nodes.mobileSummary.hidden = true;
      if (this.nodes.mobileFormulaAction) {
        this.nodes.mobileFormulaAction.hidden = true;
        this.root.dataset.nouvacOrderFlowV2MobileFormulaAction = 'inactive';
      }
      this.setInitializing(false);
    }

    hideAllMessages() {
      ['configError', 'productError', 'variantError'].forEach((key) => {
        if (this.nodes[key]) this.nodes[key].hidden = true;
      });
      if (this.nodes.retry) this.nodes.retry.hidden = true;
    }

    showCartError(message, category = ERROR_CATEGORIES.CART_FAILED) {
      this.nodes.cartError.textContent = message;
      this.nodes.cartError.dataset.nouvacOrderFlowV2ErrorCategory = category;
      this.root.dataset.nouvacOrderFlowV2ErrorCategory = category;
      if (this.debugEnabled) {
        this.nodes.cartError.dataset.nouvacOrderFlowV2Diagnostic = [
          this.product?.handle || '',
          this.route?.flowType || '',
          this.currentStep,
          category,
          this.renderer?.key || ''
        ].filter(Boolean).join('|');
      }
      this.nodes.cartError.hidden = false;
      window.requestAnimationFrame(() => this.nodes.cartError.focus?.({ preventScroll: false }));
    }

    clearCartError() {
      this.nodes.cartError.textContent = '';
      this.nodes.cartError.hidden = true;
    }
  }

  const bootstrapOrderFlowV2 = () => {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach((root) => {
      if (root.dataset.nouvacOrderFlowV2Initialized === 'true') return;
      root.dataset.nouvacOrderFlowV2Initialized = 'true';
      new NouvacOrderFlowV2(root).init();
    });
    return roots.length > 0;
  };

  if (!bootstrapOrderFlowV2() && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapOrderFlowV2, { once: true });
  }
})();
